import * as i0 from '@angular/core';
import { Directive, HostBinding, ViewContainerRef, Component, ViewChild, Injectable, InjectionToken, Input, NgModule, EventEmitter, Output, HostListener, ContentChild, ChangeDetectionStrategy, ContentChildren, ViewChildren, IterableDiffers, ViewEncapsulation, EmbeddedViewRef, isDevMode, Attribute, Optional, Inject, TemplateRef } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Subject, BehaviorSubject, merge, of, combineLatest, Subscription, Observable, fromEvent } from 'rxjs';
import * as i1$1 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import * as i4 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { filter, takeUntil, startWith, map, distinctUntilChanged, take, debounceTime } from 'rxjs/operators';
import get from 'lodash/get';
import * as i1$2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { parse, format, getMonth, getYear, getISODay, startOfMonth, getDaysInMonth, isToday, isSameDay, isBefore, isAfter, subMonths, addMonths } from 'date-fns';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpEventType, HttpClientModule } from '@angular/common/http';

class AlertTitleDirective {
    constructor() {
        this.alertTitle = true;
    }
}
AlertTitleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AlertTitleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: AlertTitleDirective, selector: "[bis-alert-title]", host: { properties: { "class.alert__title": "this.alertTitle" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertTitleDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bis-alert-title]' }]
        }], propDecorators: { alertTitle: [{
                type: HostBinding,
                args: ['class.alert__title']
            }] } });
class AlertTextDirective {
    constructor() {
        this.alertText = true;
    }
}
AlertTextDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertTextDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AlertTextDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: AlertTextDirective, selector: "[bis-alert-text]", host: { properties: { "class.alert__text": "this.alertText" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertTextDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bis-alert-text]' }]
        }], propDecorators: { alertText: [{
                type: HostBinding,
                args: ['class.alert__text']
            }] } });

class AlertComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngOnInit() {
        if (this.config && this.config.duration) {
            this.attachTimer(this.config.duration);
        }
    }
    /**
     * Method that attaches a dinamic component to the ViewContainerRef
     * ViewChild is not triggered, when attach method is invoked,
     * and the this.viewContainerRef is undefined,
     * temporary solution is with setTimeout
     * @param component Component
     * @param injector AlertInjector
     */
    attach(component, injector) {
        setTimeout(() => {
            return this.attachToView(component, injector);
        }, 0);
    }
    /**
     * Method that attches a dinamic component to the ViewContainerRef
     * @param component Component
     * @param injector AlertInjector
     */
    attachToView(component, injector) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = this.viewContainerRef.createComponent(componentFactory, this.viewContainerRef.length, injector);
        this.viewContainerRef.insert(componentRef.hostView);
        return componentRef;
    }
    /**
     * Method that attaches a setTimeout to the component,
     * when the duration is reached it will call the destroy() method
     * @param duration number
     */
    attachTimer(duration) {
        this.timeout = setTimeout(() => this.destroy(), duration);
    }
    /**
     * Method that removes the component
    */
    destroy() {
        clearTimeout(this.timeout);
        this.config = null;
        // closeFn received on the component instance, passed from the service
        if (this.closeFn) {
            this.closeFn();
            this.closeFn = null;
        }
    }
}
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertComponent, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: AlertComponent, selector: "bis-alert", viewQueries: [{ propertyName: "viewContainerRef", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<div\n  class=\"alert-container\"\n  [class.alert-container--fixed]=\"config?.fixed\"\n  [ngClass]=\"config?.type ? 'alert-container--' + config?.type : '' \">\n    <div class=\"alert\">\n      <div class=\"alert__icon\" [ngClass]=\"config?.icon ? 'alert__icon--' + config?.icon : 'icon--info'\">\n      </div>\n      <div class=\"alert__body\">\n        <div bis-alert-title *ngIf=\"config?.title\"> {{ config.title }} </div>\n        <div bis-alert-text *ngIf=\"config?.text\">\n          {{ config.text }}\n          <a class=\"alert__link u-margin-left-medium\"\n            *ngIf=\"config?.link\"\n            href=\"{{ config?.link?.url }}\">\n              {{ config.link.text }}\n          </a>\n        </div>\n        <ng-template #container></ng-template>\n      </div>\n      <button\n        class=\"alert__close\"\n        aria-label=\"Close\"\n        *ngIf=\"config?.withClose\"\n        (click)=\"destroy()\">\n      </button>\n    </div>\n</div>\n", styles: [".alert-container{position:absolute}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: AlertTitleDirective, selector: "[bis-alert-title]" }, { kind: "directive", type: AlertTextDirective, selector: "[bis-alert-text]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-alert', template: "<div\n  class=\"alert-container\"\n  [class.alert-container--fixed]=\"config?.fixed\"\n  [ngClass]=\"config?.type ? 'alert-container--' + config?.type : '' \">\n    <div class=\"alert\">\n      <div class=\"alert__icon\" [ngClass]=\"config?.icon ? 'alert__icon--' + config?.icon : 'icon--info'\">\n      </div>\n      <div class=\"alert__body\">\n        <div bis-alert-title *ngIf=\"config?.title\"> {{ config.title }} </div>\n        <div bis-alert-text *ngIf=\"config?.text\">\n          {{ config.text }}\n          <a class=\"alert__link u-margin-left-medium\"\n            *ngIf=\"config?.link\"\n            href=\"{{ config?.link?.url }}\">\n              {{ config.link.text }}\n          </a>\n        </div>\n        <ng-template #container></ng-template>\n      </div>\n      <button\n        class=\"alert__close\"\n        aria-label=\"Close\"\n        *ngIf=\"config?.withClose\"\n        (click)=\"destroy()\">\n      </button>\n    </div>\n</div>\n", styles: [".alert-container{position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; }, propDecorators: { viewContainerRef: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef, static: true }]
            }] } });

class AlertInjector {
    constructor(_parentInjector, _customTokens) {
        this._parentInjector = _parentInjector;
        this._customTokens = _customTokens;
    }
    get(token, notFoundValue) {
        const value = this._customTokens.get(token);
        if (typeof value !== 'undefined') {
            return value;
        }
        return this._parentInjector.get(token, notFoundValue);
    }
}

class AlertRef {
    constructor(htmlElement, injector, appRef, componentFactoryResolver, ngZone) {
        this.htmlElement = htmlElement;
        this.injector = injector;
        this.appRef = appRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.ngZone = ngZone;
        this.disposeFn = null;
    }
    /**
     * Method that returns the alert html element
    */
    getAlertHTMLElement() {
        return this.alertHTMLElement;
    }
    /**
     * Method that attaches the AlertComponent to the app view
     * @param component AlertComponent
     */
    attach(component) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = componentFactory.create(this.injector, null, this.htmlElement);
        this.appRef.attachView(componentRef.hostView);
        this.disposeFn = () => {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        };
        this.alertHTMLElement = this.htmlElement;
        return componentRef;
    }
    /**
     * Method that handles the removal of the AlertComponent
    */
    detach() {
        this.detachAlert();
        if (this.disposeFn) {
            this.disposeFn();
            this.disposeFn = null;
        }
    }
    detachAlert() {
        const elementToDetach = this.alertHTMLElement;
        if (elementToDetach) {
            const detach = () => {
                if (elementToDetach && elementToDetach.parentNode) {
                    elementToDetach.parentNode.removeChild(elementToDetach);
                }
                this.alertHTMLElement = null;
            };
            this.ngZone.runOutsideAngular(() => {
                setTimeout(detach, 0);
            });
        }
    }
}

class AlertPlaceholder {
    constructor(applicationRef, injector, componentFactoryResolver, ngZone, rendererFactory) {
        this.applicationRef = applicationRef;
        this.injector = injector;
        this.componentFactoryResolver = componentFactoryResolver;
        this.ngZone = ngZone;
        this.rendererFactory = rendererFactory;
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    /**
     * Method that creates a new AlertRef
     * @param config AlertConfig
     */
    create(config) {
        this.alertPlaceholderElement = this.createAlertHTMLElementPlaceholder(config);
        return new AlertRef(this.alertPlaceholderElement, this.injector, this.applicationRef, this.componentFactoryResolver, this.ngZone);
    }
    /**
     * Method that returns the alert placeholder element
     */
    getAlertHTMLElementPlaceholder() {
        return this.alertPlaceholderElement;
    }
    /**
     * Method that creates alert placeholder in which the alert will be inserted
     */
    createAlertHTMLElementPlaceholder(config) {
        const alertPlaceholderElement = this.renderer.createElement('div');
        alertPlaceholderElement.className = 'alert__placeholder';
        alertPlaceholderElement.style.zIndex = '1030';
        if (config.fixed) {
            alertPlaceholderElement.style.position = 'fixed';
        }
        if (config.top) {
            alertPlaceholderElement.style.top = config.top;
        }
        if (config.left) {
            alertPlaceholderElement.style.left = config.left;
        }
        if (config.right) {
            alertPlaceholderElement.style.right = config.right;
        }
        if (config.bottom) {
            alertPlaceholderElement.style.bottom = config.bottom;
        }
        if (config.centered) {
            alertPlaceholderElement.style.display = 'flex';
            alertPlaceholderElement.style.justifyContent = 'center';
        }
        this.renderer.appendChild(document.body, alertPlaceholderElement);
        return alertPlaceholderElement;
    }
}
AlertPlaceholder.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertPlaceholder, deps: [{ token: i0.ApplicationRef }, { token: i0.Injector }, { token: i0.ComponentFactoryResolver }, { token: i0.NgZone }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
AlertPlaceholder.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertPlaceholder });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertPlaceholder, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ApplicationRef }, { type: i0.Injector }, { type: i0.ComponentFactoryResolver }, { type: i0.NgZone }, { type: i0.RendererFactory2 }]; } });

const ALERT_DATA = new InjectionToken('AlertData');
class AlertService {
    constructor(alertPlaceholder, injector) {
        this.alertPlaceholder = alertPlaceholder;
        this.injector = injector;
        this.defaultConfig = {
            icon: 'info',
            text: null,
            duration: null,
            type: null,
            link: null,
            fixed: false,
            top: '30px',
            right: '0',
            left: '0',
            bottom: null,
            centered: true,
            withClose: true,
            data: {},
        };
        this.alertComponent = null;
    }
    /**
     * Method that attaches the alert component to the DOM
     */
    create(config, component) {
        this.destroy();
        const close$ = new Subject();
        const finalConfig = Object.assign(Object.assign({}, this.defaultConfig), config);
        const alertContainerRef = this.alertPlaceholder.create(finalConfig);
        const alertComponent = this.attachAlertComponent(alertContainerRef, finalConfig, close$);
        this.alertComponent = alertComponent;
        this.attachContentForAlertComponent(alertContainerRef, alertComponent, component, finalConfig);
        return {
            onClose: close$
        };
    }
    /**
     * Method that detaches the component and destroys it in case it exists.
    */
    destroy() {
        if (this.alertComponent) {
            this.alertComponent.closeFn();
            this.alertComponent = null;
        }
    }
    /**
     * Attaches the AlertComponent to the view
     * @param alertRef AlertRef
     * @param config AlertConfig
     */
    attachAlertComponent(alertRef, config, close) {
        const alertComponentRef = alertRef.attach(AlertComponent);
        alertComponentRef.instance.config = config;
        alertComponentRef.instance.closeFn = () => {
            close.next();
            close.complete();
            alertRef.detach();
            this.alertComponent = null;
        };
        return alertComponentRef.instance;
    }
    /**
     * Method that attaches a child component inside the alert component
     * @param alertComponent AlertComponent
     * @param component Component
     * @param config AlertConfig
     */
    attachContentForAlertComponent(alertRef, alertComponent, component, config) {
        if (!component) {
            return;
        }
        const injector = this.createAlertInjector(alertRef, alertComponent, config.data);
        alertComponent.attach(component, injector);
    }
    /**
     * Creates a custom injector for the alert component in order to pass in data to the component
     * through the config object on the data property
     * @param component AlertComponent
     * @param data Object | Array
     */
    createAlertInjector(alertRef, component, data) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(AlertRef, alertRef);
        injectionTokens.set(AlertComponent, component);
        injectionTokens.set(ALERT_DATA, data);
        return new AlertInjector(this.injector, injectionTokens);
    }
}
AlertService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertService, deps: [{ token: AlertPlaceholder }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
AlertService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: AlertPlaceholder }, { type: i0.Injector }]; } });

const deprecationWarning = '@bisnode/components: Deprecation warning - InfoBarDirective is deprecated and will be removed in a future release. Please use the InlineAlertComponent';
class InfoBarDirective {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.type = 'info';
        this.alert = true;
        this.infoBar = true;
        console.warn(deprecationWarning);
    }
    ngOnInit() {
        this.renderer.addClass(this.elementRef.nativeElement, `alert-container--${this.type}`);
    }
}
InfoBarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: InfoBarDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
InfoBarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: InfoBarDirective, selector: "[bis-info-bar]", inputs: { type: "type" }, host: { properties: { "class.alert-container": "this.alert", "class.info-bar": "this.infoBar" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: InfoBarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bis-info-bar]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { type: [{
                type: Input
            }], alert: [{
                type: HostBinding,
                args: ['class.alert-container']
            }], infoBar: [{
                type: HostBinding,
                args: ['class.info-bar']
            }] } });

class InlineAlertComponent {
}
InlineAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: InlineAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InlineAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: InlineAlertComponent, selector: "bis-inline-alert", inputs: { type: "type" }, ngImport: i0, template: "<div\n  class=\"alert-container alert-container--inline\"\n  [ngClass]=\"type ? 'alert-container--' + type : '' \">\n    <div class=\"alert alert--inline\">\n      <div class=\"alert__icon\"\n        [ngClass]=\"type ? 'alert__icon--' + type : 'icon--info'\"></div>\n      <div class=\"alert__body\">\n        <div class=\"alert__text\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n</div>\n", styles: [":host{display:inline-block}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: InlineAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-inline-alert', template: "<div\n  class=\"alert-container alert-container--inline\"\n  [ngClass]=\"type ? 'alert-container--' + type : '' \">\n    <div class=\"alert alert--inline\">\n      <div class=\"alert__icon\"\n        [ngClass]=\"type ? 'alert__icon--' + type : 'icon--info'\"></div>\n      <div class=\"alert__body\">\n        <div class=\"alert__text\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n</div>\n", styles: [":host{display:inline-block}\n"] }]
        }], propDecorators: { type: [{
                type: Input
            }] } });

class AlertModule {
}
AlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: AlertModule, declarations: [AlertComponent,
        InfoBarDirective,
        InlineAlertComponent,
        AlertTitleDirective,
        AlertTextDirective], imports: [CommonModule], exports: [AlertComponent,
        InfoBarDirective,
        InlineAlertComponent,
        AlertTitleDirective,
        AlertTextDirective] });
AlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertModule, providers: [
        AlertService,
        AlertPlaceholder
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: AlertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        AlertComponent,
                        InfoBarDirective,
                        InlineAlertComponent,
                        AlertTitleDirective,
                        AlertTextDirective
                    ],
                    exports: [
                        AlertComponent,
                        InfoBarDirective,
                        InlineAlertComponent,
                        AlertTitleDirective,
                        AlertTextDirective
                    ],
                    providers: [
                        AlertService,
                        AlertPlaceholder
                    ]
                }]
        }] });

class BreadcrumbNavigationService {
    constructor(router, activatedRoute) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this._breadcrumbs$ = new BehaviorSubject([]);
        this.breadcrumbs$ = this._breadcrumbs$.asObservable();
    }
    register() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
            const breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root.firstChild);
            this._breadcrumbs$.next(breadcrumbs);
        });
    }
    createBreadcrumbs(route, url = '', breadcrumbs = []) {
        var _a, _b;
        const children = route.children;
        for (const child of children) {
            const urlSegments = child.snapshot.url;
            const lastUrlSegment = (_a = urlSegments[urlSegments.length - 1]) === null || _a === void 0 ? void 0 : _a.path;
            const routeURL = urlSegments
                .map((segment) => segment.path)
                .join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }
            if (lastUrlSegment) {
                const titleTranslationKey = (_b = child.snapshot.data['titleTranslationKey']) !== null && _b !== void 0 ? _b : null;
                const titleFallback = this.getTitleFromUrlSegment(lastUrlSegment);
                breadcrumbs.push({
                    titleTranslationKey,
                    titleFallback,
                    url,
                });
            }
            return this.createBreadcrumbs(child, url, breadcrumbs);
        }
        return breadcrumbs;
    }
    getTitleFromUrlSegment(urlSegment) {
        if (!urlSegment) {
            return urlSegment;
        }
        return urlSegment.split('-').map(this.toTitleCase).join(' ');
    }
    toTitleCase(word) {
        return [word[0].toUpperCase(), word.slice(1).toLowerCase()].join('');
    }
}
BreadcrumbNavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationService, deps: [{ token: i1$1.Router }, { token: i1$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
BreadcrumbNavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: i1$1.ActivatedRoute }]; } });

class BreadcrumbNavigationComponent {
    constructor(breadcrumbNavigationService) {
        this.breadcrumbNavigationService = breadcrumbNavigationService;
        this.breadcrumbs$ = this.breadcrumbNavigationService.breadcrumbs$;
    }
}
BreadcrumbNavigationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationComponent, deps: [{ token: BreadcrumbNavigationService }], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbNavigationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: BreadcrumbNavigationComponent, selector: "bis-breadcrumb-navigation", ngImport: i0, template: "<ol class=\"breadcrumb\">\n  <li\n    class=\"breadcrumb__item\"\n    [class.breadcrumb__item--current]=\"isLast\"\n    *ngFor=\"let breadcrumb of breadcrumbs$ | async; let isLast = last\"\n  >\n    <a [routerLink]=\"[breadcrumb.url]\">\n      <span *ngIf=\"breadcrumb.titleTranslationKey; else titleFallback\">\n        {{ breadcrumb.titleTranslationKey | translate }}\n      </span>\n      <ng-template #titleFallback>\n        <span>{{ breadcrumb.titleFallback }}</span>\n      </ng-template>\n    </a>\n  </li>\n</ol>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i4.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-breadcrumb-navigation', template: "<ol class=\"breadcrumb\">\n  <li\n    class=\"breadcrumb__item\"\n    [class.breadcrumb__item--current]=\"isLast\"\n    *ngFor=\"let breadcrumb of breadcrumbs$ | async; let isLast = last\"\n  >\n    <a [routerLink]=\"[breadcrumb.url]\">\n      <span *ngIf=\"breadcrumb.titleTranslationKey; else titleFallback\">\n        {{ breadcrumb.titleTranslationKey | translate }}\n      </span>\n      <ng-template #titleFallback>\n        <span>{{ breadcrumb.titleFallback }}</span>\n      </ng-template>\n    </a>\n  </li>\n</ol>\n" }]
        }], ctorParameters: function () { return [{ type: BreadcrumbNavigationService }]; } });

class BreadcrumbNavigationModule {
}
BreadcrumbNavigationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BreadcrumbNavigationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationModule, declarations: [BreadcrumbNavigationComponent], imports: [CommonModule, RouterModule, TranslateModule], exports: [BreadcrumbNavigationComponent] });
BreadcrumbNavigationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationModule, imports: [CommonModule, RouterModule, TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BreadcrumbNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, TranslateModule],
                    exports: [BreadcrumbNavigationComponent],
                    declarations: [BreadcrumbNavigationComponent],
                }]
        }] });

var PoinerEvents;
(function (PoinerEvents) {
    PoinerEvents["NONE"] = "none";
    PoinerEvents["UNSET"] = "unset";
})(PoinerEvents || (PoinerEvents = {}));
/**
 * Main button directive
 */
class ButtonDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._disabled = null;
        this.pointerEvents = PoinerEvents.UNSET;
        this.classBtn = true;
        this.tabindex = 0;
        this._addon = false;
        this._dropdown = false;
        this.buttonTypes = Object.keys(ButtonType).map(key => ButtonType[key]);
        this.type = 'primary';
        this.setPointerEvents();
    }
    set type(btnType) {
        if (!(this.buttonTypes.indexOf(btnType) > -1)) {
            return;
        }
        if (this._type !== btnType) {
            this.removeTypeClass(this._type);
            this._type = btnType;
            this.setTypeClass();
        }
    }
    get type() {
        return this._type;
    }
    set dropdown(value) {
        console.warn(`ButtonDirective: The [dropdown] input is deprecated and it will be removed in a future release.
    Please check the documentation for the new API:
    https://web.qa.aws.blue.bisnode.net/angular-components-d/?path=/story/bisnode-components-charts-chart-component--documentation`);
        this._dropdown = value;
    }
    get dropdown() {
        return this._dropdown;
    }
    set addon(value) {
        this._addon = value;
        this.setAddonClass(value);
    }
    get addon() {
        return this._addon;
    }
    set disabled(value) {
        this._disabled = value || value === '' ? true : null;
        this.setPointerEvents();
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Disabled or event.stopPropogation()/preventDefault() is not working for a-tags.
     * So we need to disable pointer-events for them.
     */
    setPointerEvents() {
        const tagname = this.elementRef.nativeElement.tagName;
        this.pointerEvents = this.disabled && tagname === 'A' ? PoinerEvents.NONE : PoinerEvents.UNSET;
    }
    setTypeClass() {
        if (this.type !== 'dropdown') {
            this.elementRef.nativeElement.classList.add(`btn--${this.type}`);
        }
        else {
            this.elementRef.nativeElement.classList.add('dropdown__btn');
        }
    }
    removeTypeClass(type) {
        if (!type) {
            return;
        }
        this.elementRef.nativeElement.classList.remove(`btn--${type}`);
    }
    setAddonClass(setClasses) {
        if (!setClasses) {
            return;
        }
        this.classBtn = false;
        this.elementRef.nativeElement.classList.remove('btn--primary');
        this.elementRef.nativeElement.classList.add('form-addon__btn');
    }
}
ButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ButtonDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: ButtonDirective, selector: "button[bis-btn], a[bis-btn], input[bis-btn]", inputs: { type: ["btn-type", "type"], dropdown: "dropdown", addon: "addon", disabled: "disabled" }, host: { properties: { "class.disabled": "this._disabled", "attr.disabled": "this._disabled", "style.pointer-events": "this.pointerEvents", "class.btn": "this.classBtn", "attr.tabindex": "this.tabindex" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[bis-btn], a[bis-btn], input[bis-btn]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { _disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: HostBinding,
                args: ['attr.disabled']
            }], pointerEvents: [{
                type: HostBinding,
                args: ['style.pointer-events']
            }], classBtn: [{
                type: HostBinding,
                args: ['class.btn']
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], type: [{
                type: Input,
                args: ['btn-type']
            }], dropdown: [{
                type: Input
            }], addon: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });
var ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "primary";
    ButtonType["SECONDARY"] = "secondary";
    ButtonType["LINK"] = "link";
    ButtonType["ADDON"] = "addon";
    ButtonType["DROPDOWN"] = "dropdown";
    ButtonType["TINY"] = "tiny";
})(ButtonType || (ButtonType = {}));

class ExpandableButtonComponent {
    constructor() {
        this.btnClass = true;
        this.btnShowMore = true;
        this.roleAttribute = 'button';
        this.withIcons = true;
        this.expanded = false;
        this.onClick$ = new EventEmitter();
    }
    hostClickHandler() {
        this.expanded = !this.expanded;
        this.onClick$.next(undefined);
    }
}
ExpandableButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpandableButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ExpandableButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ExpandableButtonComponent, selector: "bis-expandable-button", inputs: { withIcons: "withIcons", expanded: "expanded" }, outputs: { onClick$: "onClick$" }, host: { listeners: { "click": "hostClickHandler()" }, properties: { "class.btn": "this.btnClass", "class.btn--expandable": "this.btnShowMore", "attr.role": "this.roleAttribute" } }, ngImport: i0, template: `
    <ng-content *ngIf="expanded" select="[expanded-content]"></ng-content>
    <ng-content *ngIf="!expanded" select="[collapsed-content]"></ng-content>

    <i *ngIf="expanded && withIcons" class="icon icon--angle-up btn__icon btn__icon--right"></i>
    <i *ngIf="!expanded && withIcons" class="icon icon--angle-down btn__icon btn__icon--right"></i>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpandableButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-expandable-button',
                    template: `
    <ng-content *ngIf="expanded" select="[expanded-content]"></ng-content>
    <ng-content *ngIf="!expanded" select="[collapsed-content]"></ng-content>

    <i *ngIf="expanded && withIcons" class="icon icon--angle-up btn__icon btn__icon--right"></i>
    <i *ngIf="!expanded && withIcons" class="icon icon--angle-down btn__icon btn__icon--right"></i>
  `
                }]
        }], propDecorators: { btnClass: [{
                type: HostBinding,
                args: ['class.btn']
            }], btnShowMore: [{
                type: HostBinding,
                args: ['class.btn--expandable']
            }], roleAttribute: [{
                type: HostBinding,
                args: ['attr.role']
            }], withIcons: [{
                type: Input
            }], expanded: [{
                type: Input
            }], onClick$: [{
                type: Output
            }], hostClickHandler: [{
                type: HostListener,
                args: ['click']
            }] } });

class ButtonModule {
}
ButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ButtonModule, declarations: [ButtonDirective,
        ExpandableButtonComponent], imports: [CommonModule], exports: [ButtonDirective,
        ExpandableButtonComponent] });
ButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ButtonModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ButtonDirective,
                        ExpandableButtonComponent
                    ],
                    exports: [
                        ButtonDirective,
                        ExpandableButtonComponent
                    ]
                }]
        }] });

class CardLinkDirective {
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
    }
    ngOnInit() {
        this.addClasses();
    }
    /**
     * Method used to add certain properties to the classes object if criterias are met
     */
    addClasses() {
        this.renderer.addClass(this.elRef.nativeElement, 'card__link');
        if (this.position) {
            this.renderer.addClass(this.elRef.nativeElement, `card__link--${this.position}`);
        }
    }
}
CardLinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardLinkDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
CardLinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CardLinkDirective, selector: "[bis-card-link]", inputs: { position: "position" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bis-card-link]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { position: [{
                type: Input
            }] } });
class CardHeaderComponent {
    constructor() {
        this.cardHeader = true;
        this.noPadding = false;
        this.hostName = true;
    }
}
CardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardHeaderComponent, selector: "bis-card-header", inputs: { noPadding: "noPadding" }, host: { properties: { "class.card__header": "this.cardHeader", "class.u-padding-none": "this.noPadding", "class.bis-host-card-header": "this.hostName" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card-header',
                    template: `
    <ng-content></ng-content>
  `,
                    preserveWhitespaces: false
                }]
        }], propDecorators: { cardHeader: [{
                type: HostBinding,
                args: ['class.card__header']
            }], noPadding: [{
                type: HostBinding,
                args: ['class.u-padding-none']
            }, {
                type: Input
            }], hostName: [{
                type: HostBinding,
                args: ['class.bis-host-card-header']
            }] } });
class CardSectionComponent {
    /**
     * This element ref is used by the tab component in order to render data into it
     * @param element
     */
    constructor(element) {
        this.element = element;
        this.scrollable = false;
        this.section = true;
    }
}
CardSectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardSectionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CardSectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardSectionComponent, selector: "bis-card-section", inputs: { scrollable: "scrollable" }, host: { properties: { "class.card__section--scrollable": "this.scrollable", "class.card__section": "this.section" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card-section',
                    template: `
    <ng-content></ng-content>
  `,
                    preserveWhitespaces: false
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { scrollable: [{
                type: HostBinding,
                args: ['class.card__section--scrollable']
            }, {
                type: Input
            }], section: [{
                type: HostBinding,
                args: ['class.card__section']
            }] } });
class CardFooterComponent {
    ngOnInit() {
        this.addClasses();
    }
    addClasses() {
        this.classesString = `${this.class ? this.class : ''} card__footer`;
    }
}
CardFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardFooterComponent, selector: "bis-card-footer", inputs: { class: "class" }, host: { properties: { "class": "this.classesString" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card-footer',
                    template: `
    <ng-content></ng-content>
  `,
                    preserveWhitespaces: false
                }]
        }], propDecorators: { class: [{
                type: Input
            }], classesString: [{
                type: HostBinding,
                args: ['class']
            }] } });
class CardButtonsContainerComponent {
    constructor() {
        this.btnContainerClass = true;
    }
}
CardButtonsContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardButtonsContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardButtonsContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardButtonsContainerComponent, selector: "bis-card-buttons-container", host: { properties: { "class.card__btn-container": "this.btnContainerClass" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardButtonsContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card-buttons-container',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], propDecorators: { btnContainerClass: [{
                type: HostBinding,
                args: ['class.card__btn-container']
            }] } });
class CardExpandableContentDirective {
}
CardExpandableContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardExpandableContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CardExpandableContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CardExpandableContentDirective, selector: "[bis-card-expandable-content]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardExpandableContentDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bis-card-expandable-content]' }]
        }] });
/**
 * Abstract class used to create CardComponents
*/
class CardComponentBase {
    constructor(container, renderer) {
        this.container = container;
        this.renderer = renderer;
        this.link = false;
        this.squared = false;
        this.small = false;
        this.card = true;
        /**
         * Stores the expanded/collapsed state of the card
         */
        this.expanded = false;
        this._cardButtonExpandableComponent = null;
        this.classes = {};
        this.destroySubscription$ = new EventEmitter();
    }
    /**
     * Sets the expanded state programatically if the user provides an input
     * Promise.resolve is used so that the @ContendChild setupExpandableButton call won't override this one
     * Promise.resolve ensures that the code will be executed after the first change detection (after @ContentChild has been called)
     */
    set contentExpanded(expanded) {
        this.expanded = expanded;
        Promise.resolve()
            .then(() => this.setupExpandableButton(this.cardButtonExpandableComponent));
    }
    /**
     * Grabs the CardButtonExpandableComponent from the template if exists
     */
    set cardButtonExpandableComponent(component) {
        if (!component) {
            return;
        }
        this.setupExpandableButton(component);
        this._cardButtonExpandableComponent = component;
    }
    get cardButtonExpandableComponent() {
        return this._cardButtonExpandableComponent;
    }
    ngOnInit() {
        this.addClasses();
    }
    /**
     * Method that adds certain classes to the host element based on inputs
     */
    addClasses() {
        if (this.link) {
            this.classes['card--link'] = true;
            this.renderer.addClass(this.container.nativeElement, 'card--link');
        }
        if (this.maxWidth) {
            this.renderer.setStyle(this.container.nativeElement, 'max-width', this.maxWidth);
        }
        if (this.maxHeight) {
            this.renderer.setStyle(this.container.nativeElement, 'max-height', this.maxHeight);
        }
        if (this.flex) {
            this.renderer.setStyle(this.container.nativeElement, 'flex', this.flex);
        }
        if (this.itemGrow) {
            this.renderer.setStyle(this.container.nativeElement, 'flex-grow', this.itemGrow);
        }
    }
    setupExpandableButton(component) {
        if (!component) {
            return;
        }
        component.expanded = this.expanded;
        this.registerExpandableButtonClicks(component);
    }
    registerExpandableButtonClicks(component) {
        // clears active subscriptions if any in case the ContendChild has changed so that we don't have multiple subscriptions in memory
        this.destroySubscription$.next(true);
        component.onClick$
            .pipe(takeUntil(this.destroySubscription$))
            .subscribe(() => {
            this.expanded = !this.expanded;
            component.expanded = this.expanded;
        });
    }
    ngOnDestroy() {
        this.destroySubscription$.next(true);
    }
}
CardComponentBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardComponentBase, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
CardComponentBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CardComponentBase, inputs: { maxWidth: ["max-width", "maxWidth"], maxHeight: ["max-height", "maxHeight"], itemGrow: ["item-grow", "itemGrow"], flex: "flex", link: "link", squared: "squared", small: "small" }, host: { properties: { "class.card--squared": "this.squared", "class.card--small": "this.small", "class.card": "this.card" } }, queries: [{ propertyName: "cardExpandableContentDirective", first: true, predicate: CardExpandableContentDirective, descendants: true }, { propertyName: "cardButtonExpandableComponent", first: true, predicate: ExpandableButtonComponent, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardComponentBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { maxWidth: [{
                type: Input,
                args: ['max-width']
            }], maxHeight: [{
                type: Input,
                args: ['max-height']
            }], itemGrow: [{
                type: Input,
                args: ['item-grow']
            }], flex: [{
                type: Input
            }], link: [{
                type: Input
            }], squared: [{
                type: HostBinding,
                args: ['class.card--squared']
            }, {
                type: Input
            }], small: [{
                type: HostBinding,
                args: ['class.card--small']
            }, {
                type: Input
            }], card: [{
                type: HostBinding,
                args: ['class.card']
            }], cardExpandableContentDirective: [{
                type: ContentChild,
                args: [CardExpandableContentDirective, { static: false }]
            }], cardButtonExpandableComponent: [{
                type: ContentChild,
                args: [ExpandableButtonComponent, { static: false }]
            }] } });
/**
 * <div bis-card [large]="true">
 *     <bis-card-header></bis-card-header>
 *     <bis-card-section color="primary"></bis-card-section>
 *     <bis-card-link></bis-card-link>
 *     <bis-card-footer></bis-card-footer>
 * </div>
 */
class CardDirective extends CardComponentBase {
    constructor(container, renderer) {
        super(container, renderer);
        this.container = container;
        this.renderer = renderer;
    }
    get contentExpanded() {
        return this.cardContentExpanded;
    }
    set contentExpanded(value) {
        this.cardContentExpanded = value;
    }
}
CardDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
CardDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CardDirective, selector: "[bis-card]", inputs: { contentExpanded: "contentExpanded" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bis-card]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { contentExpanded: [{
                type: Input
            }] } });
/**
 * <bis-card [large]="true">
 *     <bis-card-header></bis-card-header>
 *     <bis-card-section color="primary"></bis-card-section>
 *     <bis-card-link></bis-card-link>
 *     <bis-card-footer></bis-card-footer>
 * </bis-card>
 */
class CardComponent extends CardComponentBase {
    constructor(container, renderer) {
        super(container, renderer);
        this.container = container;
        this.renderer = renderer;
    }
    get contentExpanded() {
        return this._contentExpanded;
    }
    set contentExpanded(value) {
        this._contentExpanded = value;
    }
}
CardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
CardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardComponent, selector: "bis-card", inputs: { contentExpanded: "contentExpanded" }, usesInheritance: true, ngImport: i0, template: `
    <ng-template #portal>
      <ng-content select=[bis-card-expandable-content]></ng-content>
    </ng-template>

    <ng-content></ng-content>
    <ng-container *ngIf="expanded" [ngTemplateOutlet]="portal"></ng-container>
    <ng-content select="[bis-content-below-expansion]"></ng-content>
    <ng-content select="bis-expandable-button"></ng-content>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card',
                    template: `
    <ng-template #portal>
      <ng-content select=[bis-card-expandable-content]></ng-content>
    </ng-template>

    <ng-content></ng-content>
    <ng-container *ngIf="expanded" [ngTemplateOutlet]="portal"></ng-container>
    <ng-content select="[bis-content-below-expansion]"></ng-content>
    <ng-content select="bis-expandable-button"></ng-content>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { contentExpanded: [{
                type: Input
            }] } });
class CardGroupWrapperComponent {
    constructor(renderer, elRef) {
        this.renderer = renderer;
        this.elRef = elRef;
        this.cardGroupItem = true;
        this.displayFlex = true;
        this.flexColumn = true;
        console.warn(`<bis-card-group-wrapper> is deprecated and will be removed in a future release!
      Please use the bis-card-group-wrapper as a directive instead <div bis-card-group-wrapper></div> `);
    }
    ngOnInit() {
        this.addClassesToCardGroupWrapper();
    }
    /**
     * Method used to add classes to the elemenent ref, in order to style the wrapper element
     */
    addClassesToCardGroupWrapper() {
        if (this.itemGrow) {
            this.renderer.addClass(this.elRef.nativeElement, `card-group__item--grow-${this.itemGrow}`);
        }
    }
}
CardGroupWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardGroupWrapperComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CardGroupWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardGroupWrapperComponent, selector: "bis-card-group-wrapper", inputs: { itemGrow: ["item-grow", "itemGrow"] }, host: { properties: { "class.card-group__item": "this.cardGroupItem", "class.u-display-flex": "this.displayFlex", "class.u-flex-column": "this.flexColumn" } }, queries: [{ propertyName: "cards", predicate: CardDirective }], viewQueries: [{ propertyName: "wrapperElRef", first: true, predicate: ["wrapper"], descendants: true }], ngImport: i0, template: `
    <ng-content #wrapper></ng-content>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardGroupWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card-group-wrapper',
                    template: `
    <ng-content #wrapper></ng-content>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { cardGroupItem: [{
                type: HostBinding,
                args: ['class.card-group__item']
            }], displayFlex: [{
                type: HostBinding,
                args: ['class.u-display-flex']
            }], flexColumn: [{
                type: HostBinding,
                args: ['class.u-flex-column']
            }], itemGrow: [{
                type: Input,
                args: ['item-grow']
            }], wrapperElRef: [{
                type: ViewChild,
                args: ['wrapper', { static: false }]
            }], cards: [{
                type: ContentChildren,
                args: [CardDirective]
            }] } });
class CardGroupComponent {
    constructor(renderer, elRef) {
        this.renderer = renderer;
        this.elRef = elRef;
        this.tight = false;
        this.cardGroup = true;
        this.classes = {};
        this.ngOnDestroy$ = new EventEmitter();
    }
    ngOnInit() {
        this.addCollapsableClass();
    }
    ngOnChanges() {
        this.addCollapsableClass();
    }
    ngAfterViewInit() {
        this.addClassesToChildComponents(this.cardComponents, this.cardDirectives);
    }
    addClassesToChildComponents(components, directives) {
        this.attachClassToComponents(components);
        this.attachClassToComponents(directives);
    }
    attachClassToComponents(components) {
        components.forEach((card) => {
            this.renderer.addClass(card.container.nativeElement, 'card-group__item');
            if (card.itemGrow) {
                this.renderer.addClass(card.container.nativeElement, `card-group__item--grow-${card.itemGrow}`);
            }
        });
    }
    /**
     * Method that adds classes based on input to the classes object and the classes are set on the container element based on that object
     */
    addCollapsableClass() {
        if (this.collapsePoint) {
            this.classes[`card-group--${this.collapsePoint}-collapse`] = true;
            this.renderer.addClass(this.elRef.nativeElement, `card-group--${this.collapsePoint}-collapse`);
        }
    }
    ngOnDestroy() {
        this.ngOnDestroy$.emit(true);
    }
}
CardGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardGroupComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CardGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CardGroupComponent, selector: "bis-card-group", inputs: { collapsePoint: ["collapse-point", "collapsePoint"], tight: "tight" }, host: { properties: { "class.card-group--tight": "this.tight", "class.card-group": "this.cardGroup" } }, queries: [{ propertyName: "cardDirectives", predicate: CardDirective, descendants: true }, { propertyName: "cardComponents", predicate: CardComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-card-group',
                    template: `
    <ng-content></ng-content>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { collapsePoint: [{
                type: Input,
                args: ['collapse-point']
            }], tight: [{
                type: HostBinding,
                args: ['class.card-group--tight']
            }, {
                type: Input
            }], cardGroup: [{
                type: HostBinding,
                args: ['class.card-group']
            }], cardDirectives: [{
                type: ContentChildren,
                args: [CardDirective, { descendants: true }]
            }], cardComponents: [{
                type: ContentChildren,
                args: [CardComponent, { descendants: true }]
            }] } });

class CardModule {
}
CardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: CardModule, declarations: [CardDirective,
        CardHeaderComponent,
        CardSectionComponent,
        CardFooterComponent,
        CardGroupComponent,
        CardLinkDirective,
        CardGroupWrapperComponent,
        CardComponent,
        CardExpandableContentDirective,
        CardButtonsContainerComponent], imports: [CommonModule], exports: [CardDirective,
        CardHeaderComponent,
        CardSectionComponent,
        CardFooterComponent,
        CardGroupComponent,
        CardLinkDirective,
        CardGroupWrapperComponent,
        CardComponent,
        CardExpandableContentDirective,
        CardButtonsContainerComponent] });
CardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        CardDirective,
                        CardHeaderComponent,
                        CardSectionComponent,
                        CardFooterComponent,
                        CardGroupComponent,
                        CardLinkDirective,
                        CardGroupWrapperComponent,
                        CardComponent,
                        CardExpandableContentDirective,
                        CardButtonsContainerComponent
                    ],
                    exports: [
                        CardDirective,
                        CardHeaderComponent,
                        CardSectionComponent,
                        CardFooterComponent,
                        CardGroupComponent,
                        CardLinkDirective,
                        CardGroupWrapperComponent,
                        CardComponent,
                        CardExpandableContentDirective,
                        CardButtonsContainerComponent
                    ]
                }]
        }] });

class CarouselConfig {
    constructor(config) {
        config = config || {};
        this.activeComponentIndex = config.startAt || 0;
        this.hasBackdrop = (typeof config.hasBackdrop === 'undefined') ? true : config.hasBackdrop;
        this.noScroll = config.noScroll || false;
        this.withFirstPage = config.withFirstPage || false;
        this.withLastPage = config.withLastPage || false;
    }
}

class CarouselRef {
    constructor(placeholderElement, componentFactoryResolver, appRef, ngZone, injector) {
        this.placeholderElement = placeholderElement;
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.ngZone = ngZone;
        this.injector = injector;
        this.disposeFunction = null;
        this.getCarouselPlaceholder = () => {
            return this.placeholder;
        };
        this.attach = (component) => {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
            const carouselRef = componentFactory.create(this.injector, null, this.placeholderElement);
            this.appRef.attachView(carouselRef.hostView);
            this.disposeFunction = () => {
                this.appRef.detachView(carouselRef.hostView);
                carouselRef.destroy();
            };
            this.placeholder = this.placeholderElement;
            return carouselRef;
        };
        this.detach = () => {
            this.detachPlaceholder();
            if (this.disposeFunction) {
                this.disposeFunction();
                this.disposeFunction = null;
            }
        };
        this.detachPlaceholder = () => {
            const elementToDetach = this.placeholder;
            if (elementToDetach) {
                const detach = () => {
                    if (elementToDetach && elementToDetach.parentNode) {
                        elementToDetach.parentNode.removeChild(elementToDetach);
                    }
                    this.placeholder = null;
                };
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(detach, 0);
                });
            }
        };
    }
}

class CarouselPlaceholderService {
    constructor(componentFactoryResolver, appRef, rendererFactory, ngZone, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.rendererFactory = rendererFactory;
        this.ngZone = ngZone;
        this.injector = injector;
        this.create = () => {
            this.carouselPlaceholderElement = this.createPlaceholder();
            this.appendChild(this.carouselPlaceholderElement);
            return new CarouselRef(this.carouselPlaceholderElement, this.componentFactoryResolver, this.appRef, this.ngZone, this.injector);
        };
        this.createPlaceholder = () => {
            return this.renderer.createElement('div');
        };
        this.appendChild = (htmlPlaceholderElement) => {
            this.renderer.appendChild(document.body, htmlPlaceholderElement);
        };
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
}
CarouselPlaceholderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselPlaceholderService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.RendererFactory2 }, { token: i0.NgZone }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
CarouselPlaceholderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselPlaceholderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselPlaceholderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.RendererFactory2 }, { type: i0.NgZone }, { type: i0.Injector }]; } });

class CarouselDotComponent {
    constructor() {
        this.index = null;
        this.active = false;
        this.onClick = new EventEmitter();
    }
}
CarouselDotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselDotComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CarouselDotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CarouselDotComponent, selector: "bis-carousel-dot", inputs: { index: "index", active: "active" }, outputs: { onClick: "onClick" }, ngImport: i0, template: `
    <a (click)="onClick.emit(index)">
      <span class="dot" [class.dot--active]="active"></span>
    </a>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselDotComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-carousel-dot',
                    template: `
    <a (click)="onClick.emit(index)">
      <span class="dot" [class.dot--active]="active"></span>
    </a>
  `
                }]
        }], propDecorators: { index: [{
                type: Input
            }], active: [{
                type: Input
            }], onClick: [{
                type: Output
            }] } });
class CarouselDotPlaceholderComponent {
    constructor() {
        this.activeIndex = null;
        this.indexChange$ = new EventEmitter();
        this.ngOnDestroy$ = new EventEmitter();
        this.listenToDotClicks = (dots) => {
            dots.map((dot) => {
                dot.onClick
                    .pipe(takeUntil(this.ngOnDestroy$))
                    .subscribe(this.indexChangeHandler);
            });
        };
        this.indexChangeHandler = (index) => {
            this.indexChange$.emit(index);
        };
    }
    ngAfterViewInit() {
        this.listenToDotClicks(this.dotComponentRef);
    }
    hideFirst(index) {
        return this.config.withFirstPage && index === 0;
    }
    hideLast(index) {
        return this.config.withLastPage && index === this.components.length - 1;
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
CarouselDotPlaceholderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselDotPlaceholderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CarouselDotPlaceholderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CarouselDotPlaceholderComponent, selector: "bis-carousel-dot-placeholder", inputs: { components: "components", config: "config", activeIndex: "activeIndex" }, outputs: { indexChange$: "indexChange$" }, viewQueries: [{ propertyName: "dotComponentRef", predicate: CarouselDotComponent, descendants: true }], ngImport: i0, template: `
    <div class="carousel__indicator u-margin-none">
      <ng-container *ngFor="let cmp of components; let i = index">
        <bis-carousel-dot *ngIf="!hideFirst(i) && !hideLast(i)" [index]="i" [active]="activeIndex === i"></bis-carousel-dot>
      </ng-container>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CarouselDotComponent, selector: "bis-carousel-dot", inputs: ["index", "active"], outputs: ["onClick"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselDotPlaceholderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-carousel-dot-placeholder',
                    template: `
    <div class="carousel__indicator u-margin-none">
      <ng-container *ngFor="let cmp of components; let i = index">
        <bis-carousel-dot *ngIf="!hideFirst(i) && !hideLast(i)" [index]="i" [active]="activeIndex === i"></bis-carousel-dot>
      </ng-container>
    </div>
  `
                }]
        }], propDecorators: { components: [{
                type: Input
            }], config: [{
                type: Input
            }], activeIndex: [{
                type: Input
            }], indexChange$: [{
                type: Output
            }], dotComponentRef: [{
                type: ViewChildren,
                args: [CarouselDotComponent]
            }] } });

class CarouselComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.detach = null;
        this.config = null;
        this.components = null;
        this.navigate$ = null;
        this.showNavigation = true;
        this.showLeftNavigation = true;
        this.showRightNavigation = true;
        /**
         * Stores the reference to the active injected component
         */
        this.activeComponentRef = null;
        this.ngOnDestroy$ = new EventEmitter();
        this.attach = (component) => {
            if (!component) {
                throw new Error(`You provided: ${typeof component} where a Component was expected`);
            }
            this.destroy(this.activeComponentRef);
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
            return this.viewContainerRef.createComponent(componentFactory);
        };
        this.setActiveCmpIndex = (index) => {
            if (index >= 0 && index < this.components.length) {
                this.config.activeComponentIndex = index;
            }
        };
        this.getActiveCmpIndex = () => {
            return this.config.activeComponentIndex;
        };
        this.listenToNavigationChanges = () => {
            this.navigate$
                .pipe(takeUntil(this.ngOnDestroy$))
                .subscribe(this.indexChangeEventHandler);
        };
        this.onArrowClickHandler = (direction) => {
            if (direction === 'left') {
                this.setActiveCmpIndex(this.getActiveCmpIndex() - 1);
                this.switchComponent(this.getActiveCmpIndex());
            }
            else {
                this.setActiveCmpIndex(this.getActiveCmpIndex() + 1);
                this.switchComponent(this.getActiveCmpIndex());
            }
        };
        this.switchComponent = (index) => {
            this.destroy(this.activeComponentRef);
            this.activeComponentRef = this.attach(this.components[index]);
            this.viewCarouselContainerRef.nativeElement.focus();
            this.handleNavigationIcons(this.activeComponentRef);
        };
        this.indexChangeEventHandler = (index) => {
            this.setActiveCmpIndex(index);
            this.switchComponent(this.getActiveCmpIndex());
        };
        this.destroy = (componentRef) => {
            if (componentRef) {
                this.activeComponentRef.destroy();
            }
        };
    }
    ngOnInit() {
        this.activeComponentRef = this.attach(this.components[this.getActiveCmpIndex()]);
        this.handleNavigationIcons(this.activeComponentRef);
        this.listenToNavigationChanges();
    }
    ngAfterViewInit() {
        this.viewCarouselContainerRef.nativeElement.focus();
    }
    /**
     * Hides navigation elements based on certain properties being set on the active injected component like
     * hideNavigation, hideLeftNavigation, hideRightNavigation
     * @param componentRef
     */
    handleNavigationIcons(componentRef) {
        this.showNavigation = !componentRef.instance.hideNavigation;
        this.showLeftNavigation = !componentRef.instance.hideLeftNavigation;
        this.showRightNavigation = !componentRef.instance.hideRightNavigation;
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
CarouselComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselComponent, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
CarouselComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CarouselComponent, selector: "bis-carousel", viewQueries: [{ propertyName: "viewContainerRef", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }, { propertyName: "viewCarouselContainerRef", first: true, predicate: ["carouselContainer"], descendants: true }], ngImport: i0, template: "<div class=\"carousel-backdrop carousel-backdrop--open\" tabindex=\"0\" #carouselContainer (keyup.arrowright) = \"onArrowClickHandler('right')\" (keyup.arrowleft) = \"onArrowClickHandler('left')\">\n  <div class=\"carousel\">\n    <div class=\"carousel__cancel\" (click)=\"detach()\">\n      <i class=\"icon icon--close\"></i>\n    </div>\n\n    <ng-container *ngIf=\"showNavigation\">\n      <a class=\"carousel__arrow carousel__arrow--left\"\n         *ngIf=\"showLeftNavigation\"\n         (click)=\"onArrowClickHandler('left')\"></a>\n      <a class=\"carousel__arrow carousel__arrow--right\"\n         *ngIf=\"showRightNavigation\"\n         (click)=\"onArrowClickHandler('right')\"></a>\n    </ng-container>\n\n    <ng-container #container></ng-container>\n\n    <ng-container *ngIf=\"showNavigation\">\n      <bis-carousel-dot-placeholder\n        [components]=\"components\"\n        [config]=\"config\"\n        [activeIndex]=\"getActiveCmpIndex()\"\n        (indexChange$)=\"indexChangeEventHandler($event)\"></bis-carousel-dot-placeholder>\n    </ng-container>\n  </div>\n</div>\n", styles: [".carousel{min-height:30vh;line-height:1.5rem}.carousel__arrow{font-size:2rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CarouselDotPlaceholderComponent, selector: "bis-carousel-dot-placeholder", inputs: ["components", "config", "activeIndex"], outputs: ["indexChange$"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-carousel', template: "<div class=\"carousel-backdrop carousel-backdrop--open\" tabindex=\"0\" #carouselContainer (keyup.arrowright) = \"onArrowClickHandler('right')\" (keyup.arrowleft) = \"onArrowClickHandler('left')\">\n  <div class=\"carousel\">\n    <div class=\"carousel__cancel\" (click)=\"detach()\">\n      <i class=\"icon icon--close\"></i>\n    </div>\n\n    <ng-container *ngIf=\"showNavigation\">\n      <a class=\"carousel__arrow carousel__arrow--left\"\n         *ngIf=\"showLeftNavigation\"\n         (click)=\"onArrowClickHandler('left')\"></a>\n      <a class=\"carousel__arrow carousel__arrow--right\"\n         *ngIf=\"showRightNavigation\"\n         (click)=\"onArrowClickHandler('right')\"></a>\n    </ng-container>\n\n    <ng-container #container></ng-container>\n\n    <ng-container *ngIf=\"showNavigation\">\n      <bis-carousel-dot-placeholder\n        [components]=\"components\"\n        [config]=\"config\"\n        [activeIndex]=\"getActiveCmpIndex()\"\n        (indexChange$)=\"indexChangeEventHandler($event)\"></bis-carousel-dot-placeholder>\n    </ng-container>\n  </div>\n</div>\n", styles: [".carousel{min-height:30vh;line-height:1.5rem}.carousel__arrow{font-size:2rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; }, propDecorators: { viewContainerRef: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef, static: true }]
            }], viewCarouselContainerRef: [{
                type: ViewChild,
                args: ['carouselContainer', { static: false }]
            }] } });

class CarouselService {
    constructor(carouselPlaceholderSerive) {
        this.carouselPlaceholderSerive = carouselPlaceholderSerive;
        this.carouselRef = null;
        this.navigate$ = new EventEmitter();
        this.open = (components, config) => {
            const carouselRef = this.carouselPlaceholderSerive.create();
            const carouselComponent = carouselRef.attach(CarouselComponent);
            this.setComponentInstanceData(carouselComponent, carouselRef, components, config);
            this.carouselRef = carouselRef;
            return carouselRef;
        };
        this.navigateTo = (index) => {
            this.navigate$.next(index);
        };
        this.destroy = () => {
            if (this.carouselRef) {
                this.carouselRef.detach();
            }
        };
    }
    setComponentInstanceData(carouselComponent, carouselRef, components, config) {
        carouselComponent.instance.detach = carouselRef.detach;
        carouselComponent.instance.components = components;
        carouselComponent.instance.navigate$ = this.navigate$;
        carouselComponent.instance.config = new CarouselConfig(config);
    }
}
CarouselService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselService, deps: [{ token: CarouselPlaceholderService }], target: i0.ɵɵFactoryTarget.Injectable });
CarouselService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: CarouselPlaceholderService }]; } });

class CarouselJumpToDirective {
    constructor(carouselService) {
        this.carouselService = carouselService;
        this.jumpTo = null;
    }
    onClickHandler() {
        this.carouselService.navigateTo(this.jumpTo || 0);
    }
}
CarouselJumpToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselJumpToDirective, deps: [{ token: CarouselService }], target: i0.ɵɵFactoryTarget.Directive });
CarouselJumpToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CarouselJumpToDirective, selector: "[bis-carousel-jump-to]", inputs: { jumpTo: "jumpTo" }, host: { listeners: { "click": "onClickHandler()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselJumpToDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bis-carousel-jump-to]' }]
        }], ctorParameters: function () { return [{ type: CarouselService }]; }, propDecorators: { jumpTo: [{
                type: Input
            }], onClickHandler: [{
                type: HostListener,
                args: ['click']
            }] } });
class CarouselCloseDirective {
    constructor(carouselService) {
        this.carouselService = carouselService;
        this.close$ = new EventEmitter();
    }
    onClickHandler() {
        this.carouselService.destroy();
        this.close$.next(true);
    }
}
CarouselCloseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselCloseDirective, deps: [{ token: CarouselService }], target: i0.ɵɵFactoryTarget.Directive });
CarouselCloseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CarouselCloseDirective, selector: "[bis-carousel-close]", outputs: { close$: "close$" }, host: { listeners: { "click": "onClickHandler()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselCloseDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bis-carousel-close]' }]
        }], ctorParameters: function () { return [{ type: CarouselService }]; }, propDecorators: { close$: [{
                type: Output
            }], onClickHandler: [{
                type: HostListener,
                args: ['click']
            }] } });

class CarouselModule {
}
CarouselModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CarouselModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: CarouselModule, declarations: [CarouselComponent,
        CarouselDotPlaceholderComponent,
        CarouselDotComponent,
        CarouselCloseDirective,
        CarouselJumpToDirective], imports: [CommonModule], exports: [CarouselComponent,
        CarouselDotPlaceholderComponent,
        CarouselCloseDirective,
        CarouselJumpToDirective] });
CarouselModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselModule, providers: [
        CarouselService,
        CarouselPlaceholderService
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [
                        CarouselComponent,
                        CarouselDotPlaceholderComponent,
                        CarouselCloseDirective,
                        CarouselJumpToDirective
                    ],
                    declarations: [
                        CarouselComponent,
                        CarouselDotPlaceholderComponent,
                        CarouselDotComponent,
                        CarouselCloseDirective,
                        CarouselJumpToDirective
                    ],
                    providers: [
                        CarouselService,
                        CarouselPlaceholderService
                    ]
                }]
        }] });

class DataHistoryCollection {
    constructor() {
        this.history = [];
    }
    addToHistory(data) {
        this.history.push(data);
    }
    getHistory() {
        return this.history;
    }
}
class DataSource {
}
/**
 * Data source that accepts a client-side data array and includes native support of filtering,
 * sorting (using bisSort), and pagination (using Pagination Component).
 *
 * Allows for sort customization by overriding sortingDataAccessor, which defines how data
 * properties are accessed. Also allows for filter customization by overriding filterTermAccessor,
 * which defines how row data is converted to a string for filter matching.
 */
class BisTableDataSource extends DataSource {
    constructor(initialData = []) {
        super();
        // Stream emitting render data to the table (depends on ordered data changes).
        this._renderData = new BehaviorSubject([]);
        // Stream that emits when a new filter string is set on the data source.
        this._filter = new BehaviorSubject('');
        // Used to react to internal changes of the paginator that are made by the data source itself.
        this.internalPageChanges = new Subject();
        this._unsubscribe = new Subject();
        /**
         * Data accessor function that is used for accessing data properties for sorting through
         * the default sortData function.
         * This default function assumes that the sort header IDs (which defaults to the column name)
         * matches the data's properties (e.g. column Xyz represents data['Xyz']).
         * May be set to a custom function for different behavior.
         * @param data Data object that is being accessed.
         * @param sortHeaderId The name of the column that represents the data.
         */
        this.sortingDataAccessor = (data, sortHeaderId) => {
            const value = data[sortHeaderId];
            return (!isNaN(parseFloat(value)) && !isNaN(Number(value))) ? Number(value) : value;
        };
        /**
         * Gets a sorted copy of the data array based on the state of the bisSort. Called
         * after changes are made to the filtered data or when sort changes are emitted from bisSort.
         * By default, the function retrieves the active sort and its direction and compares data
         * by retrieving data using the sortingDataAccessor. May be overridden for a custom implementation
         * of data ordering.
         * @param data The array of data that should be sorted.
         * @param sort The connected bisSort that holds the current sort state.
         */
        this.sortData = (data, sort) => {
            const active = sort.bisSortActive;
            const direction = sort.direction;
            if (!active || direction === '') {
                return data;
            }
            return data.sort((a, b) => {
                const valueA = this.sortingDataAccessor(a, active);
                const valueB = this.sortingDataAccessor(b, active);
                // If both valueA and valueB exist (truthy), then compare the two. Otherwise, check if
                // one value exists while the other doesn't. In this case, existing value should come first.
                // This avoids inconsistent results when comparing values to undefined/null.
                // If neither value exists, return 0 (equal).
                let comparatorResult = 0;
                if (valueA && valueB) {
                    // Check if one value is greater than the other; if equal, comparatorResult should remain 0.
                    if (valueA > valueB) {
                        comparatorResult = 1;
                    }
                    else if (valueA < valueB) {
                        comparatorResult = -1;
                    }
                }
                else if (valueA) {
                    comparatorResult = 1;
                }
                else if (valueB) {
                    comparatorResult = -1;
                }
                return comparatorResult * (direction === 'asc' ? 1 : -1);
            });
        };
        /**
         * Checks if a data object matches the data source's filter string. By default, each data object
         * is converted to a string of its properties and returns true if the filter has
         * at least one occurrence in that string. By default, the filter string has its whitespace
         * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
         * filter matching.
         * @param data Data object used to check against the filter.
         * @param filter Filter string that has been set on the data source.
         * @returns Whether the filter matches against the data
         */
        this.filterPredicate = (data, filter) => {
            // Word delimiter to avoid matching of combined column values
            const unicodeDelimiter = '◬';
            // Transform the data into a lowercase string of all property values.
            const dataStr = Object
                .keys(data)
                .reduce((currentTerm, key) => {
                const value = data[key];
                return `${currentTerm}${value}${unicodeDelimiter}`;
            }, '')
                .toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
        };
        this._iterableDiffers = new IterableDiffers(null);
        this._data = new BehaviorSubject(initialData);
        this._updateChangeSubscription();
    }
    /** Array of data that should be rendered by the table, where each object represents one row. */
    get data() {
        return this._data.value;
    }
    set data(data) {
        this.updatePageIndexIfPageIsEmpty(data);
        this._data.next(data);
    }
    get pagination() {
        return this._pagination;
    }
    set pagination(pagination) {
        this._pagination = pagination;
        if (this.pagination.config) {
            this._updateChangeSubscription();
        }
    }
    /**
     * Filter term that should be used to filter out objects from the data array. To override how
     * data objects match to this filter string, provide a custom function for filterPredicate.
     */
    get filter() {
        return this._filter.value;
    }
    set filter(filter) {
        this._filter.next(filter);
    }
    /**
     * Instance of the bisSort directive used by the table to control its sorting. Sort changes
     * emitted by the bisSort will trigger an update to the table's rendered data.
     */
    get sort() {
        return this._sort;
    }
    set sort(sort) {
        this._sort = sort;
        this._updateChangeSubscription();
    }
    /**
     * Subscribe to changes that should trigger an update to the table's rendered rows. When the
     * changes occur, process the current state of the filter, sort, and pagination along with
     * the provided base data and send it to the table for rendering.
     */
    _updateChangeSubscription() {
        this._unsubscribe.next(undefined);
        const sortChange = this._sort
            ? merge(this._sort.sortChange.pipe(startWith(null)), this._sort.initialized)
            : of(null);
        const pageChange = this.pagination
            ? merge(this.pagination.pageChange.pipe(startWith(null)), this.internalPageChanges, this.pagination.initialized)
            : of(null);
        const filterChange = this._filter;
        const dataStream = this._data;
        const filteredDataStream = combineLatest([dataStream, filterChange])
            .pipe(map(([data]) => this._filterData(data)));
        const orderedDataStream = combineLatest([filteredDataStream, sortChange])
            .pipe(map(([data]) => this._orderData(data)));
        const paginatedDataStream = combineLatest([orderedDataStream, pageChange])
            .pipe(map(([data, page]) => this._pageData(data, page)));
        paginatedDataStream
            .pipe(takeUntil(this._unsubscribe))
            .subscribe((data) => this._renderData.next(data));
    }
    /**
     * Returns a filtered data array where each filter object contains the filter string within
     * the result of the filterTermAccessor function. If no filter is set, returns the data array
     * as provided.
     */
    _filterData(data) {
        const paginationAtFirstPage = this.pagination && this.pagination.config.pageIndex === 1;
        const filterApplied = this.filter !== '';
        this.filteredData =
            !this.filter ? data : data.filter(obj => this.filterPredicate(obj, this.filter));
        if (!paginationAtFirstPage && filterApplied) {
            this.internalPageChanges.next({ page: 1 });
        }
        return this.filteredData;
    }
    /**
     * Returns a sorted copy of the data if bisSort has a sort applied, otherwise just returns the
     * data array as provided. Uses the default data accessor for data lookup, unless a
     * sortDataAccessor function is defined.
     */
    _orderData(data) {
        if (!this.sort) {
            return data;
        }
        return this.sortData(data.slice(), this.sort);
    }
    updatePageIndexIfPageIsEmpty(data) {
        const shouldUpdatePaginationIndex = this.pagination
            && this.pagination.config.pageIndex > 0
            && this._pageData(data, this.pagination.config).length === 0;
        if (shouldUpdatePaginationIndex) {
            const lastPossiblePageIndex = Math.ceil(data.length / this.pagination.config.pageSize);
            this.internalPageChanges.next({ page: lastPossiblePageIndex === 0 ? 1 : lastPossiblePageIndex });
        }
    }
    /**
     * Returns a paged splice of the provided data array according to the provided Pagination Component's page
     * index and length. If there is no pagination provided, returns the data array as provided.
     */
    _pageData(data, pageConfig) {
        if (!this.pagination) {
            return data;
        }
        const hasPageChangeEvent = pageConfig && pageConfig.page;
        const page = hasPageChangeEvent || this.pagination.config.pageIndex;
        const pageIndex = page - 1;
        const newStartIndex = pageIndex * this.pagination.config.pageSize;
        if (hasPageChangeEvent) {
            // pageIndex in the paginatior starts from 1... so we updated it with the current page
            this.pagination.config = Object.assign(Object.assign({}, this.pagination.config), { pageIndex: page });
        }
        this.pagination.config = Object.assign(Object.assign({}, this.pagination.config), { length: data.length });
        return data.slice(newStartIndex, newStartIndex + this.pagination.config.pageSize);
    }
    /**
     * Used by the BisTable. Called when it connects to the data source.
     * @docs-private
     */
    connect() {
        return this._renderData;
    }
    /**
     * Used by the BisTable. Called when it is destroyed. No-op.
     * @docs-private
     */
    disconnect() {
        this._unsubscribe.next(undefined);
        this._unsubscribe.complete();
    }
}

class CellBase {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._grow = 1;
        this.addGrowClass(1);
    }
    setGrow(grow) {
        this.removePreviousGrowClass(this._grow);
        if (grow) {
            this.addGrowClass(grow);
        }
        this._grow = grow;
    }
    removePreviousGrowClass(grow) {
        this.elementRef.nativeElement.classList.remove(`tcell--grow-${grow}`);
    }
    addGrowClass(grow) {
        this.elementRef.nativeElement.classList.add(`tcell--grow-${grow}`);
    }
}
/**
 * Cell definition for a bis table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
// tslint:disable-next-line:directive-selector
class CellDefDirective {
    constructor(template) {
        this.template = template;
    }
}
CellDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CellDefDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
CellDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CellDefDirective, selector: "[bisCellDef]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CellDefDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisCellDef]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
/**
 * Header cell definition for a bis table.
 * Captures the template of a column's header cell and as well as cell-specific properties.
 */
// tslint:disable-next-line:directive-selector
class HeaderCellDefDirective {
    constructor(template) {
        this.template = template;
    }
}
HeaderCellDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderCellDefDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
HeaderCellDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: HeaderCellDefDirective, selector: "[bisHeaderCellDef]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderCellDefDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisHeaderCellDef]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
/**
 * Column definition for the bis table.
 * Defines a set of cells available for a table column.
 */
// tslint:disable-next-line:directive-selector
class ColumnDefDirective {
    /** Unique name for this column. */
    get name() { return this._name; }
    set name(name) {
        // If the directive is set without a name (updated programatically), then this setter will
        // trigger with an empty string and should not overwrite the programatically set value.
        if (!name) {
            return;
        }
        this._name = name;
    }
}
ColumnDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ColumnDefDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ColumnDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: ColumnDefDirective, selector: "[bisColumnDef]", inputs: { name: ["bisColumnDef", "name"] }, queries: [{ propertyName: "cell", first: true, predicate: CellDefDirective, descendants: true }, { propertyName: "headerCell", first: true, predicate: HeaderCellDefDirective, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ColumnDefDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisColumnDef]' }]
        }], propDecorators: { name: [{
                type: Input,
                args: ['bisColumnDef']
            }], cell: [{
                type: ContentChild,
                args: [CellDefDirective, { static: false }]
            }], headerCell: [{
                type: ContentChild,
                args: [HeaderCellDefDirective, { static: false }]
            }] } });
/** Header cell template container that adds the right classes and role. */
class HeaderCellComponent extends CellBase {
    constructor(elementRef) {
        super(elementRef);
        this.role = 'columnheader';
        this.tcell = true;
        this.tcellHead = true;
        /**
         * Add a vertical left border (adds .tcell--vertical-border)
         *   {boolean}
         */
        this.verticalBorder = false;
        /**
         * Set the input as bold (adds .tcell--bold-text)
         *   {boolean}
         */
        this.boldCell = false;
    }
    set grow(grow) {
        this.setGrow(grow);
    }
    get grow() {
        return this._grow;
    }
}
HeaderCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderCellComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
HeaderCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: HeaderCellComponent, selector: "bis-header-cell", inputs: { verticalBorder: "verticalBorder", boldCell: "boldCell", grow: "grow" }, host: { properties: { "attr.role": "this.role", "class.tcell": "this.tcell", "class.tcell--head": "this.tcellHead", "class.tcell--vertical-border": "this.verticalBorder", "class.tcell--bold-text": "this.boldCell" } }, usesInheritance: true, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-header-cell',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], tcell: [{
                type: HostBinding,
                args: ['class.tcell']
            }], tcellHead: [{
                type: HostBinding,
                args: ['class.tcell--head']
            }], verticalBorder: [{
                type: HostBinding,
                args: ['class.tcell--vertical-border']
            }, {
                type: Input
            }], boldCell: [{
                type: HostBinding,
                args: ['class.tcell--bold-text']
            }, {
                type: Input
            }], grow: [{
                type: Input
            }] } });
/** Cell template container that adds the right classes and role. */
class CellComponent extends CellBase {
    constructor(elementRef) {
        super(elementRef);
        this.role = 'cell';
        this.scope = 'row';
        this.tcell = true;
        this.hostName = true;
        /**
         * Add a vertical left border (adds .tcell--vertical-border)
         *   {boolean}
         */
        this.verticalBorder = false;
        /**
         * Set the input as bold (adds .tcell--bold-text)
         *   {boolean}
         */
        this.boldCell = false;
    }
    set grow(grow) {
        this.setGrow(grow);
    }
    get grow() {
        return this._grow;
    }
}
CellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CellComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CellComponent, selector: "bis-cell", inputs: { verticalBorder: "verticalBorder", boldCell: "boldCell", grow: "grow" }, host: { properties: { "attr.role": "this.role", "attr.scope": "this.scope", "class.tcell": "this.tcell", "class.bis-host-cell": "this.hostName", "class.tcell--vertical-border": "this.verticalBorder", "class.tcell--bold-text": "this.boldCell" } }, usesInheritance: true, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-cell',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], scope: [{
                type: HostBinding,
                args: ['attr.scope']
            }], tcell: [{
                type: HostBinding,
                args: ['class.tcell']
            }], hostName: [{
                type: HostBinding,
                args: ['class.bis-host-cell']
            }], verticalBorder: [{
                type: HostBinding,
                args: ['class.tcell--vertical-border']
            }, {
                type: Input
            }], boldCell: [{
                type: HostBinding,
                args: ['class.tcell--bold-text']
            }, {
                type: Input
            }], grow: [{
                type: Input
            }] } });

/**
 * Returns an error to be thrown when attempting to find an unexisting column.
 * @param id Id whose lookup failed.
 */
function getTableUnknownColumnError(id) {
    return Error(`Could not find column with id "${id}".`);
}
/**
 * Returns an error to be thrown when two column definitions have the same name.
 */
function getTableDuplicateColumnNameError(name) {
    return Error(`Duplicate column definition name provided: "${name}".`);
}
/**
 * Returns an error to be thrown when there are multiple rows that are missing a when function.
 */
function getTableMultipleDefaultRowDefsError() {
    return Error(`There can only be one default row without a when predicate function.`);
}
/**
 * Returns an error to be thrown when there are no matching row defs for a particular set of data.
 */
function getTableMissingMatchingRowDefError() {
    return Error(`Could not find a matching row definition for the provided row data.`);
}
/**
 * Returns an error to be thrown when there is no row definitions present in the content.
 */
function getTableMissingRowDefsError() {
    return Error('Missing definitions for header and row, ' + 'cannot determine which columns should be rendered.');
}
/**
 * Returns an error to be thrown when the data source does not match the compatible types.
 */
function getTableUnknownDataSourceError() {
    return Error(`Provided data source did not match an array, Observable, or DataSource`);
}

/**
 * Base class for the HeaderRowDefDirective and RowDefDirective that handles checking their columns inputs
 * for changes and notifying the table.
 */
class BaseRowDef {
    constructor(template, _differs) {
        this.template = template;
        this._differs = _differs;
    }
    ngOnChanges(changes) {
        // Create a new columns differ if one does not yet exist. Initialize it based on initial value
        // of the columns property or an empty array if none is provided.
        const columns = changes['columns'].currentValue || [];
        if (!this._columnsDiffer) {
            this._columnsDiffer = this._differs.find(columns).create();
            this._columnsDiffer.diff(columns);
        }
    }
    /**
     * Returns the difference between the current columns and the columns from the last diff, or null
     * if there is no difference.
     */
    getColumnsDiff() {
        return this._columnsDiffer.diff(this.columns);
    }
}
BaseRowDef.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BaseRowDef, deps: [{ token: i0.TemplateRef }, { token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Directive });
BaseRowDef.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: BaseRowDef, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BaseRowDef, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.IterableDiffers }]; } });
/**
 * Header row definition for the data table.
 * Captures the header row's template and other header properties such as the columns to display.
 */
class HeaderRowDefDirective extends BaseRowDef {
    constructor(template, _differs) {
        super(template, _differs);
    }
}
HeaderRowDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderRowDefDirective, deps: [{ token: i0.TemplateRef }, { token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Directive });
HeaderRowDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: HeaderRowDefDirective, selector: "[bisHeaderRowDef]", inputs: { columns: ["bisHeaderRowDef", "columns"] }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[bisHeaderRowDef]',
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['columns: bisHeaderRowDef'],
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.IterableDiffers }]; } });
/**
 * Data row definition for the data table.
 * Captures the header row's template and other row properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 */
class RowDefDirective extends BaseRowDef {
    // TODO(andrewseguin): Add an input for providing a switch function to determine
    //   if this template should be used.
    constructor(template, _differs) {
        super(template, _differs);
    }
}
RowDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RowDefDirective, deps: [{ token: i0.TemplateRef }, { token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Directive });
RowDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: RowDefDirective, selector: "[bisRowDef]", inputs: { columns: ["bisRowDefColumns", "columns"], when: ["bisRowDefWhen", "when"] }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[bisRowDef]',
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['columns: bisRowDefColumns', 'when: bisRowDefWhen'],
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.IterableDiffers }]; } });
/**
 * Outlet for rendering cells inside of a row or header row.
 */
// tslint:disable-next-line:directive-selector
class CellOutletDirective {
    constructor(_viewContainer) {
        this._viewContainer = _viewContainer;
        CellOutletDirective.mostRecentCellOutlet = this;
    }
}
/**
 * Static property containing the latest constructed instance of this class.
 * Used by the data table when each HeaderRowComponent and RowComponent is created using
 * createEmbeddedView. After one of these components are created, this property will provide
 * a handle to provide that component's cells and context. After init, the bisCellOutlet will
 * construct the cells with the provided context.
 */
CellOutletDirective.mostRecentCellOutlet = null;
CellOutletDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CellOutletDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
CellOutletDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: CellOutletDirective, selector: "[bisCellOutlet]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CellOutletDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisCellOutlet]' }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });
/** Header template container that contains the cell outlet. Adds the right class and role. */
class HeaderRowComponent {
    constructor() {
        this.role = 'row';
        this.class = 'thead__row';
    }
}
HeaderRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeaderRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: HeaderRowComponent, selector: "bis-header-row", host: { properties: { "attr.role": "this.role", "class": "this.class" } }, ngImport: i0, template: `<ng-container bisCellOutlet></ng-container>`, isInline: true, dependencies: [{ kind: "directive", type: CellOutletDirective, selector: "[bisCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-header-row',
                    template: `<ng-container bisCellOutlet></ng-container>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });
/** Data row template container that contains the cell outlet. Adds the right class and role. */
class TableRowComponent {
    constructor() {
        this.role = 'row';
        this.tbodyRowClass = true;
    }
}
TableRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TableRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TableRowComponent, selector: "bis-table-row", host: { properties: { "attr.role": "this.role", "class.tbody__row": "this.tbodyRowClass" } }, ngImport: i0, template: `
    <ng-container bisCellOutlet></ng-container>
    <ng-content></ng-content>
  `, isInline: true, dependencies: [{ kind: "directive", type: CellOutletDirective, selector: "[bisCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TableRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-table-row',
                    template: `
    <ng-container bisCellOutlet></ng-container>
    <ng-content></ng-content>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], tbodyRowClass: [{
                type: HostBinding,
                args: ['class.tbody__row']
            }] } });

class PaginationComponent {
    constructor(cd) {
        this.cd = cd;
        this.hostName = true;
        this.prevPageItem = null;
        this.nextPageItem = null;
        this.items = [];
        this.initialized = new Subject();
        this.scrollToTop = false;
        this.pageLimit = 9999;
        this.pageChange = new EventEmitter();
        this.breakpoint = 'md';
    }
    get config() {
        return this._config;
    }
    set config(config) {
        if (config && config !== this.config) {
            this._config = config;
            this._updatePagination();
            this.cd.detectChanges();
            this.initialized.next(undefined);
            this.initialized.complete();
        }
    }
    /**
     * The main build function used to determine
     * the paging logic.
     */
    _updatePagination() {
        //Reset page items
        this.items = [];
        this.nextPageItem = null;
        this.prevPageItem = null;
        //Do not display pagination
        if (this.config.length <= this.config.pageSize) {
            return;
        }
        const length = this.config.length > (this.pageLimit - this.config.pageSize) ? (this.pageLimit - this.config.pageSize) : this.config.length;
        const pageSize = (!this.config.pageSize || this.config.pageSize <= 0) ? 1 : this.config.pageSize; // Block divide by 0 and empty page size
        const pageIndex = this.config.pageIndex || 1;
        const pageCount = Math.ceil(length / pageSize); // Determine the last page or total page count
        const adjacent = this.config.adjacent || 2;
        const fullAdjacentSize = (adjacent * adjacent) + adjacent;
        let start, finish;
        this.prevPageItem = this.buildPrevPageItem(pageIndex);
        this.nextPageItem = this.buildNextPageItem(pageIndex, pageCount);
        // If the page count is less than the full adjacent size
        // Then we simply display all the pages, Otherwise we
        // calculate the proper paging display
        if (pageCount <= (fullAdjacentSize + adjacent)) {
            start = 1;
            this.addRange(start, pageCount, pageIndex);
        }
        else {
            // Determine if we are showing the beginning of the paging list
            // We know it is the beginning if the page - adjacent is <= 2
            if (pageIndex - adjacent <= adjacent) {
                start = 1;
                finish = 1 + fullAdjacentSize;
                this.addRange(start, finish, pageIndex);
                this.addLast(pageCount, finish, pageIndex, adjacent);
            }
            // Determine if we are showing the middle of the paging list
            // We know we are either in the middle or at the end since the beginning is ruled out above
            // So we simply check if we are not at the end
            // Again 2 is hard coded as we always display two pages after the dots
            else if (pageIndex < pageCount - (adjacent * adjacent)) {
                start = pageIndex - adjacent;
                finish = pageIndex + adjacent;
                this.addFirst(start, pageIndex, adjacent);
                this.addRange(start, finish, pageIndex);
                this.addLast(pageCount, finish, pageIndex, adjacent);
            }
            // If nothing else we conclude we are at the end of the paging list
            // We know this since we have already ruled out the beginning and middle above
            else {
                start = pageCount - fullAdjacentSize;
                finish = pageCount;
                this.addFirst(start, pageIndex, adjacent);
                this.addRange(start, finish, pageIndex);
            }
        }
    }
    /**
     * Add the first or beginning items in our paging list
     * We leverage the 'next' parameter to determine if the dots are required
     *
     * @param next - the next page number in the paging sequence
     * @param pageIndex - the current page
     */
    addFirst(next, pageIndex, adjacent) {
        this.addRange(1, adjacent, pageIndex);
        // We ignore dots if the next value is 3
        // ie: 1 2 ... 3 4 5 becomes just 1 2 3 4 5
        if (next !== adjacent + 1) {
            this.items.push(this.buildPageItem('dot', null, true, false));
        }
    }
    /**
     * Add the last or end items in our paging list
     * We leverage the 'prev' parameter to determine if the dots are required
     *
     * @param pageCount - The last page number or total page count
     * @param prev - the previous page number in the paging sequence
     * @param pageIndex - the current page
     */
    // Add Last Pages
    addLast(pageCount, prev, pageIndex, adjacent) {
        // We ignore dots if the previous value is one less that our start range
        // ie: 1 2 3 4 ... 5 6  becomes just 1 2 3 4 5 6
        if (prev !== pageCount - adjacent) {
            this.items.push(this.buildPageItem('dot', null, true, false));
        }
        this.addRange(pageCount - (adjacent - 1), pageCount, pageIndex);
    }
    /**
     * Create's a range of page items
     * The range is dependent on the start and finish parameters
     *
     * @param start - The start of the range to add to the paging list
     * @param finish - The end of the range to add to the paging list
     * @param pageIndex - the current page
     */
    addRange(start, finish, pageIndex) {
        for (let page = start; page <= finish; page++) {
            const selected = pageIndex === page;
            this.items.push(this.buildPageItem('default', page, false, selected));
        }
    }
    /**
     * Create's the previous page item
     *
     * @param pageIndex - the current page
     */
    buildPrevPageItem(pageIndex) {
        const disabled = pageIndex - 1 <= 0;
        const previousPage = pageIndex - 1 <= 0 ? 1 : pageIndex - 1;
        return this.buildPageItem('arrow', previousPage, disabled, false);
    }
    /**
     * Create's the next page item
     *
     * @param pageIndex - the current page
     * @param pageCount - the total page count
     */
    buildNextPageItem(pageIndex, pageCount) {
        const disabled = pageIndex + 1 > pageCount;
        const nextPage = pageIndex + 1 >= pageCount ? pageCount : pageIndex + 1;
        return this.buildPageItem('arrow', nextPage, disabled, false);
    }
    /**
     * Create's a page item
     *
     * @param disabled - if item is disabled
     * @param page - page number of the item
     * @param displayPage - if the item should display page number default to false
     * @param selected - if the item is the current page default to false
     */
    buildPageItem(type, page, disabled, selected) {
        return {
            type,
            disabled,
            selected,
            text: `${page ? page : ''}`,
            onClick: ($event) => {
                $event.preventDefault();
                if (!disabled && !selected) {
                    this.pageChange.next({ page });
                    if (this.scrollToTop) {
                        window.scrollTo(0, 0);
                    }
                }
            }
        };
    }
}
PaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
PaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: PaginationComponent, selector: "bis-pagination", inputs: { config: "config", scrollToTop: "scrollToTop", pageLimit: "pageLimit", breakpoint: "breakpoint", hidePagination: "hidePagination" }, outputs: { pageChange: "pageChange" }, host: { properties: { "class.bis-host-pagination": "this.hostName", "class.u-display-none": "this.hidePagination" } }, ngImport: i0, template: "<!-- Navigation for web (shown above provided breakpoint) -->\n<nav class=\"pagination u-display-none u-display-{{breakpoint}}-flex\" *ngIf=\"config\">\n  <a href=\"#\" class=\"pagination__item pagination__item--previous\" *ngIf=\"prevPageItem\" (click)=\"prevPageItem.onClick($event)\"></a>\n  <ng-container *ngFor=\"let item of items; let i=index\">\n    <ng-container *ngIf=\"item?.type === 'dot'\">\n      <span class=\"pagination__item pagination__item--more\"></span>\n    </ng-container>\n    <ng-container *ngIf=\"item?.type !== 'dot'\">\n      <a href=\"#\" class=\"pagination__item u-display-none u-display-{{breakpoint}}-flex\"\n         [class.pagination__item--selected]=\"item?.selected\"\n         [class.u-hidden-lg-down]=\"!item?.selected\"\n         (click)=\"item?.onClick($event)\">{{item?.text}}</a>\n    </ng-container>\n  </ng-container>\n  <a href=\"#\" class=\"pagination__item pagination__item--next\" *ngIf=\"nextPageItem\" (click)=\"nextPageItem.onClick($event)\"></a>\n</nav>\n\n<!-- Navigation for mobile (shown blow provided breakpoint) -->\n<nav class=\"pagination u-display-{{breakpoint}}-none\" *ngIf=\"config\">\n  <a href=\"#\" class=\"pagination__item pagination__item--previous\" *ngIf=\"prevPageItem\" (click)=\"prevPageItem.onClick($event)\"></a>\n  <ng-container *ngFor=\"let item of items; let i=index\">\n    <ng-container *ngIf=\"item?.selected\">\n      <a href=\"#\" class=\"pagination__item\"\n         *ngIf=\"i > 0\"\n         (click)=\"items[i-1]?.onClick($event)\">{{items[i-1]?.text}}</a>\n\n      <a href=\"#\" class=\"pagination__item\"\n         [class.pagination__item--selected]=\"item?.selected\"\n         [class.u-hidden-lg-down]=\"!item?.selected\"\n         (click)=\"item?.onClick($event)\">{{item?.text}}</a>\n\n      <a href=\"#\" class=\"pagination__item\"\n         *ngIf=\"i < items.length-1\"\n         (click)=\"items[i+1]?.onClick($event)\">{{items[i+1]?.text}}</a>\n    </ng-container>\n  </ng-container>\n  <a href=\"#\" class=\"pagination__item pagination__item--next\" *ngIf=\"nextPageItem\" (click)=\"nextPageItem.onClick($event)\"></a>\n</nav>\n", styles: [":host{display:block}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'bis-pagination', template: "<!-- Navigation for web (shown above provided breakpoint) -->\n<nav class=\"pagination u-display-none u-display-{{breakpoint}}-flex\" *ngIf=\"config\">\n  <a href=\"#\" class=\"pagination__item pagination__item--previous\" *ngIf=\"prevPageItem\" (click)=\"prevPageItem.onClick($event)\"></a>\n  <ng-container *ngFor=\"let item of items; let i=index\">\n    <ng-container *ngIf=\"item?.type === 'dot'\">\n      <span class=\"pagination__item pagination__item--more\"></span>\n    </ng-container>\n    <ng-container *ngIf=\"item?.type !== 'dot'\">\n      <a href=\"#\" class=\"pagination__item u-display-none u-display-{{breakpoint}}-flex\"\n         [class.pagination__item--selected]=\"item?.selected\"\n         [class.u-hidden-lg-down]=\"!item?.selected\"\n         (click)=\"item?.onClick($event)\">{{item?.text}}</a>\n    </ng-container>\n  </ng-container>\n  <a href=\"#\" class=\"pagination__item pagination__item--next\" *ngIf=\"nextPageItem\" (click)=\"nextPageItem.onClick($event)\"></a>\n</nav>\n\n<!-- Navigation for mobile (shown blow provided breakpoint) -->\n<nav class=\"pagination u-display-{{breakpoint}}-none\" *ngIf=\"config\">\n  <a href=\"#\" class=\"pagination__item pagination__item--previous\" *ngIf=\"prevPageItem\" (click)=\"prevPageItem.onClick($event)\"></a>\n  <ng-container *ngFor=\"let item of items; let i=index\">\n    <ng-container *ngIf=\"item?.selected\">\n      <a href=\"#\" class=\"pagination__item\"\n         *ngIf=\"i > 0\"\n         (click)=\"items[i-1]?.onClick($event)\">{{items[i-1]?.text}}</a>\n\n      <a href=\"#\" class=\"pagination__item\"\n         [class.pagination__item--selected]=\"item?.selected\"\n         [class.u-hidden-lg-down]=\"!item?.selected\"\n         (click)=\"item?.onClick($event)\">{{item?.text}}</a>\n\n      <a href=\"#\" class=\"pagination__item\"\n         *ngIf=\"i < items.length-1\"\n         (click)=\"items[i+1]?.onClick($event)\">{{items[i+1]?.text}}</a>\n    </ng-container>\n  </ng-container>\n  <a href=\"#\" class=\"pagination__item pagination__item--next\" *ngIf=\"nextPageItem\" (click)=\"nextPageItem.onClick($event)\"></a>\n</nav>\n", styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { hostName: [{
                type: HostBinding,
                args: ['class.bis-host-pagination']
            }], config: [{
                type: Input
            }], scrollToTop: [{
                type: Input
            }], pageLimit: [{
                type: Input
            }], pageChange: [{
                type: Output
            }], breakpoint: [{
                type: Input
            }], hidePagination: [{
                type: HostBinding,
                args: ['class.u-display-none']
            }, {
                type: Input
            }] } });

class TableFooterComponent {
    constructor() {
        this.isToggled = false;
        this.onClick$ = new EventEmitter();
    }
    handleClick(event) {
        this.onClick$
            .emit(event);
    }
}
TableFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TableFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TableFooterComponent, selector: "bis-table-footer", inputs: { collapsedText: "collapsedText", expandedText: "expandedText", isToggled: "isToggled" }, outputs: { onClick$: "onClick$" }, host: { listeners: { "click": "handleClick($event)" } }, ngImport: i0, template: `
    <div class="table-cell">
      <bis-expandable-button [expanded]="isToggled" class="u-margin-top-none">
        <ng-container collapsed-content>
          <span>{{collapsedText ? collapsedText : ''}}</span>
        </ng-container>
        <ng-container expanded-content>
          <span>{{expandedText ? expandedText : ''}}</span>
        </ng-container>
      </bis-expandable-button>
    </div>
  `, isInline: true, styles: [":host{display:block;cursor:pointer;overflow:hidden;border-radius:19px;margin-top:-16px}\n"], dependencies: [{ kind: "component", type: ExpandableButtonComponent, selector: "bis-expandable-button", inputs: ["withIcons", "expanded"], outputs: ["onClick$"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TableFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-table-footer', template: `
    <div class="table-cell">
      <bis-expandable-button [expanded]="isToggled" class="u-margin-top-none">
        <ng-container collapsed-content>
          <span>{{collapsedText ? collapsedText : ''}}</span>
        </ng-container>
        <ng-container expanded-content>
          <span>{{expandedText ? expandedText : ''}}</span>
        </ng-container>
      </bis-expandable-button>
    </div>
  `, styles: [":host{display:block;cursor:pointer;overflow:hidden;border-radius:19px;margin-top:-16px}\n"] }]
        }], propDecorators: { collapsedText: [{
                type: Input
            }], expandedText: [{
                type: Input
            }], isToggled: [{
                type: Input
            }], onClick$: [{
                type: Output
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class SpinnerComponent {
    constructor() {
        this.hostName = true;
    }
}
SpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: SpinnerComponent, selector: "bis-spinner", host: { properties: { "class.bis-host-spinner": "this.hostName" } }, ngImport: i0, template: "<div class=\"spinner-container\">\n  <svg class=\"spinner\" viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g clip-path=\"url(#clip0_502_879)\" fill-rule=\"evenodd\" class=\"spinner__dots\">\n      <path d=\"M27.337 4.398C27.337 2.163 29.149 0.352997 31.383 0.352997C33.618 0.352997 35.429 2.163 35.429 4.398C35.429 6.633 33.617 8.444 31.382 8.444C29.148 8.444 27.336 6.634 27.336 4.398\" fill=\"#555555\"/>\n      <path d=\"M27.337 59.105C27.337 56.871 29.149 55.06 31.383 55.06C33.618 55.06 35.429 56.87 35.429 59.105C35.429 61.34 33.617 63.151 31.382 63.151C29.148 63.151 27.336 61.341 27.336 59.106\" fill=\"#555555\"/>\n      <path d=\"M54.693 31.752C54.693 29.517 56.505 27.706 58.74 27.706C60.975 27.706 62.785 29.516 62.785 31.752C62.785 33.986 60.975 35.798 58.74 35.798C56.505 35.798 54.693 33.986 54.693 31.752Z\" fill=\"#555555\"/>\n      <path d=\"M-0.0200195 31.752C-0.0200195 29.517 1.79298 27.706 4.02698 27.706C6.26198 27.706 8.07298 29.516 8.07298 31.752C8.07298 33.986 6.26298 35.798 4.02698 35.798C1.79298 35.798 -0.0190195 33.986 -0.0190195 31.752\" fill=\"#555555\"/>\n      <path d=\"M9.20996 9.93199C10.79 8.35199 13.352 8.35199 14.93 9.93199C16.512 11.512 16.512 14.074 14.932 15.654C13.352 17.234 10.79 17.234 9.20996 15.654C7.62996 14.074 7.62996 11.512 9.20996 9.93199Z\" fill=\"#555555\"/>\n      <path d=\"M47.894 48.616C49.474 47.036 52.034 47.036 53.614 48.616C55.196 50.196 55.196 52.758 53.614 54.338C52.034 55.918 49.474 55.918 47.894 54.338C46.314 52.758 46.314 50.196 47.894 48.616Z\" fill=\"#555555\"/>\n      <path d=\"M47.895 9.93C49.475 8.35 52.037 8.35 53.617 9.93C55.197 11.51 55.197 14.072 53.617 15.652C52.037 17.232 49.477 17.232 47.897 15.652C46.317 14.072 46.315 11.51 47.895 9.93Z\" fill=\"#555555\"/>\n      <path d=\"M9.20801 48.618C10.788 47.038 13.35 47.038 14.93 48.618C16.51 50.198 16.51 52.76 14.93 54.34C13.35 55.92 10.788 55.92 9.20801 54.34C7.62801 52.76 7.62801 50.198 9.20801 48.618Z\" fill=\"#555555\"/>\n    </g>\n    <path class=\"spinner__letter\" d=\"M38.6326 28.5416C39.7065 29.6534 40.2824 31.1179 40.2539 32.6644C40.2256 34.2102 39.5969 35.6537 38.484 36.7287L38.2868 36.9102L36.7235 35.3141L36.9318 35.1217C37.6164 34.4608 38.0028 33.5736 38.0202 32.6233C38.0376 31.6738 37.6846 30.7752 37.0257 30.0928C36.6487 29.7027 36.2381 29.4105 35.7432 29.2284V26.9163C36.8371 27.1601 37.8365 27.7171 38.6326 28.5416ZM26.1301 22.1455L25.0223 23.2065L26.5741 24.8134L27.6817 23.7527C28.7433 22.7276 30.439 22.7547 31.4612 23.8138C32.4837 24.8725 32.452 26.5682 31.3907 27.5933L30.2909 28.6466L31.8427 30.2535L32.9426 29.2005C34.89 27.3196 34.9465 24.2073 33.0684 22.2622C31.1901 20.3171 28.0778 20.2648 26.1301 22.1455Z\" fill=\"#555555\"/>\n    <path class=\"spinner__letter\" d=\"M24.673 24.3822L39.9588 40.2479L38.3518 41.7998L35.939 39.301L33.5544 41.6037C32.4415 42.6784 30.9769 43.2566 29.431 43.2309H29.4256C27.8809 43.2041 26.4397 42.5777 25.367 41.467C24.2932 40.3549 23.7176 38.8907 23.7458 37.3439C23.7741 35.7981 24.403 34.3546 25.5157 33.2796L27.1129 31.7466L28.6671 33.3518L27.0679 34.8866C26.3835 35.5475 25.9968 36.435 25.9794 37.385C25.962 38.3345 26.315 39.2331 26.974 39.9152C27.632 40.5966 28.5164 40.981 29.4644 40.9976H29.4678C30.4179 41.0133 31.3182 40.658 32.0025 39.9971L34.3857 37.6929L24.6716 27.6215L24.673 24.3822Z\" fill=\"#555555\"/>\n  </svg>\n</div>\n", styles: [".spinner__letter{fill:#555;-ms-transform-origin:0% 0%;transform-origin:0% 0%;-webkit-animation:opacity .5s ease infinite alternate;animation:opacity .5s ease infinite alternate}.spinner__dots{fill:#555;-webkit-animation:spinn 1s ease-out infinite;animation:spinn 1s ease-out infinite;-ms-transform-origin:50% 50%;transform-origin:50% 50%}.spinner__dots.white,.spinner__letter.white{fill:#fff}@-webkit-keyframes spinn{0%,50%{transform:rotate(0)}50%,to{transform:rotate(360deg)}}@keyframes spinn{0%,50%{transform:rotate(0)}50%,to{transform:rotate(360deg)}}@-webkit-keyframes opacity{0%{opacity:0}to{opacity:1}}@keyframes opacity{0%{opacity:0}to{opacity:1}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-spinner', template: "<div class=\"spinner-container\">\n  <svg class=\"spinner\" viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g clip-path=\"url(#clip0_502_879)\" fill-rule=\"evenodd\" class=\"spinner__dots\">\n      <path d=\"M27.337 4.398C27.337 2.163 29.149 0.352997 31.383 0.352997C33.618 0.352997 35.429 2.163 35.429 4.398C35.429 6.633 33.617 8.444 31.382 8.444C29.148 8.444 27.336 6.634 27.336 4.398\" fill=\"#555555\"/>\n      <path d=\"M27.337 59.105C27.337 56.871 29.149 55.06 31.383 55.06C33.618 55.06 35.429 56.87 35.429 59.105C35.429 61.34 33.617 63.151 31.382 63.151C29.148 63.151 27.336 61.341 27.336 59.106\" fill=\"#555555\"/>\n      <path d=\"M54.693 31.752C54.693 29.517 56.505 27.706 58.74 27.706C60.975 27.706 62.785 29.516 62.785 31.752C62.785 33.986 60.975 35.798 58.74 35.798C56.505 35.798 54.693 33.986 54.693 31.752Z\" fill=\"#555555\"/>\n      <path d=\"M-0.0200195 31.752C-0.0200195 29.517 1.79298 27.706 4.02698 27.706C6.26198 27.706 8.07298 29.516 8.07298 31.752C8.07298 33.986 6.26298 35.798 4.02698 35.798C1.79298 35.798 -0.0190195 33.986 -0.0190195 31.752\" fill=\"#555555\"/>\n      <path d=\"M9.20996 9.93199C10.79 8.35199 13.352 8.35199 14.93 9.93199C16.512 11.512 16.512 14.074 14.932 15.654C13.352 17.234 10.79 17.234 9.20996 15.654C7.62996 14.074 7.62996 11.512 9.20996 9.93199Z\" fill=\"#555555\"/>\n      <path d=\"M47.894 48.616C49.474 47.036 52.034 47.036 53.614 48.616C55.196 50.196 55.196 52.758 53.614 54.338C52.034 55.918 49.474 55.918 47.894 54.338C46.314 52.758 46.314 50.196 47.894 48.616Z\" fill=\"#555555\"/>\n      <path d=\"M47.895 9.93C49.475 8.35 52.037 8.35 53.617 9.93C55.197 11.51 55.197 14.072 53.617 15.652C52.037 17.232 49.477 17.232 47.897 15.652C46.317 14.072 46.315 11.51 47.895 9.93Z\" fill=\"#555555\"/>\n      <path d=\"M9.20801 48.618C10.788 47.038 13.35 47.038 14.93 48.618C16.51 50.198 16.51 52.76 14.93 54.34C13.35 55.92 10.788 55.92 9.20801 54.34C7.62801 52.76 7.62801 50.198 9.20801 48.618Z\" fill=\"#555555\"/>\n    </g>\n    <path class=\"spinner__letter\" d=\"M38.6326 28.5416C39.7065 29.6534 40.2824 31.1179 40.2539 32.6644C40.2256 34.2102 39.5969 35.6537 38.484 36.7287L38.2868 36.9102L36.7235 35.3141L36.9318 35.1217C37.6164 34.4608 38.0028 33.5736 38.0202 32.6233C38.0376 31.6738 37.6846 30.7752 37.0257 30.0928C36.6487 29.7027 36.2381 29.4105 35.7432 29.2284V26.9163C36.8371 27.1601 37.8365 27.7171 38.6326 28.5416ZM26.1301 22.1455L25.0223 23.2065L26.5741 24.8134L27.6817 23.7527C28.7433 22.7276 30.439 22.7547 31.4612 23.8138C32.4837 24.8725 32.452 26.5682 31.3907 27.5933L30.2909 28.6466L31.8427 30.2535L32.9426 29.2005C34.89 27.3196 34.9465 24.2073 33.0684 22.2622C31.1901 20.3171 28.0778 20.2648 26.1301 22.1455Z\" fill=\"#555555\"/>\n    <path class=\"spinner__letter\" d=\"M24.673 24.3822L39.9588 40.2479L38.3518 41.7998L35.939 39.301L33.5544 41.6037C32.4415 42.6784 30.9769 43.2566 29.431 43.2309H29.4256C27.8809 43.2041 26.4397 42.5777 25.367 41.467C24.2932 40.3549 23.7176 38.8907 23.7458 37.3439C23.7741 35.7981 24.403 34.3546 25.5157 33.2796L27.1129 31.7466L28.6671 33.3518L27.0679 34.8866C26.3835 35.5475 25.9968 36.435 25.9794 37.385C25.962 38.3345 26.315 39.2331 26.974 39.9152C27.632 40.5966 28.5164 40.981 29.4644 40.9976H29.4678C30.4179 41.0133 31.3182 40.658 32.0025 39.9971L34.3857 37.6929L24.6716 27.6215L24.673 24.3822Z\" fill=\"#555555\"/>\n  </svg>\n</div>\n", styles: [".spinner__letter{fill:#555;-ms-transform-origin:0% 0%;transform-origin:0% 0%;-webkit-animation:opacity .5s ease infinite alternate;animation:opacity .5s ease infinite alternate}.spinner__dots{fill:#555;-webkit-animation:spinn 1s ease-out infinite;animation:spinn 1s ease-out infinite;-ms-transform-origin:50% 50%;transform-origin:50% 50%}.spinner__dots.white,.spinner__letter.white{fill:#fff}@-webkit-keyframes spinn{0%,50%{transform:rotate(0)}50%,to{transform:rotate(360deg)}}@keyframes spinn{0%,50%{transform:rotate(0)}50%,to{transform:rotate(360deg)}}@-webkit-keyframes opacity{0%{opacity:0}to{opacity:1}}@keyframes opacity{0%{opacity:0}to{opacity:1}}\n"] }]
        }], propDecorators: { hostName: [{
                type: HostBinding,
                args: ['class.bis-host-spinner']
            }] } });

/**
 * Provides a handle for the table to grab the view container's ng-container to insert data rows.
 */
// tslint:disable-next-line:directive-selector
class RowPlaceholderDirective {
    constructor(viewContainer) {
        this.viewContainer = viewContainer;
    }
}
RowPlaceholderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RowPlaceholderDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
RowPlaceholderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: RowPlaceholderDirective, selector: "[bisRowPlaceholder]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RowPlaceholderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisRowPlaceholder]' }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });
// tslint:disable-next-line:directive-selector
class ExpandablePlaceholderDirective {
    constructor(viewContainer) {
        this.viewContainer = viewContainer;
    }
}
ExpandablePlaceholderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpandablePlaceholderDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
ExpandablePlaceholderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: ExpandablePlaceholderDirective, selector: "[bisExpandablePlaceholder]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpandablePlaceholderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisExpandablePlaceholder]' }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });
// tslint:disable-next-line:directive-selector
class PaginationPlaceholderDirective {
    constructor(viewContainer) {
        this.viewContainer = viewContainer;
    }
}
PaginationPlaceholderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationPlaceholderDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
PaginationPlaceholderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: PaginationPlaceholderDirective, selector: "[bisPaginationPlaceholder]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationPlaceholderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisPaginationPlaceholder]' }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });
/**
 * Provides a handle for the table to grab the view container's ng-container to insert the header.
 */
// tslint:disable-next-line:directive-selector
class HeaderRowPlaceholderDirective {
    constructor(viewContainer) {
        this.viewContainer = viewContainer;
    }
}
HeaderRowPlaceholderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderRowPlaceholderDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
HeaderRowPlaceholderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: HeaderRowPlaceholderDirective, selector: "[bisHeaderRowPlaceholder]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: HeaderRowPlaceholderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bisHeaderRowPlaceholder]' }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });
let componentId = 0;
/**
 * Class used to conveniently type the embedded view ref for rows with a context.
 */
class RowViewRef extends EmbeddedViewRef {
}
/**
 * A data table that renders a header row and data rows. Uses the dataSource input to determine
 * the data to be rendered. The data can be provided either as a data array or an Observable stream
 * that emits the data array to render
 */
class DataTableComponent {
    constructor(_differs, _changeDetectorRef, elementRef, role, componentFactoryResolver) {
        this._differs = _differs;
        this._changeDetectorRef = _changeDetectorRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.display = 'block';
        this.width = '100%';
        this.class = 'table-container';
        this.hostName = true;
        /** Subject that emits when the component has been destroyed. */
        this._onDestroy = new Subject();
        this._loading = false;
        this.spinnerClasses = 'bis-data-table-spinner';
        this.breakPoint = 'sm';
        /** Subscription that listens for the data provided by the data source. */
        this._renderChangeSubscription = Subscription.EMPTY;
        /**
         * Map of all the user's defined columns (header and data cell template) identified by name.
         * Collection populated by the column definitions gathered by `ContentChildren` as well as any
         * custom column definitions added to `_customColumnDefs`.
         */
        this._columnDefsByName = new Map();
        /** Column definitions that were defined outside of the direct content children of the table. */
        this._customColumnDefs = new Set();
        /** Row definitions that were defined outside of the direct content children of the table. */
        this._customRowDefs = new Set();
        /**
         * Whether the header row definition has been changed. Triggers an update to the header row after
         * content is checked.
         */
        this._headerRowDefChanged = false;
        this._toggled = false;
        /**
         * Tells the table from which row on to collapse it's content
         */
        this.collapseAtRow = null;
        /**
         * Stream containing the latest information on what rows are being displayed on screen.
         * Can be used by the data source to as a heuristic of what data should be provided.
         */
        this.viewChange = new BehaviorSubject({ start: 0, end: Number.MAX_VALUE });
        if (!role) {
            elementRef.nativeElement.setAttribute('role', 'grid');
        }
    }
    get data() {
        return this.collapseAtRow && !this._toggled ? this._data.slice(0, this.collapseAtRow) : this._data;
    }
    set data(data) {
        this._data = data;
    }
    set loading(loading) {
        this._loading = loading;
        this._changeDetectorRef.detectChanges();
        if (!loading && this._dataDiffer) {
            this._dataDiffer.diff([]);
            this.renderRows();
        }
        if (loading && this._rowPlaceholder) {
            this._rowPlaceholder.viewContainer.clear();
        }
    }
    get loading() {
        return this._loading;
    }
    /**
     * Tracking function that will be used to check the differences in data changes. Used similarly
     * to `ngFor` `trackBy` function. Optimize row operations by identifying a row based on its data
     * relative to the function to know if a row should be added/removed/moved.
     * Accepts a function that takes two parameters, `index` and `item`.
     */
    get trackBy() {
        return this._trackByFn;
    }
    set trackBy(fn) {
        if (isDevMode() &&
            fn != null && typeof fn !== 'function' &&
            console && console.warn) {
            console.warn(`trackBy must be a function, but received ${JSON.stringify(fn)}.`);
        }
        this._trackByFn = fn;
    }
    get paginationConfig() {
        return this._paginationConfig;
    }
    /**
     * It resets the pagination config if there is already a config file in over to override it
     */
    set paginationConfig(config) {
        if (!config) {
            return;
        }
        // Internal pagination index starts from 1...
        config.pageIndex = config.pageIndex + 1;
        this._paginationConfig = config;
        this.injectPagination();
        if (this.dataSource && this.paginationComponentRef) {
            this.dataSource.pagination = this.paginationComponentRef.instance;
        }
    }
    ;
    /**
     * The table's source of data, which can be provided in three ways (in order of complexity):
     *   - Simple data array (each object represents one table row)
     *   - Stream that emits a data array each time the array changes
     *   - `DataSource` object that implements the connect/disconnect interface.
     *
     * If a data array is provided, the table must be notified when the array's objects are
     * added, removed, or moved. This can be done by calling the `renderRows()` function which will
     * render the diff since the last table render. If the data array reference is changed, the table
     * will automatically trigger an update to the rows.
     *
     * When providing an Observable stream, the table will trigger an update automatically when the
     * stream emits a new array of data.
     */
    get dataSource() {
        return this._dataSource;
    }
    set dataSource(dataSource) {
        const shouldSetPaginationFirstPage = this._dataSource && this.paginationComponentRef;
        if (shouldSetPaginationFirstPage) {
            // pageIndex starts from 1
            this.paginationComponentRef.instance.config.pageIndex = 1;
        }
        if (dataSource && this._dataSource !== dataSource) {
            this._switchDataSource(dataSource);
        }
    }
    // Placeholders within the table's template where the header and data rows will be inserted.
    set rowPlaceholder(rowPlaceholder) {
        this._rowPlaceholder = rowPlaceholder;
    }
    ;
    ngOnInit() {
        this._dataDiffer = this._differs.find([]).create(this._trackByFn);
        // If the table has a header row definition defined as part of its content, flag this as a
        // header row def change so that the content check will render the header row.
        if (this._headerRowDef) {
            this._headerRowDefChanged = true;
        }
    }
    ngAfterContentChecked() {
        // Cache the row and column definitions gathered by ContentChildren and programmatic injection.
        this._cacheRowDefs();
        this._cacheColumnDefs();
        // Make sure that the user has at least added a header row or row def.
        if (!this._headerRowDef && !this._rowDefs.length) {
            throw getTableMissingRowDefsError();
        }
        // Render updates if the list of columns have been changed for the header or row definitions.
        this._renderUpdatedColumns();
        // If the header row definition has been changed, trigger a render to the header row.
        if (this._headerRowDefChanged) {
            this._renderHeaderRow();
            this._headerRowDefChanged = false;
        }
        // If there is a data source and row definitions, connect to the data source unless a
        // connection has already been made.
        if (this.dataSource && this._rowDefs.length > 0 && !this._renderChangeSubscription) {
            this._observeRenderChanges();
        }
    }
    ngOnDestroy() {
        if (this._rowPlaceholder) {
            this._rowPlaceholder.viewContainer.clear();
        }
        this._headerRowPlaceholder.viewContainer.clear();
        this._onDestroy.next();
        this._onDestroy.complete();
        if (this.dataSource instanceof DataSource) {
            this.dataSource.disconnect(this);
        }
        componentId = 0;
    }
    /**
     * Renders rows based on the table's latest set of data, which was either provided directly as an
     * input or retrieved through an Observable stream (directly or from a DataSource).
     * Checks for differences in the data since the last diff to perform only the necessary
     * changes (add/remove/move rows).
     *
     * If the table's data source is a DataSource or Observable, this will be invoked automatically
     * each time the provided Observable stream emits a new data array. Otherwise if your data is
     * an array, this function will need to be called to render any changes.
     */
    renderRows() {
        if (!this._rowPlaceholder || this.loading) {
            return;
        }
        const changes = this._dataDiffer.diff(this.data);
        this.injectTableFooter();
        if (!changes) {
            return;
        }
        const viewContainer = this._rowPlaceholder.viewContainer;
        changes.forEachOperation((record, adjustedPreviousIndex, currentIndex) => {
            if (record.previousIndex == null) {
                this._insertRow(record.item, currentIndex);
            }
            else if (currentIndex == null) {
                viewContainer.remove(adjustedPreviousIndex);
            }
            else {
                const view = viewContainer.get(adjustedPreviousIndex);
                viewContainer.move(view, currentIndex);
            }
        });
        // Update the meta context of a row's context data (index, count, first, last, ...)
        this._updateRowIndexContext();
        // Update rows that did not get added/removed/moved but may have had their identity changed,
        // e.g. if trackBy matched data on some property but the actual data reference changed.
        changes.forEachIdentityChange((record) => {
            const rowView = viewContainer.get(record.currentIndex);
            rowView.context.$implicit = record.item;
        });
    }
    injectTableFooter() {
        this.destroyFooterComponentRef();
        if (this.collapseAtRow !== null && this.collapseAtRow < this._data.length) {
            this.tableFooterComponentFactory = this.componentFactoryResolver.resolveComponentFactory(TableFooterComponent);
            this.tableFooterComponentRef = this._expandablePlaceholder.viewContainer.createComponent(this.tableFooterComponentFactory);
            this.tableFooterComponentRef.instance.expandedText = this.expandedText;
            this.tableFooterComponentRef.instance.collapsedText = this.collapsedText;
            this.tableFooterComponentRef.instance.isToggled = this._toggled;
            this.tableFooterComponentRef.instance.onClick$
                .subscribe(() => {
                this._toggleTableContent();
            });
            this._changeDetectorRef.detectChanges();
        }
    }
    destroyFooterComponentRef() {
        if (this.tableFooterComponentRef) {
            this.tableFooterComponentRef.destroy();
        }
    }
    injectPagination() {
        if (this.paginationConfig !== undefined && !this.paginationComponentRef) {
            this.paginationComponentFactory = this.componentFactoryResolver.resolveComponentFactory(PaginationComponent);
            this.paginationComponentRef = this._paginationPlaceholder.viewContainer.createComponent(this.paginationComponentFactory);
        }
        const length = get(this.dataSource, 'data.length');
        this.paginationComponentRef.instance.config = Object.assign(Object.assign({}, this.paginationConfig), { pageIndex: this.paginationConfig.pageIndex, length });
        if (this.paginationConfig !== undefined && this.collapseAtRow !== null) {
            console.warn(`Both pagination and collapseAtRow are set up`);
        }
    }
    /**
     * Sets the header row definition to be used. Overrides the header row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
     * table's content is checked.
     */
    setHeaderRowDef(headerRowDef) {
        this._headerRowDef = headerRowDef;
        this._headerRowDefChanged = true;
    }
    /** Adds a column definition that was not included as part of the direct content children. */
    addColumnDef(columnDef) {
        this._customColumnDefs.add(columnDef);
    }
    /** Removes a column definition that was not included as part of the direct content children. */
    removeColumnDef(columnDef) {
        this._customColumnDefs.delete(columnDef);
    }
    /** Adds a row definition that was not included as part of the direct content children. */
    addRowDef(rowDef) {
        this._customRowDefs.add(rowDef);
    }
    /** Removes a row definition that was not included as part of the direct content children. */
    removeRowDef(rowDef) {
        this._customRowDefs.delete(rowDef);
    }
    /** Update the map containing the content's column definitions. */
    _cacheColumnDefs() {
        this._columnDefsByName.clear();
        const columnDefs = this._contentColumnDefs ? this._contentColumnDefs.toArray() : [];
        this._customColumnDefs.forEach(columnDef => columnDefs.push(columnDef));
        columnDefs.forEach(columnDef => {
            if (this._columnDefsByName.has(columnDef.name)) {
                throw getTableDuplicateColumnNameError(columnDef.name);
            }
            this._columnDefsByName.set(columnDef.name, columnDef);
        });
    }
    /** Update the list of all available row definitions that can be used. */
    _cacheRowDefs() {
        this._rowDefs = this._contentRowDefs ? this._contentRowDefs.toArray() : [];
        this._customRowDefs.forEach(rowDef => this._rowDefs.push(rowDef));
        const defaultRowDefs = this._rowDefs.filter(def => !def.when);
        if (defaultRowDefs.length > 1) {
            throw getTableMultipleDefaultRowDefsError();
        }
        this._defaultRowDef = defaultRowDefs[0];
    }
    /**
     * Check if the header or rows have changed what columns they want to display. If there is a diff,
     * then re-render that section.
     */
    _renderUpdatedColumns() {
        // Re-render the rows when the row definition columns change.
        this._rowDefs.forEach(def => {
            if (!!def.getColumnsDiff()) {
                // Reset the data to an empty array so that renderRowChanges will re-render all new rows.
                this._dataDiffer.diff([]);
                if (this._rowPlaceholder) {
                    this._rowPlaceholder.viewContainer.clear();
                }
                this.renderRows();
            }
        });
        // Re-render the header row if there is a difference in its columns.
        if (this._headerRowDef && this._headerRowDef.getColumnsDiff()) {
            this._renderHeaderRow();
        }
    }
    /**
     * Switch to the provided data source by resetting the data and unsubscribing from the current
     * render change subscription if one exists. If the data source is null, interpret this by
     * clearing the row placeholder. Otherwise start listening for new data.
     */
    _switchDataSource(dataSource) {
        this.data = [];
        if (this.dataSource instanceof DataSource) {
            this.dataSource.disconnect(this);
        }
        // Stop listening for data from the previous data source.
        if (this._renderChangeSubscription) {
            this._renderChangeSubscription.unsubscribe();
            this._renderChangeSubscription = null;
        }
        if (!dataSource) {
            if (this._dataDiffer) {
                this._dataDiffer.diff([]);
            }
            if (this._rowPlaceholder) {
                this._rowPlaceholder.viewContainer.clear();
            }
        }
        this._dataSource = dataSource;
    }
    /** Set up a subscription for the data provided by the data source. */
    _observeRenderChanges() {
        if (!this.dataSource) {
            return;
        }
        if (this.paginationComponentRef) {
            this.dataSource.pagination = this.paginationComponentRef.instance;
        }
        let dataStream;
        if (this.dataSource.connect instanceof Function) {
            dataStream = this.dataSource.connect(this);
        }
        else if (this.dataSource instanceof Observable) {
            dataStream = this.dataSource;
        }
        else if (Array.isArray(this.dataSource)) {
            dataStream = of(this.dataSource);
        }
        if (dataStream === undefined) {
            throw getTableUnknownDataSourceError();
        }
        this._renderChangeSubscription = dataStream
            .pipe(takeUntil(this._onDestroy))
            .subscribe(data => {
            this.data = data;
            this.renderRows();
        });
    }
    /**
     * Clears any existing content in the header row placeholder and creates a new embedded view
     * in the placeholder using the header row definition.
     */
    _renderHeaderRow() {
        // Clear the header row placeholder if any content exists.
        if (this._headerRowPlaceholder.viewContainer.length > 0) {
            this._headerRowPlaceholder.viewContainer.clear();
        }
        const cells = this._getHeaderCellTemplatesForRow(this._headerRowDef);
        if (!cells.length) {
            return;
        }
        this._headerRowPlaceholder.viewContainer
            .createEmbeddedView(this._headerRowDef.template, { cells });
        cells.forEach(cell => {
            if (CellOutletDirective.mostRecentCellOutlet) {
                CellOutletDirective.mostRecentCellOutlet._viewContainer.createEmbeddedView(cell.template, {});
            }
        });
        this._changeDetectorRef.markForCheck();
    }
    /**
     * Finds the matching row definition that should be used for this row data. If there is only
     * one row definition, it is returned. Otherwise, find the row definition that has a when
     * predicate that returns true with the data. If none return true, return the default row
     * definition.
     */
    _getRowDef(data, i) {
        if (this._rowDefs.length === 1) {
            return this._rowDefs[0];
        }
        const rowDef = this._rowDefs.find(def => def.when && def.when(i, data)) || this._defaultRowDef;
        if (!rowDef) {
            throw getTableMissingMatchingRowDefError();
        }
        return rowDef;
    }
    /**
     * Create the embedded view for the data row template and place it in the correct index location
     * within the data row view container.
     */
    _insertRow(rowData, index) {
        const row = this._getRowDef(rowData, index);
        // Row context that will be provided to both the created embedded row view and its cells.
        const context = { $implicit: rowData };
        // TODO(andrewseguin): add some code to enforce that exactly one
        //   CdkCellOutlet was instantiated as a result  of `createEmbeddedView`.
        this._rowPlaceholder.viewContainer.createEmbeddedView(row.template, context, index);
        this._getCellTemplatesForRow(row).forEach(cell => {
            if (CellOutletDirective.mostRecentCellOutlet) {
                CellOutletDirective.mostRecentCellOutlet._viewContainer
                    .createEmbeddedView(cell.template, context);
            }
        });
        this._changeDetectorRef.markForCheck();
    }
    /**
     * Method that changes the toggled boolean value and calls the _renderUpdatedColumns method to update the table
     */
    _toggleTableContent() {
        this._toggled = !this._toggled;
        this._dataDiffer.diff([]);
        if (this._rowPlaceholder) {
            this._rowPlaceholder.viewContainer.clear();
        }
        this.renderRows();
    }
    /**
     * Updates the index-related context for each row to reflect any changes in the index of the rows,
     * e.g. first/last/even/odd.
     */
    _updateRowIndexContext() {
        const viewContainer = this._rowPlaceholder.viewContainer;
        for (let index = 0, count = viewContainer.length; index < count; index++) {
            const viewRef = viewContainer.get(index);
            viewRef.context.index = index;
            viewRef.context.count = count;
            viewRef.context.first = index === 0;
            viewRef.context.last = index === count - 1;
            viewRef.context.even = index % 2 === 0;
            viewRef.context.odd = !viewRef.context.even;
        }
    }
    /**
     * Returns the cell template definitions to insert into the header
     * as defined by its list of columns to display.
     */
    _getHeaderCellTemplatesForRow(headerDef) {
        if (!headerDef || !headerDef.columns) {
            return [];
        }
        return headerDef.columns.map(columnId => {
            const column = this._columnDefsByName.get(columnId);
            if (!column) {
                throw getTableUnknownColumnError(columnId);
            }
            return column.headerCell;
        });
    }
    /**
     * Returns the cell template definitions to insert in the provided row
     * as defined by its list of columns to display.
     */
    _getCellTemplatesForRow(rowDef) {
        if (!rowDef.columns) {
            return [];
        }
        return rowDef.columns.map(columnId => {
            const column = this._columnDefsByName.get(columnId);
            if (!column) {
                throw getTableUnknownColumnError(columnId);
            }
            return column.cell;
        });
    }
}
DataTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DataTableComponent, deps: [{ token: i0.IterableDiffers }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: 'role', attribute: true }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
DataTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DataTableComponent, selector: "bis-data-table", inputs: { loading: "loading", spinnerClasses: "spinnerClasses", breakPoint: "breakPoint", trackBy: "trackBy", collapseAtRow: "collapseAtRow", collapsedText: "collapsedText", expandedText: "expandedText", paginationConfig: "paginationConfig", dataSource: "dataSource" }, host: { properties: { "style.display": "this.display", "style.width": "this.width", "class": "this.class", "class.bis-host-data-table": "this.hostName" } }, queries: [{ propertyName: "_headerRowDef", first: true, predicate: HeaderRowDefDirective, descendants: true, static: true }, { propertyName: "_contentColumnDefs", predicate: ColumnDefDirective }, { propertyName: "_contentRowDefs", predicate: RowDefDirective }], viewQueries: [{ propertyName: "rowPlaceholder", first: true, predicate: RowPlaceholderDirective, descendants: true, static: true }, { propertyName: "_expandablePlaceholder", first: true, predicate: ExpandablePlaceholderDirective, descendants: true, static: true }, { propertyName: "_paginationPlaceholder", first: true, predicate: PaginationPlaceholderDirective, descendants: true, static: true }, { propertyName: "_headerRowPlaceholder", first: true, predicate: HeaderRowPlaceholderDirective, descendants: true, static: true }], ngImport: i0, template: `
    <div role="table" class="table table--smart table--smart-{{breakPoint}}-collapse">
      <div role="rowgroup" class="thead">
        <ng-container bisHeaderRowPlaceholder></ng-container>
      </div>
      <div role="rowgroup" class="tbody">
        <ng-container bisRowPlaceholder></ng-container>
        <bis-spinner *ngIf="loading" [class]="spinnerClasses"></bis-spinner>
      </div>
    </div>
    <ng-container bisExpandablePlaceholder></ng-container>
    <div [ngClass]="loading ? 'u-display-none' : 'u-display-block'">
      <ng-container bisPaginationPlaceholder></ng-container>
    </div>
    `, isInline: true, styles: [".bis-data-table-spinner{display:block;margin:8% auto}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "bis-spinner" }, { kind: "directive", type: RowPlaceholderDirective, selector: "[bisRowPlaceholder]" }, { kind: "directive", type: HeaderRowPlaceholderDirective, selector: "[bisHeaderRowPlaceholder]" }, { kind: "directive", type: ExpandablePlaceholderDirective, selector: "[bisExpandablePlaceholder]" }, { kind: "directive", type: PaginationPlaceholderDirective, selector: "[bisPaginationPlaceholder]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-data-table', template: `
    <div role="table" class="table table--smart table--smart-{{breakPoint}}-collapse">
      <div role="rowgroup" class="thead">
        <ng-container bisHeaderRowPlaceholder></ng-container>
      </div>
      <div role="rowgroup" class="tbody">
        <ng-container bisRowPlaceholder></ng-container>
        <bis-spinner *ngIf="loading" [class]="spinnerClasses"></bis-spinner>
      </div>
    </div>
    <ng-container bisExpandablePlaceholder></ng-container>
    <div [ngClass]="loading ? 'u-display-none' : 'u-display-block'">
      <ng-container bisPaginationPlaceholder></ng-container>
    </div>
    `, preserveWhitespaces: false, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".bis-data-table-spinner{display:block;margin:8% auto}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.IterableDiffers }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                        type: Attribute,
                        args: ['role']
                    }] }, { type: i0.ComponentFactoryResolver }];
    }, propDecorators: { display: [{
                type: HostBinding,
                args: ['style.display']
            }], width: [{
                type: HostBinding,
                args: ['style.width']
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], hostName: [{
                type: HostBinding,
                args: ['class.bis-host-data-table']
            }], loading: [{
                type: Input
            }], spinnerClasses: [{
                type: Input
            }], breakPoint: [{
                type: Input
            }], trackBy: [{
                type: Input
            }], collapseAtRow: [{
                type: Input
            }], collapsedText: [{
                type: Input
            }], expandedText: [{
                type: Input
            }], paginationConfig: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], rowPlaceholder: [{
                type: ViewChild,
                args: [RowPlaceholderDirective, { static: true }]
            }], _expandablePlaceholder: [{
                type: ViewChild,
                args: [ExpandablePlaceholderDirective, { static: true }]
            }], _paginationPlaceholder: [{
                type: ViewChild,
                args: [PaginationPlaceholderDirective, { static: true }]
            }], _headerRowPlaceholder: [{
                type: ViewChild,
                args: [HeaderRowPlaceholderDirective, { static: true }]
            }], _contentColumnDefs: [{
                type: ContentChildren,
                args: [ColumnDefDirective]
            }], _contentRowDefs: [{
                type: ContentChildren,
                args: [RowDefDirective]
            }], _headerRowDef: [{
                type: ContentChild,
                args: [HeaderRowDefDirective, { static: true }]
            }] } });

function getSortDuplicateSortableIdError(id) {
    return Error(`Cannot have two sortables with the same id (${id}).`);
}
function getSortHeaderNotContainedWithinSortError() {
    return Error(`bis-sort-header must be placed within a parent element with the bistSort directive.`);
}
function getSortHeaderMissingIdError() {
    return Error(`bis-sort-header must be provided with a unique id.`);
}
function getSortInvalidDirectionError(direction) {
    return Error(`${direction} is not a valid sort direction ('asc' or 'desc').`);
}

/** Container for MatSortables to manage the sort state and provide default sort parameters. */
class SortDirective {
    constructor() {
        /** Collection of all registered sortables that this directive manages. */
        this.sortables = new Map();
        this.initialized = new Subject();
        /** Used to notify any child components listening to state changes. */
        this._stateChanges = new Subject();
        /**
         * The direction to set when an MatSortable is initially sorted.
         * May be overriden by the MatSortable's sort start.
         */
        this.bisSortStart = 'asc';
        this._direction = '';
        this.destroySubscriptions$ = new EventEmitter();
        /** Event emitted when the user changes either the active sort or sort direction. */
        // tslint:disable-next-line:no-output-rename
        this.sortChange = new EventEmitter();
    }
    /** The sort direction of the currently active MatSortable. */
    get direction() { return this._direction; }
    set direction(direction) {
        if (isDevMode() && direction && direction !== 'asc' && direction !== 'desc') {
            throw getSortInvalidDirectionError(direction);
        }
        this._direction = direction;
        this.sortables.forEach(sortable => {
            sortable.removeSortIcons();
        });
        this.sortables.forEach(sortable => {
            if (sortable.id === this.bisSortActive) {
                sortable.addActiveClass(direction);
                sortable.sortDirection = direction;
            }
        });
    }
    /**
     * Whether to disable the user from clearing the sort by finishing the sort direction cycle.
     * May be overriden by the MatSortable's disable clear input.
     */
    get disableClear() { return this._disableClear; }
    set disableClear(v) { this._disableClear = v != null && `${v}` !== 'false'; }
    ngAfterViewInit() {
        this.sortables.forEach((sortDirective, index) => {
            sortDirective.onSortClick
                .pipe(takeUntil(this.destroySubscriptions$))
                .subscribe(this.onSortClick.bind(this, index));
        });
        this.initialized.next(undefined);
        this.initialized.complete();
    }
    resetSort() {
        this.sortables.forEach((sortDirective) => {
            sortDirective.sortDirection = '';
            sortDirective.removeSortIcons();
        });
        this.direction = '';
        this.sortChange.emit({ active: this.bisSortActive, direction: this.direction });
    }
    /**
     * Register function to be used by the contained Sortables. Adds the Sortable to the
     * collection of Sortables.
     */
    register(sortable) {
        if (!sortable.id) {
            throw getSortHeaderMissingIdError();
        }
        this.sortables.set(sortable.id, sortable);
    }
    /**
     * Unregister function to be used by the contained Sortables. Removes the Sortable from the
     * collection of contained Sortables.
     */
    deregister(sortable) {
        this.sortables.delete(sortable.id);
    }
    /** Sets the active sort id and determines the new sort direction. */
    sort(sortable) {
        if (this.bisSortActive !== sortable.id) {
            this.bisSortActive = sortable.id;
            this.direction = sortable.start ? sortable.start : this.bisSortStart;
        }
        else {
            if (!sortable.fixedSortDirection) {
                this.direction = this.getNextSortDirection(sortable);
            }
        }
        this.sortChange.emit({ active: this.bisSortActive, direction: this.direction });
    }
    /**
     * Method that itterates through the directives and clears all the sorts that are different from the las clicked element
     * @param id
     */
    onSortClick(id) {
        this.sortables.forEach((sortDirective, index) => {
            if (id !== index) {
                sortDirective.sortDirection = '';
                sortDirective.removeSortIcons();
            }
        });
    }
    /** Returns the next sort direction of the active sortable, checking for potential overrides. */
    getNextSortDirection(sortable) {
        if (!sortable) {
            return '';
        }
        // Get the sort direction cycle with the potential sortable overrides.
        const disableClear = sortable.disableClear != null ? sortable.disableClear : this.disableClear;
        const sortDirectionCycle = getSortDirectionCycle(sortable.start || this.bisSortStart, disableClear);
        // Get and return the next direction in the cycle
        let nextDirectionIndex = sortDirectionCycle.indexOf(this.direction) + 1;
        if (nextDirectionIndex >= sortDirectionCycle.length) {
            nextDirectionIndex = 0;
        }
        return sortDirectionCycle[nextDirectionIndex];
    }
    ngOnChanges() {
        this._stateChanges.next();
    }
    ngOnDestroy() {
        this._stateChanges.complete();
        this.destroySubscriptions$.next(true);
    }
}
SortDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SortDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SortDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: SortDirective, selector: "[bisSort]", inputs: { bisSortActive: "bisSortActive", bisSortStart: "bisSortStart", direction: "direction", disableClear: "disableClear" }, outputs: { sortChange: "bisSortChange" }, exportAs: ["bisSort"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SortDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[bisSort]',
                    exportAs: 'bisSort',
                }]
        }], propDecorators: { bisSortActive: [{
                type: Input
            }], bisSortStart: [{
                type: Input
            }], direction: [{
                type: Input
            }], disableClear: [{
                type: Input,
                args: ['disableClear']
            }], sortChange: [{
                type: Output,
                args: ['bisSortChange']
            }] } });
/** Returns the sort direction cycle to use given the provided parameters of order and clear. */
function getSortDirectionCycle(start, disableClear) {
    const sortOrder = ['asc', 'desc'];
    if (start === 'desc') {
        sortOrder.reverse();
    }
    if (!disableClear) {
        sortOrder.push('');
    }
    return sortOrder;
}

const SORT_DESC = 'sort--desc';
const SORT_ASC = 'sort--asc';
/**
 * Applies sorting behavior (click to change sort) and styles to an element, including an
 * arrow to display the current sort direction.
 *
 * Must be provided with an id and contained within a parent bisSort directive.
 *
 * If used on header cells in a CdkTable, it will automatically default its id from its containing
 * column definition.
 */
class SortHeaderComponent {
    constructor(renderer, elRef, _sort, columnDefDirective) {
        this.renderer = renderer;
        this.elRef = elRef;
        this._sort = _sort;
        this.columnDefDirective = columnDefDirective;
        /** Sets the position of the arrow that displays when sorted. */
        this.arrowPosition = 'after';
        this.onSortClick = new EventEmitter();
        if (!_sort) {
            throw getSortHeaderNotContainedWithinSortError();
        }
    }
    /** Overrides the disable clear value of the containing bisSort for this MatSortable. */
    get disableClear() { return this._disableClear; }
    set disableClear(v) { this._disableClear = v != null && `${v}` !== 'false'; }
    onClick() {
        this._handleClick();
    }
    mouseEnter() {
        this._setIndicatorHintVisible(true);
    }
    mouseLeave() {
        this._setIndicatorHintVisible(false);
    }
    ngOnInit() {
        if (!this.id && this.columnDefDirective) {
            this.id = this.columnDefDirective.name;
        }
        this._sort.register(this);
    }
    ngOnDestroy() {
        this._sort.deregister(this);
    }
    /**
     * Handles the adding and removing of the asc and desc classes according to weather or not
     * the sort is active, only works on moseover (in and out)
     * @param visible boolean true if it's mose enter, false if it's mouse leave
     */
    _setIndicatorHintVisible(visible) {
        if (visible) {
            if (this.sortDirection === 'asc') {
                this.renderer.addClass(this._sortIconRef.nativeElement, SORT_DESC);
                return;
            }
            this.renderer.addClass(this._sortIconRef.nativeElement, SORT_ASC);
        }
        else {
            if (this.sortDirection === 'asc') {
                this.renderer.removeClass(this._sortIconRef.nativeElement, SORT_DESC);
                return;
            }
            this.renderer.removeClass(this._sortIconRef.nativeElement, SORT_ASC);
        }
    }
    addActiveClass(order) {
        this.removeSortIcons();
        if (order === 'desc') {
            this.renderer.addClass(this._sortIconRef.nativeElement, SORT_DESC);
        }
        else if (order === 'asc') {
            this.renderer.addClass(this._sortIconRef.nativeElement, SORT_ASC);
        }
    }
    /**
     * Triggers the sort on this sort header.
     * */
    _handleClick() {
        this._sort.sort(this);
        this.sortDirection = this._sort.direction;
        this.onSortClick.emit();
        this.removeSortIcons();
        switch (this._sort.direction) {
            case 'asc': {
                this.renderer.addClass(this._sortIconRef.nativeElement, SORT_ASC);
                break;
            }
            case 'desc': {
                this.renderer.addClass(this._sortIconRef.nativeElement, SORT_DESC);
                break;
            }
        }
    }
    /**
     * Method that removes the sort-asc and desc classes from the host element
    */
    removeSortIcons() {
        this.renderer.removeClass(this._sortIconRef.nativeElement, SORT_ASC);
        this.renderer.removeClass(this._sortIconRef.nativeElement, SORT_DESC);
    }
}
SortHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SortHeaderComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: SortDirective, optional: true }, { token: ColumnDefDirective, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SortHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: SortHeaderComponent, selector: "bis-sort-header", inputs: { disabled: "disabled", id: ["bis-sort-header", "id"], arrowPosition: "arrowPosition", start: "start", disableClear: "disableClear" }, host: { listeners: { "click": "onClick()", "mouseenter": "mouseEnter()", "mouseleave": "mouseLeave()" } }, viewQueries: [{ propertyName: "_sortIconRef", first: true, predicate: ["sortIcon"], descendants: true, static: true }], exportAs: ["bisSortHeader"], ngImport: i0, template: `
    <span class="sort" #sortIcon></span>
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{cursor:pointer}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SortHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-sort-header', exportAs: 'bisSortHeader', inputs: ['disabled'], template: `
    <span class="sort" #sortIcon></span>
    <ng-content></ng-content>
  `, styles: [":host{cursor:pointer}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: SortDirective, decorators: [{
                        type: Optional
                    }] }, { type: ColumnDefDirective, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { id: [{
                type: Input,
                args: ['bis-sort-header']
            }], arrowPosition: [{
                type: Input
            }], start: [{
                type: Input
            }], disableClear: [{
                type: Input
            }], _sortIconRef: [{
                type: ViewChild,
                args: ['sortIcon', { static: true }]
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }], mouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], mouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class IconFieldComponent {
    constructor() {
        this.vertical = false;
        this.collapseClassName = {};
    }
    ngOnChanges() {
        this.setCollapseClassname();
    }
    /**
     * Method used to set the collapse class based on input provided on the attribute binding on the selector
     */
    setCollapseClassname() {
        if (this.collapseVertical) {
            this.collapseClassName[`icon-field--vertical-${this.collapseVertical}-collapse`] = true;
        }
    }
}
IconFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: IconFieldComponent, selector: "bis-icon-field", inputs: { iconClasses: "iconClasses", vertical: "vertical", collapseVertical: ["collapse-vertical", "collapseVertical"] }, usesOnChanges: true, ngImport: i0, template: `
    <span class="icon-field" [ngClass]="collapseClassName" [class.icon-field--vertical]="vertical">
      <i class="icon-field__icon {{iconClasses}}"></i>
      <span class="icon-field__text">
        <ng-content></ng-content>
      </span>
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-icon-field',
                    template: `
    <span class="icon-field" [ngClass]="collapseClassName" [class.icon-field--vertical]="vertical">
      <i class="icon-field__icon {{iconClasses}}"></i>
      <span class="icon-field__text">
        <ng-content></ng-content>
      </span>
    </span>
  `,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { iconClasses: [{
                type: Input
            }], vertical: [{
                type: Input
            }], collapseVertical: [{
                type: Input,
                args: ['collapse-vertical']
            }] } });
class IconComponent {
    constructor() {
        this.hostName = true;
        this.classes = {};
    }
    ngOnChanges() {
        this.setClasses();
    }
    /**
     * Method used to check if there were inputs passed in and set classes accordingly
     */
    setClasses() {
        this.classes['icon'] = true;
        this.removeOldIcon();
        this.classes[`${IconComponent.ICON_PREFIX}${this.icon}`] = true;
        if (this.size) {
            this.classes[`${IconComponent.ICON_PREFIX}${this.size}`] = true;
        }
        if (this.elementType) {
            this.setElementTypeClass(this.elementType);
        }
    }
    removeOldIcon() {
        Object.keys(this.classes).forEach(key => {
            if (key.indexOf(IconComponent.ICON_PREFIX) !== -1) {
                delete this.classes[key];
            }
        });
    }
    /**
     * Method used to set classes based on elementType provided
     * @param elementType
     */
    setElementTypeClass(elementType) {
        if (elementType === 'btn') {
            this.classes['btn__icon'] = true;
        }
    }
}
IconComponent.ICON_PREFIX = 'icon--';
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: IconComponent, selector: "bis-icon", inputs: { size: "size", icon: "icon", elementType: ["element-type", "elementType"] }, host: { properties: { "class.bis-host-icon": "this.hostName" } }, usesOnChanges: true, ngImport: i0, template: `
    <i [ngClass]="classes"></i>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-icon',
                    template: `
    <i [ngClass]="classes"></i>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { hostName: [{
                type: HostBinding,
                args: ['class.bis-host-icon']
            }], size: [{
                type: Input
            }], icon: [{
                type: Input
            }], elementType: [{
                type: Input,
                args: ['element-type']
            }] } });

class IconFieldModule {
}
IconFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: IconFieldModule, declarations: [IconFieldComponent,
        IconComponent], imports: [CommonModule], exports: [IconFieldComponent,
        IconComponent] });
IconFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconFieldModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: IconFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        IconFieldComponent,
                        IconComponent
                    ],
                    exports: [
                        IconFieldComponent,
                        IconComponent
                    ]
                }]
        }] });

class PaginationModule {
    static forRoot() {
        return {
            ngModule: PaginationModule
        };
    }
}
PaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: PaginationModule, declarations: [PaginationComponent], imports: [CommonModule], exports: [PaginationComponent] });
PaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        PaginationComponent
                    ],
                    exports: [
                        PaginationComponent
                    ]
                }]
        }] });

class SpinnerModule {
}
SpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: SpinnerModule, declarations: [SpinnerComponent], exports: [SpinnerComponent] });
SpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SpinnerModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [SpinnerComponent],
                    declarations: [SpinnerComponent],
                    providers: [],
                }]
        }] });

const exportsAndDeclarations$1 = [
    RowPlaceholderDirective,
    HeaderRowPlaceholderDirective,
    DataTableComponent,
    CellDefDirective,
    ColumnDefDirective,
    HeaderCellDefDirective,
    HeaderRowDefDirective,
    CellOutletDirective,
    CellComponent,
    HeaderCellComponent,
    RowDefDirective,
    TableRowComponent,
    HeaderRowComponent,
    SortDirective,
    SortHeaderComponent,
    TableFooterComponent,
    ExpandablePlaceholderDirective,
    PaginationPlaceholderDirective
];
class DataTableModule {
}
DataTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: DataTableModule, declarations: [RowPlaceholderDirective,
        HeaderRowPlaceholderDirective,
        DataTableComponent,
        CellDefDirective,
        ColumnDefDirective,
        HeaderCellDefDirective,
        HeaderRowDefDirective,
        CellOutletDirective,
        CellComponent,
        HeaderCellComponent,
        RowDefDirective,
        TableRowComponent,
        HeaderRowComponent,
        SortDirective,
        SortHeaderComponent,
        TableFooterComponent,
        ExpandablePlaceholderDirective,
        PaginationPlaceholderDirective], imports: [CommonModule, SpinnerModule, IconFieldModule, PaginationModule, ButtonModule], exports: [RowPlaceholderDirective,
        HeaderRowPlaceholderDirective,
        DataTableComponent,
        CellDefDirective,
        ColumnDefDirective,
        HeaderCellDefDirective,
        HeaderRowDefDirective,
        CellOutletDirective,
        CellComponent,
        HeaderCellComponent,
        RowDefDirective,
        TableRowComponent,
        HeaderRowComponent,
        SortDirective,
        SortHeaderComponent,
        TableFooterComponent,
        ExpandablePlaceholderDirective,
        PaginationPlaceholderDirective] });
DataTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DataTableModule, imports: [CommonModule, SpinnerModule, IconFieldModule, PaginationModule, ButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SpinnerModule, IconFieldModule, PaginationModule, ButtonModule],
                    exports: [exportsAndDeclarations$1],
                    declarations: [exportsAndDeclarations$1],
                    providers: []
                }]
        }] });

const translations = {
    sv: {
        days: ['Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön'],
        months: [
            'Januari',
            'Februari',
            'Mars',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'Augusti',
            'September',
            'Oktober',
            'November',
            'December'
        ]
    },
    en: {
        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    },
    de: {
        days: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        months: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember'
        ]
    },
    da: {
        days: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn'],
        months: [
            'Januar',
            'Februar',
            'Marts',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'December'
        ]
    },
    no: {
        days: ['Man', 'Tirs', 'Ons', 'Tors', 'Fre', 'Lør', 'Søn'],
        months: [
            'Januar',
            'Februar',
            'Mars',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Desember'
        ]
    }
};
let getTranslation = (lang) => {
    switch (lang) {
        case 'sv':
        case 'SV':
            return translations.sv;
        case 'de':
        case 'DE':
            return translations.de;
        case 'da':
        case 'DA':
            return translations.da;
        case 'no':
        case 'NO':
            return translations.no;
        default:
            return translations.en;
    }
};

class DatePickerComponent {
    constructor(elRef) {
        this.elRef = elRef;
        /**
         * This field contains the flag, if the minDate input is a Date.
         */
        this.minDateIsDate = false;
        /**
         * This field contains the flag, if the maxDate input is a Date.
         */
        this.maxDateIsDate = false;
        this._maxDate = null;
        this._minDate = null;
        this._lang = 'en';
        this._format = DatePickerComponent.DEFAULT_FORMAT;
        this._viewFormat = DatePickerComponent.DEFAULT_FORMAT;
        this.today = new Date();
        this.oldDate = null;
        this.date = null;
        this.displayDate = null;
        this.hasInvalidInput = false;
        this.translation = getTranslation(this._lang);
        this.valueChange = new EventEmitter();
        this.calendarVisibilityChange = new EventEmitter();
        this.placeholder = '';
        this.alignRight = false;
        this.width = '19rem';
        this.disabled = false;
        this.onTouchedCallback = () => {
        };
        this.onChangeCallback = () => {
        };
    }
    get lang() {
        return this._lang;
    }
    /**
     * Sets the language used for translations to the datepicker
     */
    set lang(lang) {
        if (lang && this._lang !== lang) {
            this._lang = lang;
            this.translation = getTranslation(lang);
            this.generateCalendar();
        }
    }
    get format() {
        return this._format;
    }
    set format(format) {
        this._format = this.createUnicodeConvertedFormat(format);
    }
    get viewFormat() {
        return this._viewFormat;
    }
    set viewFormat(viewFormat) {
        this._viewFormat = this.createUnicodeConvertedFormat(viewFormat);
    }
    get maxDate() {
        if (this.maxDateIsDate) {
            return parse(this._maxDate, this.format, new Date());
        }
        return this._maxDate;
    }
    /**
     * Max date until the calendar is selectable
     */
    set maxDate(value) {
        this.maxDateIsDate = value instanceof Date;
        if (typeof value === 'string') {
            value = parse(value, this.format, new Date());
        }
        this._maxDate = value ? format(value, this.format) : null;
        this.generateCalendar();
    }
    get minDate() {
        if (this.minDateIsDate) {
            return parse(this._minDate, this.format, new Date());
        }
        return this._minDate;
    }
    /**
     * Mindate until the calendar is selectable
     */
    set minDate(value) {
        this.minDateIsDate = value instanceof Date;
        if (typeof value === 'string') {
            value = parse(value, this.format, new Date());
        }
        this._minDate = value ? format(value, this.format) : null;
        this.generateCalendar();
    }
    get open() {
        return this._open;
    }
    set open(newValue) {
        this._open = newValue;
        this.calendarVisibilityChange.emit(this._open);
    }
    requireDate() {
        if (!this.date) {
            const selectedDate = parse(this.displayDate, this.viewFormat, new Date());
            this.date = this.displayDate ? selectedDate : this.today;
        }
        return this.date;
    }
    /**
     * Methods used by the ControlValueAccessor
     */
    writeValue(value) {
        if (value) {
            const date = parse(value, this.format, new Date());
            const parsedDisplayDate = parse(value, this.viewFormat, new Date());
            this.displayDate = format(date, this.viewFormat);
            this.oldDate = new Date(parsedDisplayDate);
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /**
     * Method used to open the calendar body and generate the dates
     */
    openCalendar() {
        this.open = true;
        this.generateCalendar();
    }
    /**
     * Method used to clear the input value of the calendar
     */
    clear() {
        this.displayDate = null;
        this.emitDisplayDate();
    }
    /**
     * Method that is used to create a date based on the day and week selected
     */
    selectDate(event, week, day) {
        event.preventDefault();
        const calendarDate = this.weeks[week].days[day];
        if (!calendarDate.enabled) {
            return;
        }
        const selectedDate = parse(`${calendarDate.day}.${calendarDate.month}.${calendarDate.year}`, 'dd.MM.yyyy', new Date());
        this.displayDate = format(selectedDate, this.viewFormat);
        this.updateDate();
    }
    generateCalendar() {
        const selectedDate = parse(this.displayDate, this.viewFormat, new Date());
        const currentMonth = getMonth(this.requireDate());
        const currentYear = getYear(this.requireDate());
        const days = [];
        const startDayCount = getISODay(startOfMonth(this.requireDate())) - 1;
        const daysInMonth = getDaysInMonth(this.requireDate());
        for (let day = 0; day < startDayCount; day++) {
            days.push({
                day: null,
                month: null,
                year: null,
                enabled: false,
                today: false,
                selected: false
            });
        }
        for (let day = 1; day <= daysInMonth; day++) {
            const dateToCompare = new Date(currentYear, currentMonth, day);
            days.push({
                day,
                month: currentMonth + 1,
                year: currentYear,
                enabled: this.enableBefore(dateToCompare) && this.enableAfter(dateToCompare),
                today: isToday(dateToCompare),
                selected: isSameDay(selectedDate, dateToCompare)
            });
        }
        let currentDayInWeek = 0;
        let currentWeek = 0;
        this.weeks = [];
        days.forEach((day) => {
            if (currentDayInWeek === 0) {
                this.weeks.push(({ days: [] }));
            }
            this.weeks[currentWeek].days.push(day);
            if (currentDayInWeek === 6) {
                currentDayInWeek = 0;
                currentWeek++;
            }
            else {
                currentDayInWeek++;
            }
        });
    }
    /**
     * Currently this feature is disabled.
     * On enter when the input is changed by the user manually it sends the data to the component.
     *
     * @param event the KeyboardEvent, not {@code null}
     */
    updateDate(event) {
        this.open = false;
        this.date = parse(this.displayDate, this.viewFormat, new Date());
        const isInvalidDate = this.isInvalidDate(this.date);
        if (isInvalidDate || !this.isSameDayOrAfterMinDate(this.date) || !this.isSameDayOrBeforeMaxDate(this.date)) {
            this.date = this.oldDate;
            this.hasInvalidInput = !!this.displayDate && isInvalidDate;
            return;
        }
        this.hasInvalidInput = false;
        if (this.oldDate && this.date && isSameDay(this.oldDate, this.date)) {
            return;
        }
        this.emitDisplayDate();
    }
    /**
     * Method used to check if the minDate is present and returns false if the given date is smaller than the minDate.
     *
     * @param dateToCompare the {@code Date} to compare or {@code null}
     */
    enableBefore(dateToCompare) {
        if (!this.minDate || (!this.minDate && !dateToCompare)) {
            return true;
        }
        else if (!dateToCompare) {
            return false;
        }
        return this.isSameDayOrAfterMinDate(dateToCompare);
    }
    isSameDayOrAfterMinDate(dateToCompare) {
        if (!this._minDate) {
            return true;
        }
        const parsedMinDate = parse(this._minDate, this.format, new Date());
        return isSameDay(parsedMinDate, dateToCompare) || isBefore(parsedMinDate, dateToCompare);
    }
    /**
     * Method used to check if maxDate is present and returns false if the given date is bigger than the maxDate.
     *
     * @param dateToCompare the {@code Date} to compare or {@code null}
     */
    enableAfter(dateToCompare) {
        if (!this.maxDate || (!this.maxDate && !dateToCompare)) {
            return true;
        }
        else if (!dateToCompare) {
            return false;
        }
        return this.isSameDayOrBeforeMaxDate(dateToCompare);
    }
    isSameDayOrBeforeMaxDate(dateToCompare) {
        if (!this._maxDate) {
            return true;
        }
        const parsedMaxDate = parse(this._maxDate, this.format, new Date());
        return isSameDay(parsedMaxDate, dateToCompare) || isAfter(parsedMaxDate, dateToCompare);
    }
    /**
     * This method creates an Unicode converted format. The date-fns library is using Uniceode Tokens
     * for formatting and parsing: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * @param formatToConvert the format, which should be converted into an Unicode format or {@code null}
     */
    createUnicodeConvertedFormat(formatToConvert) {
        if (!formatToConvert) {
            return DatePickerComponent.DEFAULT_FORMAT;
        }
        return formatToConvert.replace(/Y/g, 'y').replace(/D/g, 'd');
    }
    getCurrentMonth() {
        return getMonth(this.requireDate());
    }
    formatCurrentYear() {
        if (this.isInvalidDate(this.requireDate())) {
            return DatePickerComponent.INVALID_DATE;
        }
        return format(this.requireDate(), 'yyyy');
    }
    /**
     * This method is checking, if {@code this.date} is a valid date.
     */
    isInvalidDate(invalidDate) {
        return !invalidDate || invalidDate.toString() === DatePickerComponent.INVALID_DATE;
    }
    /**
     * Method used to substract one month from the current date and generate the calendar accordingly
     */
    prevMonth() {
        this.date = subMonths(this.requireDate(), 1);
        this.generateCalendar();
    }
    /**
     * Method used to increase the current month by one and generate the new calendar
     */
    nextMonth() {
        this.date = addMonths(this.requireDate(), 1);
        this.generateCalendar();
    }
    /**
     * This method formats the {@code displayDate} to the internal format and emits it to the listeners.
     */
    emitDisplayDate() {
        let result = this.displayDate;
        this.oldDate = null;
        if (this.displayDate) {
            const parsedDisplayDate = parse(this.displayDate, this.viewFormat, new Date());
            if (!this.isInvalidDate(parsedDisplayDate)) {
                result = format(parsedDisplayDate, this.format);
                this.oldDate = new Date(parsedDisplayDate);
            }
        }
        this.onChangeCallback(result);
        this.valueChange.emit(result);
        this.generateCalendar();
    }
    changeHandler(event) {
        if (!event.target.value.length) {
            this.displayDate = null;
            this.emitDisplayDate();
        }
    }
    /**
     * Method used to check for where the click has occured so that the calendar is closed when the click
     * occured outside the element.
     * @param event
     * @param targetElement
     */
    onClick(event, targetElement) {
        if (!targetElement) {
            return;
        }
        const clickedInside = this.elRef.nativeElement.contains(targetElement);
        if (!clickedInside && this.open) {
            // Update internal date in case of manual input of the date occured
            this.updateDate();
        }
    }
}
DatePickerComponent.DEFAULT_FORMAT = 'yyyy-MM-dd';
DatePickerComponent.INVALID_DATE = 'Invalid Date';
DatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DatePickerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DatePickerComponent, selector: "bis-date-picker", inputs: { placeholder: "placeholder", alignRight: "alignRight", width: "width", disabled: "disabled", firstWeekdaySunday: "firstWeekdaySunday", lang: "lang", format: "format", viewFormat: "viewFormat", maxDate: "maxDate", minDate: "minDate", open: "open" }, outputs: { valueChange: "valueChange", calendarVisibilityChange: "calendarVisibilityChange" }, host: { listeners: { "document:click": "onClick($event,$event.target)" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: DatePickerComponent, multi: true }], ngImport: i0, template: "<div class=\"datepicker\" [style.width]=\"width\">\n  <input type=\"text\"\n         #inputDate\n         [class.form-control--error]=\"hasInvalidInput\"\n         [placeholder]=\"placeholder\"\n         class=\"form-control form-control--date\"\n         (click)=\"openCalendar()\"\n         (input)=\"changeHandler($event)\"\n         [(ngModel)]=\"displayDate\"\n         [ngModelOptions]=\"{standalone: true}\"\n         (keydown.enter)=\"updateDate()\"\n         [disabled]=\"disabled\">\n  <div class=\"datepicker-body\" [class.datepicker-body--open]=\"open\" [class.datepicker-body--align-right]=\"alignRight\" style=\"top: 45px\">\n    <div class=\"datepicker-header\">\n      <button class=\"datepicker-header__previous\" (click)=\"prevMonth()\">\n        <span class=\"icon icon--left\"></span>\n      </button>\n      <div class=\"datepicker-header__title\">{{ translation.months[getCurrentMonth()]}}, {{formatCurrentYear()}}</div>\n      <button class=\"datepicker-header__next\" (click)=\"nextMonth()\">\n        <span class=\"icon icon--right\"></span>\n      </button>\n    </div>\n    <table class=\"datepicker-table\">\n      <tbody>\n        <tr>\n          <th *ngFor=\"let day of translation.days\" class=\"weekday\">{{day}}</th>\n        </tr>\n        <tr *ngFor=\"let week of weeks; let w = index;\">\n          <td *ngFor=\"let day of week.days; let d = index;\"\n              class=\"date\"\n              (click)=\"selectDate($event, w, d)\"\n              [class.date--today]=\"day.today\"\n              [class.date--disabled]=\"!day.enabled\"\n              [class.date--active]=\"day.selected\">{{ day.day }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n", styles: [".form-control--date:valid{color:inherit}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-date-picker', encapsulation: ViewEncapsulation.None, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: DatePickerComponent, multi: true }], template: "<div class=\"datepicker\" [style.width]=\"width\">\n  <input type=\"text\"\n         #inputDate\n         [class.form-control--error]=\"hasInvalidInput\"\n         [placeholder]=\"placeholder\"\n         class=\"form-control form-control--date\"\n         (click)=\"openCalendar()\"\n         (input)=\"changeHandler($event)\"\n         [(ngModel)]=\"displayDate\"\n         [ngModelOptions]=\"{standalone: true}\"\n         (keydown.enter)=\"updateDate()\"\n         [disabled]=\"disabled\">\n  <div class=\"datepicker-body\" [class.datepicker-body--open]=\"open\" [class.datepicker-body--align-right]=\"alignRight\" style=\"top: 45px\">\n    <div class=\"datepicker-header\">\n      <button class=\"datepicker-header__previous\" (click)=\"prevMonth()\">\n        <span class=\"icon icon--left\"></span>\n      </button>\n      <div class=\"datepicker-header__title\">{{ translation.months[getCurrentMonth()]}}, {{formatCurrentYear()}}</div>\n      <button class=\"datepicker-header__next\" (click)=\"nextMonth()\">\n        <span class=\"icon icon--right\"></span>\n      </button>\n    </div>\n    <table class=\"datepicker-table\">\n      <tbody>\n        <tr>\n          <th *ngFor=\"let day of translation.days\" class=\"weekday\">{{day}}</th>\n        </tr>\n        <tr *ngFor=\"let week of weeks; let w = index;\">\n          <td *ngFor=\"let day of week.days; let d = index;\"\n              class=\"date\"\n              (click)=\"selectDate($event, w, d)\"\n              [class.date--today]=\"day.today\"\n              [class.date--disabled]=\"!day.enabled\"\n              [class.date--active]=\"day.selected\">{{ day.day }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n", styles: [".form-control--date:valid{color:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { valueChange: [{
                type: Output
            }], calendarVisibilityChange: [{
                type: Output
            }], placeholder: [{
                type: Input
            }], alignRight: [{
                type: Input
            }], width: [{
                type: Input
            }], disabled: [{
                type: Input
            }], firstWeekdaySunday: [{
                type: Input
            }], lang: [{
                type: Input
            }], format: [{
                type: Input
            }], viewFormat: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], minDate: [{
                type: Input
            }], open: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event', '$event.target']]
            }] } });

class DatePickerModule {
}
DatePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DatePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: DatePickerModule, declarations: [DatePickerComponent], imports: [CommonModule,
        FormsModule], exports: [DatePickerComponent] });
DatePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DatePickerModule, imports: [CommonModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    exports: [DatePickerComponent],
                    declarations: [DatePickerComponent],
                    providers: [],
                }]
        }] });

const template = '<ng-content></ng-content>';
class SetDisplayBlock {
    constructor() {
        this.display = 'block';
    }
}
SetDisplayBlock.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SetDisplayBlock, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SetDisplayBlock.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: SetDisplayBlock, host: { properties: { "style.display": "this.display" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SetDisplayBlock, decorators: [{
            type: Directive
        }], propDecorators: { display: [{
                type: HostBinding,
                args: ['style.display']
            }] } });
class DialogHeaderComponent extends SetDisplayBlock {
    constructor() {
        super(...arguments);
        this.modalHeader = true;
    }
}
DialogHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogHeaderComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
DialogHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DialogHeaderComponent, selector: "bis-dialog-header", host: { properties: { "class.modal__header": "this.modalHeader" } }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `bis-dialog-header`,
                    template
                }]
        }], propDecorators: { modalHeader: [{
                type: HostBinding,
                args: ['class.modal__header']
            }] } });
class DialogSectionComponent extends SetDisplayBlock {
    constructor() {
        super(...arguments);
        this.modalSection = true;
    }
}
DialogSectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogSectionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
DialogSectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DialogSectionComponent, selector: "bis-dialog-section", host: { properties: { "class.modal__section": "this.modalSection" } }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `bis-dialog-section`,
                    template
                }]
        }], propDecorators: { modalSection: [{
                type: HostBinding,
                args: ['class.modal__section']
            }] } });
class DialogFooterComponent extends SetDisplayBlock {
    constructor() {
        super(...arguments);
        this.modalFooter = true;
        this.clearFix = true;
    }
}
DialogFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogFooterComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
DialogFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DialogFooterComponent, selector: "bis-dialog-footer", host: { properties: { "class.modal__footer": "this.modalFooter", "class.u-clearfix": "this.clearFix" } }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: `bis-dialog-footer`,
                    template
                }]
        }], propDecorators: { modalFooter: [{
                type: HostBinding,
                args: ['class.modal__footer']
            }], clearFix: [{
                type: HostBinding,
                args: ['class.u-clearfix']
            }] } });
class DialogButtonContainerComponent {
    constructor() {
        this.modalButtonContainer = true;
    }
}
DialogButtonContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogButtonContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DialogButtonContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DialogButtonContainerComponent, selector: "bis-dialog-button-container", host: { properties: { "class.modal__btn-container": "this.modalButtonContainer" } }, ngImport: i0, template: "<ng-content></ng-content>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogButtonContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-dialog-button-container',
                    template
                }]
        }], propDecorators: { modalButtonContainer: [{
                type: HostBinding,
                args: ['class.modal__btn-container']
            }] } });

class DialogConfig {
    constructor() {
        this.disableClose = true;
        this.hasBackdrop = true;
        this.disableModalWrapper = false;
        this.scrollable = false;
        this.closeOnOutsideClick = false;
        this.size = {
            small: false,
            medium: false,
            large: false
        };
        /** Data being injected into the child component. */
        this.data = null;
    }
}

class DialogContainerComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
    }
    attach(component, injector) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = this.viewContainerRef.createComponent(componentFactory, this.viewContainerRef.length, injector);
        this.viewContainerRef.insert(componentRef.hostView);
        return componentRef;
    }
}
DialogContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogContainerComponent, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
DialogContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DialogContainerComponent, selector: "bis-modal-container", viewQueries: [{ propertyName: "viewContainerRef", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `
    <div [class.modal]="!config.disableModalWrapper"
          [class.modal--small]="config.size.small"
          [class.modal--medium]="config.size.medium"
          [class.modal--large]="config.size.large"
          [class.modal--scroll]="config.scrollable">
      <ng-template #container></ng-template>
    </div>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-modal-container',
                    template: `
    <div [class.modal]="!config.disableModalWrapper"
          [class.modal--small]="config.size.small"
          [class.modal--medium]="config.size.medium"
          [class.modal--large]="config.size.large"
          [class.modal--scroll]="config.scrollable">
      <ng-template #container></ng-template>
    </div>`
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; }, propDecorators: { viewContainerRef: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef, static: true }]
            }] } });

class DialogInjector {
    constructor(_parentInjector, _customTokens) {
        this._parentInjector = _parentInjector;
        this._customTokens = _customTokens;
    }
    get(token, notFoundValue) {
        const value = this._customTokens.get(token);
        if (typeof value !== 'undefined') {
            return value;
        }
        return this._parentInjector.get(token, notFoundValue);
    }
}

class BackdropConfig {
    constructor(config) {
        this.disableScroll = true;
        /** Class to add to the backdrop */
        this.backdropClass = 'modal-backdrop';
        /** Class to add to the backdrop to notify it's open*/
        this.backdropOpenClass = ' modal-backdrop--open';
        /** Class to add to set <body> element to overflow: hidden */
        this.bodyNoScrollClass = 'no-scroll';
        config = config || {};
        this.disableScroll = (typeof config.hasBackdrop === 'undefined') ? true : config.hasBackdrop;
    }
}

class BackdropRef {
    constructor(backdropHTMLElement, config, injector, applicationRef, componentFactoryResolver, document, ngZone) {
        this.backdropHTMLElement = backdropHTMLElement;
        this.config = config;
        this.injector = injector;
        this.applicationRef = applicationRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.document = document;
        this.ngZone = ngZone;
        this._disposeFn = null;
        this._backdropClick = new Subject();
        this.scrollBlock = null;
    }
    getBackdropHTMLElement() {
        return this.backdropHTMLElement;
    }
    attach(component) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = componentFactory.create(this.injector);
        this.applicationRef.attachView(componentRef.hostView);
        this._disposeFn = () => {
            this.applicationRef.detachView(componentRef.hostView);
            componentRef.destroy();
        };
        this.backdropHTMLElement.appendChild(this.getComponentRootNode(componentRef));
        this.attachBackdropEvents();
        return componentRef;
    }
    detach() {
        this.detachBackdrop();
        if (this._disposeFn) {
            this._disposeFn();
            this._disposeFn = null;
            this._backdropClick.complete();
        }
    }
    attachBackdropEvents() {
        if (this.config.disableScroll) {
            this.document.body.classList.add('no-scroll');
        }
        this.backdropHTMLElement.addEventListener('click', (event) => {
            if (event.target.dataset.modalBackdrop) {
                this._backdropClick.next(event);
            }
        });
    }
    detachBackdrop() {
        this.document.body.classList.remove('no-scroll');
        const elementToDetach = this.backdropHTMLElement.parentNode;
        if (elementToDetach) {
            const detach = () => {
                if (elementToDetach && elementToDetach.parentNode) {
                    elementToDetach.parentNode.removeChild(elementToDetach);
                }
                this.backdropHTMLElement = null;
            };
            this.ngZone.runOutsideAngular(() => {
                setTimeout(detach, 0);
            });
        }
    }
    /** Gets an observable that emits when the backdrop has been clicked. */
    backdropClick() {
        return this._backdropClick.asObservable();
    }
    /** Gets the root HTMLElement for an instantiated component. */
    getComponentRootNode(componentRef) {
        return componentRef.hostView.rootNodes[0];
    }
}

class BackdropContainer {
    constructor(document) {
        this.document = document;
    }
    getBackdropContainerHTMLElement() {
        this.createBackdropContainerHTMLElement();
        return this.backdropContainerHTMLElement;
    }
    createBackdropContainerHTMLElement() {
        const element = this.document.createElement('div');
        element.classList.add('modal-backdrop-container');
        this.document.body.appendChild(element);
        this.backdropContainerHTMLElement = element;
    }
    ngOnDestroy() {
        if (this.backdropContainerHTMLElement && this.backdropContainerHTMLElement.parentNode) {
            this.backdropContainerHTMLElement.parentNode.removeChild(this.backdropContainerHTMLElement);
        }
    }
}
BackdropContainer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BackdropContainer, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
BackdropContainer.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BackdropContainer });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BackdropContainer, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }];
    } });

class Backdrop {
    constructor(backdropContainer, applicationRef, injector, ngZone, componentFactoryResolver, document) {
        this.backdropContainer = backdropContainer;
        this.applicationRef = applicationRef;
        this.injector = injector;
        this.ngZone = ngZone;
        this.componentFactoryResolver = componentFactoryResolver;
        this.document = document;
    }
    create(config = new BackdropConfig()) {
        const backdropElement = this.createBackdropHTMLElement();
        return new BackdropRef(backdropElement, config, this.injector, this.applicationRef, this.componentFactoryResolver, this.document, this.ngZone);
    }
    createBackdropHTMLElement() {
        /**
         * we need the backdrop to create an HTML element that will be appended do the DOM
         * there is no other way to append a child
         */
        const backdropElement = this.document.createElement('div');
        backdropElement.classList.add('modal-backdrop');
        backdropElement.classList.add('modal-backdrop--open');
        backdropElement.dataset.modalBackdrop = 'true';
        this.backdropContainer.getBackdropContainerHTMLElement().appendChild(backdropElement);
        return backdropElement;
    }
}
Backdrop.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: Backdrop, deps: [{ token: BackdropContainer }, { token: i0.ApplicationRef }, { token: i0.Injector }, { token: i0.NgZone }, { token: i0.ComponentFactoryResolver }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
Backdrop.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: Backdrop });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: Backdrop, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: BackdropContainer }, { type: i0.ApplicationRef }, { type: i0.Injector }, { type: i0.NgZone }, { type: i0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }];
    } });

class DialogRef {
    constructor(backdropRef, dialogContainer) {
        this.backdropRef = backdropRef;
        this.dialogContainer = dialogContainer;
        this.onClose$ = new EventEmitter();
    }
    close() {
        this.onClose$.emit(true);
        this.backdropRef.detach();
    }
}

const DIALOG_DATA = new InjectionToken('DialogData');
class DialogService {
    constructor(backdrop, injector, location) {
        this.backdrop = backdrop;
        this.injector = injector;
        this.location = location;
        this.defaultConfig = {
            disableClose: true,
            hasBackdrop: true,
            scrollable: false,
            closeOnOutsideClick: false,
            size: {
                small: false,
                medium: false,
                large: false,
            }
        };
        this.location.onPopState(() => this.close());
    }
    close() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
    open(component, config = new DialogConfig()) {
        config = Object.assign(Object.assign({}, this.defaultConfig), config);
        const backdropRef = this.backdrop.create(new BackdropConfig());
        const dialogContainer = this.attachDialogContainer(backdropRef, config);
        dialogContainer.config = config;
        return this.attachDialogContent(component, backdropRef, dialogContainer, config);
    }
    attachDialogContent(component, backdropRef, dialogContainer, config) {
        const dialogRef = new DialogRef(backdropRef, dialogContainer);
        const injector = this.createDialogInjector(dialogRef, dialogContainer, config);
        const componentRef = dialogContainer.attach(component, injector);
        dialogRef.componentInstance = componentRef.instance;
        // When the dialog backdrop is clicked, we want to close it.
        if (config.hasBackdrop) {
            backdropRef.backdropClick().subscribe(() => {
                if (config.closeOnOutsideClick || !config.disableClose) {
                    dialogRef.close();
                }
            });
        }
        this.dialogRef = dialogRef;
        this.dialogRef.onClose$.subscribe(() => this.dialogRef = null);
        return dialogRef;
    }
    attachDialogContainer(backdropRef, config) {
        const containerRef = backdropRef.attach(DialogContainerComponent);
        containerRef.instance.config = config;
        return containerRef.instance;
    }
    createDialogInjector(dialogRef, dialogContainer, config) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(DialogRef, dialogRef);
        injectionTokens.set(DialogContainerComponent, dialogContainer);
        injectionTokens.set(DIALOG_DATA, config.data);
        return new DialogInjector(this.injector, injectionTokens);
    }
}
DialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogService, deps: [{ token: Backdrop }, { token: i0.Injector }, { token: i1.PlatformLocation }], target: i0.ɵɵFactoryTarget.Injectable });
DialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Backdrop }, { type: i0.Injector }, { type: i1.PlatformLocation }]; } });

class DialogModule {
}
DialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: DialogModule, declarations: [DialogContainerComponent,
        DialogHeaderComponent,
        DialogSectionComponent,
        DialogFooterComponent,
        DialogButtonContainerComponent], imports: [CommonModule], exports: [DialogContainerComponent,
        DialogHeaderComponent,
        DialogSectionComponent,
        DialogFooterComponent,
        DialogButtonContainerComponent] });
DialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogModule, providers: [
        Backdrop,
        BackdropContainer,
        DialogService
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [
                        DialogContainerComponent,
                        DialogHeaderComponent,
                        DialogSectionComponent,
                        DialogFooterComponent,
                        DialogButtonContainerComponent
                    ],
                    declarations: [
                        DialogContainerComponent,
                        DialogHeaderComponent,
                        DialogSectionComponent,
                        DialogFooterComponent,
                        DialogButtonContainerComponent
                    ],
                    providers: [
                        Backdrop,
                        BackdropContainer,
                        DialogService
                    ]
                }]
        }] });

class DropdownLabelComponent {
    constructor() {
        this.dropdownLabel = true;
    }
}
DropdownLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DropdownLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DropdownLabelComponent, selector: "bis-dropdown-label", host: { properties: { "class.dropdown__label": "this.dropdownLabel" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownLabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-dropdown-label',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], propDecorators: { dropdownLabel: [{
                type: HostBinding,
                args: ['class.dropdown__label']
            }] } });
class DropdownBodyComponent {
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
        this.position = null;
        this.closeOnClick = true;
        this.dropdownBody = true;
        this.showBody = false;
        this.onClickHandler = (event) => {
            if (!this.closeOnClick) {
                event.stopPropagation();
            }
        };
    }
    ngOnInit() {
        this.addClass();
    }
    /**
     * Method used to set the classes for the host element (bis-dropdown-body)
     */
    addClass() {
        if (this.position) {
            this.renderer.addClass(this.elRef.nativeElement, `dropdown__body--${this.position}`);
        }
    }
}
DropdownBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownBodyComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
DropdownBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DropdownBodyComponent, selector: "bis-dropdown-body", inputs: { position: "position", closeOnClick: "closeOnClick", showBody: "showBody" }, host: { listeners: { "click": "onClickHandler($event)" }, properties: { "class.dropdown__body": "this.dropdownBody", "class.dropdown__body--open": "this.showBody" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownBodyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-dropdown-body',
                    template: `
    <ng-content></ng-content>
  `,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { position: [{
                type: Input
            }], closeOnClick: [{
                type: Input
            }], dropdownBody: [{
                type: HostBinding,
                args: ['class.dropdown__body']
            }], showBody: [{
                type: HostBinding,
                args: ['class.dropdown__body--open']
            }, {
                type: Input
            }], onClickHandler: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class DropdownComponent {
    constructor(renderer, elRef) {
        this.renderer = renderer;
        this.elRef = elRef;
        this.isToggled = false;
        this.dropdown = true;
        this.tabindex = 0;
        this._disabled = null;
        this.onClick = (event) => {
            if (this.disabled) {
                event.stopPropagation();
                if (this.isToggled) {
                    this.toggleDropdownBody();
                }
                return;
            }
            this.toggleDropdownBody();
        };
        this.closeWhenClickedOutside();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value || value === '' ? true : null;
        if (this._disabled) {
            this.tabindex = -1;
        }
    }
    toggleDropdownBody() {
        if (!this.dropdownComponentRef) {
            throw new Error('bis-dropdown must have a bis-dropdown-body child component!');
        }
        this.switchToggle();
        this.dropdownComponentRef.showBody = this.isToggled;
        this.toggleActiveClass();
    }
    toggleActiveClass() {
        const BUTTON_ACTIVE = 'dropdown__btn--active';
        if (this.buttonDirectiveRef) {
            if (this.buttonDirectiveRef.elementRef.nativeElement.classList.contains(BUTTON_ACTIVE)) {
                this.renderer.removeClass(this.buttonDirectiveRef.elementRef.nativeElement, BUTTON_ACTIVE);
            }
            else {
                this.renderer.addClass(this.buttonDirectiveRef.elementRef.nativeElement, BUTTON_ACTIVE);
            }
        }
        else {
            console.warn('bis-btn directive and btn-type="dropdown" input should be set on the dropdown button');
        }
    }
    switchToggle() {
        this.isToggled = !this.isToggled;
    }
    closeWhenClickedOutside() {
        this.listenerFn = this.renderer.listen(document, 'click', (event) => {
            if (this.isToggled && !this.isDropdownClicked(event.target)) {
                this.toggleDropdownBody();
            }
        });
    }
    isDropdownClicked(targetElement) {
        return this.elRef.nativeElement.contains(targetElement);
    }
    ngOnDestroy() {
        this.listenerFn();
    }
}
DropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DropdownComponent, selector: "bis-dropdown", inputs: { tabindex: "tabindex", disabled: "disabled" }, host: { listeners: { "click": "onClick($event)" }, properties: { "class.dropdown": "this.dropdown", "attr.tabindex": "this.tabindex", "class.disabled": "this.disabled", "attr.disabled": "this.disabled" } }, queries: [{ propertyName: "dropdownComponentRef", first: true, predicate: DropdownBodyComponent, descendants: true }, { propertyName: "buttonDirectiveRef", first: true, predicate: ButtonDirective, descendants: true }], ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-dropdown',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { dropdownComponentRef: [{
                type: ContentChild,
                args: [DropdownBodyComponent, { static: false }]
            }], buttonDirectiveRef: [{
                type: ContentChild,
                args: [ButtonDirective, { static: false }]
            }], dropdown: [{
                type: HostBinding,
                args: ['class.dropdown']
            }], tabindex: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.tabindex']
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: HostBinding,
                args: ['attr.disabled']
            }] } });

class DropdownModule {
}
DropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: DropdownModule, declarations: [DropdownComponent,
        DropdownBodyComponent,
        DropdownLabelComponent], exports: [DropdownComponent,
        DropdownBodyComponent,
        DropdownLabelComponent] });
DropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [
                        DropdownComponent,
                        DropdownBodyComponent,
                        DropdownLabelComponent
                    ],
                    declarations: [
                        DropdownComponent,
                        DropdownBodyComponent,
                        DropdownLabelComponent
                    ],
                    providers: [],
                }]
        }] });

const EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';

const bodyExpansionAnimation = trigger('bodyExpansion', [
    state('collapsed, void', style({ height: '0px', visibility: 'hidden' })),
    state('expanded', style({ height: '*', visibility: 'visible' })),
    transition('expanded <=> collapsed, void => collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
]);

const indicatorRotateAnimation = trigger('indicatorRotate', [
    state('collapsed, void', style({ transform: 'rotate(0deg)' })),
    state('expanded', style({ transform: 'rotate(180deg)' })),
    transition('expanded <=> collapsed, void => collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
]);

var ExpansionState;
(function (ExpansionState) {
    ExpansionState["Expanded"] = "expanded";
    ExpansionState["Collapsed"] = "collapsed";
})(ExpansionState || (ExpansionState = {}));

class ExpansionPanelCollapsedSuffixDirective {
}
ExpansionPanelCollapsedSuffixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelCollapsedSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ExpansionPanelCollapsedSuffixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: ExpansionPanelCollapsedSuffixDirective, selector: "[bisExpansionPanelCollapsedSuffix]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelCollapsedSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bisExpansionPanelCollapsedSuffix]',
                }]
        }] });

class ExpansionPanelExpandedSuffixDirective {
}
ExpansionPanelExpandedSuffixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelExpandedSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ExpansionPanelExpandedSuffixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: ExpansionPanelExpandedSuffixDirective, selector: "[bisExpansionPanelExpandedSuffix]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelExpandedSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bisExpansionPanelExpandedSuffix]',
                }]
        }] });

class ExpansionPanelPrefixDirective {
}
ExpansionPanelPrefixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelPrefixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ExpansionPanelPrefixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: ExpansionPanelPrefixDirective, selector: "[bisExpansionPanelPrefix]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bisExpansionPanelPrefix]',
                }]
        }] });

const publicDirectives = [
    ExpansionPanelCollapsedSuffixDirective,
    ExpansionPanelExpandedSuffixDirective,
    ExpansionPanelPrefixDirective,
];

class ExpansionPanelComponent {
    constructor() {
        this.expanded = false;
        this.disableToggle = false;
        this.expandedChange = new EventEmitter();
    }
    toggle() {
        this.expanded = !this.expanded && !this.disableToggle;
        this.expandedChange.emit(this.expanded);
    }
    getExpandedState() {
        return this.expanded ? ExpansionState.Expanded : ExpansionState.Collapsed;
    }
    shouldShowDefaultSuffix() {
        if (this.disableToggle) {
            return false;
        }
        if (this.collapsedSuffixElement && !this.expanded) {
            return false;
        }
        if (this.expandedSuffixElement && this.expanded) {
            return false;
        }
        return true;
    }
}
ExpansionPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ExpansionPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ExpansionPanelComponent, selector: "bis-expansion-panel", inputs: { expanded: "expanded", disableToggle: "disableToggle" }, outputs: { expandedChange: "expandedChange" }, queries: [{ propertyName: "prefixElement", first: true, predicate: ExpansionPanelPrefixDirective, descendants: true }, { propertyName: "collapsedSuffixElement", first: true, predicate: ExpansionPanelCollapsedSuffixDirective, descendants: true }, { propertyName: "expandedSuffixElement", first: true, predicate: ExpansionPanelExpandedSuffixDirective, descendants: true }], ngImport: i0, template: "<article class=\"u-border\">\n  <header (click)=\"toggle()\">\n    <div>\n      <span *ngIf=\"prefixElement\" class=\"u-margin-left-default\">\n        <ng-content select=\"[bisExpansionPanelPrefix]\"></ng-content>\n      </span>\n      <span class=\"u-margin-left-default\">\n        <ng-content select=\"bis-expansion-panel-title\"></ng-content>\n      </span>\n    </div>\n    <span class=\"u-margin-right-default expansion-panel__suffix\">\n      <bis-icon\n        *ngIf=\"shouldShowDefaultSuffix()\"\n        [@indicatorRotate]=\"getExpandedState()\"\n        icon=\"angle-up\"\n      ></bis-icon>\n      <ng-content\n        *ngIf=\"collapsedSuffixElement && !expanded\"\n        select=\"[bisExpansionPanelCollapsedSuffix]\"\n      ></ng-content>\n      <ng-content\n        *ngIf=\"expandedSuffixElement && expanded\"\n        select=\"[bisExpansionPanelExpandedSuffix]\"\n      ></ng-content>\n    </span>\n  </header>\n  <section [@bodyExpansion]=\"getExpandedState()\">\n    <ng-content></ng-content>\n  </section>\n</article>\n", styles: ["header{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;height:56px}article{border-radius:.5rem;border-color:#d1d3d7}section{overflow:hidden}.expansion-panel__suffix{display:-ms-flexbox;display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "bis-icon", inputs: ["size", "icon", "element-type"] }], animations: [bodyExpansionAnimation, indicatorRotateAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-expansion-panel', changeDetection: ChangeDetectionStrategy.OnPush, animations: [bodyExpansionAnimation, indicatorRotateAnimation], template: "<article class=\"u-border\">\n  <header (click)=\"toggle()\">\n    <div>\n      <span *ngIf=\"prefixElement\" class=\"u-margin-left-default\">\n        <ng-content select=\"[bisExpansionPanelPrefix]\"></ng-content>\n      </span>\n      <span class=\"u-margin-left-default\">\n        <ng-content select=\"bis-expansion-panel-title\"></ng-content>\n      </span>\n    </div>\n    <span class=\"u-margin-right-default expansion-panel__suffix\">\n      <bis-icon\n        *ngIf=\"shouldShowDefaultSuffix()\"\n        [@indicatorRotate]=\"getExpandedState()\"\n        icon=\"angle-up\"\n      ></bis-icon>\n      <ng-content\n        *ngIf=\"collapsedSuffixElement && !expanded\"\n        select=\"[bisExpansionPanelCollapsedSuffix]\"\n      ></ng-content>\n      <ng-content\n        *ngIf=\"expandedSuffixElement && expanded\"\n        select=\"[bisExpansionPanelExpandedSuffix]\"\n      ></ng-content>\n    </span>\n  </header>\n  <section [@bodyExpansion]=\"getExpandedState()\">\n    <ng-content></ng-content>\n  </section>\n</article>\n", styles: ["header{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;height:56px}article{border-radius:.5rem;border-color:#d1d3d7}section{overflow:hidden}.expansion-panel__suffix{display:-ms-flexbox;display:flex}\n"] }]
        }], propDecorators: { prefixElement: [{
                type: ContentChild,
                args: [ExpansionPanelPrefixDirective]
            }], collapsedSuffixElement: [{
                type: ContentChild,
                args: [ExpansionPanelCollapsedSuffixDirective]
            }], expandedSuffixElement: [{
                type: ContentChild,
                args: [ExpansionPanelExpandedSuffixDirective]
            }], expanded: [{
                type: Input
            }], disableToggle: [{
                type: Input
            }], expandedChange: [{
                type: Output
            }] } });

class ExpansionPanelTitleComponent {
}
ExpansionPanelTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelTitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ExpansionPanelTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ExpansionPanelTitleComponent, selector: "bis-expansion-panel-title", ngImport: i0, template: "<ng-content></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-expansion-panel-title', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n" }]
        }] });

const publicComponents = [
    ExpansionPanelComponent,
    ExpansionPanelTitleComponent,
];

const publicDeclarations = [...publicComponents, ...publicDirectives];
class ExpansionPanelModule {
}
ExpansionPanelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ExpansionPanelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelModule, declarations: [ExpansionPanelComponent, ExpansionPanelTitleComponent, ExpansionPanelCollapsedSuffixDirective, ExpansionPanelExpandedSuffixDirective, ExpansionPanelPrefixDirective], imports: [CommonModule, IconFieldModule], exports: [ExpansionPanelComponent, ExpansionPanelTitleComponent, ExpansionPanelCollapsedSuffixDirective, ExpansionPanelExpandedSuffixDirective, ExpansionPanelPrefixDirective] });
ExpansionPanelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelModule, imports: [CommonModule, IconFieldModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ExpansionPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...publicDeclarations],
                    exports: [...publicDeclarations],
                    imports: [CommonModule, IconFieldModule],
                }]
        }] });

class DropContainerComponent {
    constructor() {
        this.dropFiles$ = new EventEmitter();
        this.buttonClick$ = new EventEmitter();
        this.isDragOver = false;
    }
    dragLeave(_) {
        this.isDragOver = false;
    }
    dragover(e) {
        e.preventDefault();
        if (e.dataTransfer.types.indexOf('Files') > -1) {
            this.isDragOver = true;
        }
    }
    handleDrop(e) {
        e.preventDefault();
        const files = e.dataTransfer.files;
        this.isDragOver = false;
        if (files && files.length) {
            this.dropFiles$.next(files);
        }
    }
}
DropContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DropContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DropContainerComponent, selector: "bis-drop-container", inputs: { textContent: "textContent" }, outputs: { dropFiles$: "dropFiles$", buttonClick$: "buttonClick$" }, ngImport: i0, template: "<div [ngClass]=\"{'file-container': true, 'file-container--is-dragover': isDragOver}\" (drop)=\"handleDrop($event)\"\n  (dragover)=\"dragover($event)\" (dragleave)=\"dragLeave($event)\">\n  <div class=\"container\">\n    <ng-container *ngIf=\"textContent?.description?.length\">\n      <p class=\"text-bold\" *ngFor=\"let description of textContent?.description\">{{description}}</p>\n    </ng-container>\n    <button class=\"btn btn--secondary u-margin-right-default\" (click)=\"buttonClick$.emit($event)\">\n      {{ textContent?.buttons?.addFile }}\n      <i class=\"icon icon--plus icon--small\"></i>\n    </button>\n    <p class=\"notes text-secondary\">{{ textContent?.limitationNote }}</p>\n  </div>\n</div>", styles: [".file-container{border:1px dashed #7c808c;border-radius:19px;overflow:hidden;width:90%;height:90%;text-align:center;position:absolute;top:50%;left:50%;-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding-top:10%;background-color:#e4e5ea}.notes{margin-top:5%;opacity:.5;color:#a5a8b2}.file-container--is-dragover{border-color:#c8dadf;background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-drop-container', template: "<div [ngClass]=\"{'file-container': true, 'file-container--is-dragover': isDragOver}\" (drop)=\"handleDrop($event)\"\n  (dragover)=\"dragover($event)\" (dragleave)=\"dragLeave($event)\">\n  <div class=\"container\">\n    <ng-container *ngIf=\"textContent?.description?.length\">\n      <p class=\"text-bold\" *ngFor=\"let description of textContent?.description\">{{description}}</p>\n    </ng-container>\n    <button class=\"btn btn--secondary u-margin-right-default\" (click)=\"buttonClick$.emit($event)\">\n      {{ textContent?.buttons?.addFile }}\n      <i class=\"icon icon--plus icon--small\"></i>\n    </button>\n    <p class=\"notes text-secondary\">{{ textContent?.limitationNote }}</p>\n  </div>\n</div>", styles: [".file-container{border:1px dashed #7c808c;border-radius:19px;overflow:hidden;width:90%;height:90%;text-align:center;position:absolute;top:50%;left:50%;-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding-top:10%;background-color:#e4e5ea}.notes{margin-top:5%;opacity:.5;color:#a5a8b2}.file-container--is-dragover{border-color:#c8dadf;background-color:#fff}\n"] }]
        }], propDecorators: { textContent: [{
                type: Input
            }], dropFiles$: [{
                type: Output
            }], buttonClick$: [{
                type: Output
            }] } });

class FileListComponent {
    constructor() {
        this.files = [];
        this.deleteFile$ = new EventEmitter();
    }
    getFileSize(file) {
        return (file.size / Math.pow(1024, 2)).toFixed(2);
    }
}
FileListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FileListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FileListComponent, selector: "bis-file-list", inputs: { files: "files", textContent: "textContent", validators: "validators", errorCounter: "errorCounter" }, outputs: { deleteFile$: "deleteFile$" }, ngImport: i0, template: "<div class=\"alert-container alert-container--danger\" *ngIf=\"errorCounter > 0\">\n  <div class=\"alert\">\n    <div class=\"alert__icon alert__icon--danger\"></div>\n    <div class=\"alert__text\">\n      {{ textContent?.errors?.listError?.join(' ' + errorCounter + ' ') }}\n    </div>\n  </div>\n</div>\n<div class=\"table-container\">\n  <table class=\"table\">\n    <thead class=\"thead\">\n      <tr class=\"thead__row\">\n        <th class=\"tcell tcell--head\" scope=\"col\">{{ textContent?.columns?.file }}</th>\n        <th class=\"tcell tcell--head u-text-right\" scope=\"col\">{{ textContent?.columns?.size }}</th>\n        <th class=\"tcell tcell--head u-text-right\" scope=\"col\"></th>\n      </tr>\n    </thead>\n    <tbody class=\"tbody\">\n      <tr class=\"tbody__row\" *ngFor=\"let file of files;\">\n        <td class=\"tcell\">\n          <div class=\"file-name text-secondary-bold\" [attr.data-filetype]=\"file.extension\">\n            <p class=\"text-secondary-bold\">{{ file?.nameWithoutExtension }}</p>\n          </div>\n          <p class=\"display-7 red-dark\">{{ file?.error }}</p>\n        </td>\n        <td class=\"tcell u-text-right text-secondary-bold\">{{ getFileSize(file) }}</td>\n        <td class=\"tcell u-text-right u-cursor-pointer\" (click)=\"deleteFile$.next(file)\">\n          <i class=\"icon icon--delete icon--small\"></i>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>", styles: [".table{margin-bottom:0;table-layout:fixed}.red-dark{color:#ca2121}.file-name{display:inline-block;position:relative}.file-name p{clear:both;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.file-name:after{content:attr(data-filetype);position:absolute;left:100%;top:0}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-file-list', template: "<div class=\"alert-container alert-container--danger\" *ngIf=\"errorCounter > 0\">\n  <div class=\"alert\">\n    <div class=\"alert__icon alert__icon--danger\"></div>\n    <div class=\"alert__text\">\n      {{ textContent?.errors?.listError?.join(' ' + errorCounter + ' ') }}\n    </div>\n  </div>\n</div>\n<div class=\"table-container\">\n  <table class=\"table\">\n    <thead class=\"thead\">\n      <tr class=\"thead__row\">\n        <th class=\"tcell tcell--head\" scope=\"col\">{{ textContent?.columns?.file }}</th>\n        <th class=\"tcell tcell--head u-text-right\" scope=\"col\">{{ textContent?.columns?.size }}</th>\n        <th class=\"tcell tcell--head u-text-right\" scope=\"col\"></th>\n      </tr>\n    </thead>\n    <tbody class=\"tbody\">\n      <tr class=\"tbody__row\" *ngFor=\"let file of files;\">\n        <td class=\"tcell\">\n          <div class=\"file-name text-secondary-bold\" [attr.data-filetype]=\"file.extension\">\n            <p class=\"text-secondary-bold\">{{ file?.nameWithoutExtension }}</p>\n          </div>\n          <p class=\"display-7 red-dark\">{{ file?.error }}</p>\n        </td>\n        <td class=\"tcell u-text-right text-secondary-bold\">{{ getFileSize(file) }}</td>\n        <td class=\"tcell u-text-right u-cursor-pointer\" (click)=\"deleteFile$.next(file)\">\n          <i class=\"icon icon--delete icon--small\"></i>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>", styles: [".table{margin-bottom:0;table-layout:fixed}.red-dark{color:#ca2121}.file-name{display:inline-block;position:relative}.file-name p{clear:both;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.file-name:after{content:attr(data-filetype);position:absolute;left:100%;top:0}\n"] }]
        }], propDecorators: { files: [{
                type: Input
            }], textContent: [{
                type: Input
            }], validators: [{
                type: Input
            }], errorCounter: [{
                type: Input
            }], deleteFile$: [{
                type: Output
            }] } });

class FileUploadFooterComponent {
    constructor() {
        this.width = '100%';
        this.isContainer = true;
        this.filesCounter = 0;
        this.addFiles$ = new EventEmitter();
        this.submit$ = new EventEmitter();
        this.canSubmit = true;
    }
}
FileUploadFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FileUploadFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FileUploadFooterComponent, selector: "bis-file-upload-footer", inputs: { textContent: "textContent", showContent: "showContent", filesCounter: "filesCounter", canSubmit: "canSubmit" }, outputs: { addFiles$: "addFiles$", submit$: "submit$" }, host: { properties: { "style.width": "this.width", "class.modal__btn-container": "this.isContainer" } }, ngImport: i0, template: `
    <div [ngClass]="{'hidden': !showContent}">
      <button class="btn btn--secondary u-margin-right-default" (click)="addFiles$.emit($event)">
       {{ textContent?.buttons?.addFiles }}
      </button>
      <button bis-btn class="btn btn--primary u-margin-right-default" (click)="submit$.emit($event)" [disabled]="!canSubmit" >
      {{ textContent?.buttons?.upload }}
      {{ filesCounter }}
      {{ textContent?.buttons?.files }}
      </button>
    </div>
    `, isInline: true, styles: [".hidden{visibility:hidden}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-file-upload-footer', template: `
    <div [ngClass]="{'hidden': !showContent}">
      <button class="btn btn--secondary u-margin-right-default" (click)="addFiles$.emit($event)">
       {{ textContent?.buttons?.addFiles }}
      </button>
      <button bis-btn class="btn btn--primary u-margin-right-default" (click)="submit$.emit($event)" [disabled]="!canSubmit" >
      {{ textContent?.buttons?.upload }}
      {{ filesCounter }}
      {{ textContent?.buttons?.files }}
      </button>
    </div>
    `, styles: [".hidden{visibility:hidden}\n"] }]
        }], propDecorators: { width: [{
                type: HostBinding,
                args: ['style.width']
            }], isContainer: [{
                type: HostBinding,
                args: ['class.modal__btn-container']
            }], textContent: [{
                type: Input
            }], showContent: [{
                type: Input
            }], filesCounter: [{
                type: Input
            }], addFiles$: [{
                type: Output
            }], submit$: [{
                type: Output
            }], canSubmit: [{
                type: Input
            }] } });

class OverlayUploadingComponent {
    constructor() {
        this.continue$ = new EventEmitter();
        this.cancel$ = new EventEmitter();
        this.done = false;
        this.percentage = 5;
    }
    shouldCancel() {
        if (!this.done) {
            this.cancel$.emit();
        }
    }
    ngOnInit() {
        const subscription = this.streamConnection$
            .pipe(map((data) => {
            if (typeof data.percentage !== 'undefined') {
                return data;
            }
            return this.getDataFromEvent(data);
        }), filter((data) => data))
            .subscribe(({ percentage }) => {
            this.percentage = percentage;
            if (percentage === 100) {
                subscription.unsubscribe();
                this.success();
            }
        });
    }
    success() {
        this.done = true;
        fromEvent(this.progressBar.nativeElement, 'transitionend').subscribe(() => {
            this.continue$.emit();
        });
    }
    getDataFromEvent(event) {
        if (event.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * event.loaded / event.total);
            return { percentage: percentDone };
        }
        if (event.type === HttpEventType.Response) {
            return { percentage: 100 };
        }
    }
    getStatus() {
        return `${this.textContent.uploading}
            ${this.filesCounter}
            ${this.textContent.files}`;
    }
}
OverlayUploadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OverlayUploadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OverlayUploadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: OverlayUploadingComponent, selector: "bis-overlay-uploading", inputs: { textContent: "textContent", filesCounter: "filesCounter", streamConnection$: "streamConnection$" }, outputs: { continue$: "continue$", cancel$: "cancel$" }, viewQueries: [{ propertyName: "progressBar", first: true, predicate: ["progressBar"], descendants: true }], ngImport: i0, template: "<div class=\"container u-margin-top-xlarge\">\n  <div class=\"row\">\n    <div class=\"col-12 align-self-center\">\n      <div class=\"u-text-center text-white p-2\">\n        <span class=\"status display-5\">\n          {{ this.getStatus() }}\n        </span>\n      </div>\n\n      <div class=\"progres-bar u-margin-top-medium\" style=\"margin-top: 20px;\">\n        <div #progressBar class=\"progres-bar__line\" [ngStyle]=\"{'width': percentage + '%'}\"></div>\n      </div>\n\n      <div class=\"actions u-text-center u-margin-top-xlarge\">\n        <button class=\"actions__btn  btn btn--secondary u-margin-right-default\" (click)=\"shouldCancel()\">\n          {{ textContent?.buttons?.cancel }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".actions__btn{min-width:125px}.status{color:#fff}.progres-bar{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start;padding:1px;margin:20px auto auto;width:280px;height:24px;color:#fff;border-radius:12px;background-color:#fff;stroke:#242b43;stroke-width:1px}.progres-bar__line{height:100%;transition:width 1s;background-color:#242b43;border-radius:12px}\n"], dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OverlayUploadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-overlay-uploading', template: "<div class=\"container u-margin-top-xlarge\">\n  <div class=\"row\">\n    <div class=\"col-12 align-self-center\">\n      <div class=\"u-text-center text-white p-2\">\n        <span class=\"status display-5\">\n          {{ this.getStatus() }}\n        </span>\n      </div>\n\n      <div class=\"progres-bar u-margin-top-medium\" style=\"margin-top: 20px;\">\n        <div #progressBar class=\"progres-bar__line\" [ngStyle]=\"{'width': percentage + '%'}\"></div>\n      </div>\n\n      <div class=\"actions u-text-center u-margin-top-xlarge\">\n        <button class=\"actions__btn  btn btn--secondary u-margin-right-default\" (click)=\"shouldCancel()\">\n          {{ textContent?.buttons?.cancel }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".actions__btn{min-width:125px}.status{color:#fff}.progres-bar{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start;padding:1px;margin:20px auto auto;width:280px;height:24px;color:#fff;border-radius:12px;background-color:#fff;stroke:#242b43;stroke-width:1px}.progres-bar__line{height:100%;transition:width 1s;background-color:#242b43;border-radius:12px}\n"] }]
        }], propDecorators: { textContent: [{
                type: Input
            }], filesCounter: [{
                type: Input
            }], streamConnection$: [{
                type: Input
            }], continue$: [{
                type: Output
            }], cancel$: [{
                type: Output
            }], progressBar: [{
                type: ViewChild,
                args: ['progressBar', { static: false }]
            }] } });

class OverlaySuccessComponent {
    constructor() {
        this.continue$ = new EventEmitter();
    }
}
OverlaySuccessComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OverlaySuccessComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OverlaySuccessComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: OverlaySuccessComponent, selector: "bis-overlay-success", inputs: { textContent: "textContent" }, outputs: { continue$: "continue$" }, ngImport: i0, template: "<div class=\"container u-margin-top-xlarge\">\n  <div class=\"row\">\n    <div class=\"col-12 align-self-center\">\n      <div class=\"u-text-center text-white p-2\">\n        <span class=\"status display-5\">\n          {{ textContent?.title }}\n        </span>\n      </div>\n      <div class=\"u-text-center text-white p-2 u-margin-top-medium\">\n        <i class=\"icon icon--check icon--medium\"></i>\n      </div>\n      <div class=\"u-text-center u-margin-top-xlarge\">\n        <button class=\"actions__btn  btn btn--primary u-margin-right-default\" (click)=\"continue$.emit($event)\">\n          {{ textContent?.buttons?.continue }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>", styles: [".icon--medium{font-size:48px}.actions__btn{min-width:125px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OverlaySuccessComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-overlay-success', template: "<div class=\"container u-margin-top-xlarge\">\n  <div class=\"row\">\n    <div class=\"col-12 align-self-center\">\n      <div class=\"u-text-center text-white p-2\">\n        <span class=\"status display-5\">\n          {{ textContent?.title }}\n        </span>\n      </div>\n      <div class=\"u-text-center text-white p-2 u-margin-top-medium\">\n        <i class=\"icon icon--check icon--medium\"></i>\n      </div>\n      <div class=\"u-text-center u-margin-top-xlarge\">\n        <button class=\"actions__btn  btn btn--primary u-margin-right-default\" (click)=\"continue$.emit($event)\">\n          {{ textContent?.buttons?.continue }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>", styles: [".icon--medium{font-size:48px}.actions__btn{min-width:125px}\n"] }]
        }], propDecorators: { textContent: [{
                type: Input
            }], continue$: [{
                type: Output
            }] } });

class OverlayErrorComponent {
    constructor() {
        this.tryAgain$ = new EventEmitter();
        this.cancel$ = new EventEmitter();
    }
}
OverlayErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OverlayErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OverlayErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: OverlayErrorComponent, selector: "bis-overlay-error", inputs: { textContent: "textContent" }, outputs: { tryAgain$: "tryAgain$", cancel$: "cancel$" }, ngImport: i0, template: "<div class=\"container u-margin-top-medium u-margin-right-medium\">\n  <div class=\"row\">\n    <div class=\"col-12 u-float-right\">\n      <i class=\"icon icon--close\" (click)=\"cancel$.next($event)\"></i>\n    </div>\n  </div>\n  <div class=\"row u-margin-top-mediu\">\n\n    <div class=\"col-12 align-self-center u-margin-top-default\">\n      <div class=\"u-text-center p-2\">\n        <span class=\"status display-5\">\n          {{ textContent?.title }}\n        </span>\n      </div>\n      <div class=\"u-text-center p-2 u-margin-top-medium\">\n        <i class=\"icon icon--warning icon--medium\"></i>\n      </div>\n      <div class=\"actions u-text-center u-margin-top-xlarge\">\n        <button class=\"actions__btn  btn btn--primary u-margin-right-default\" (click)=\"tryAgain$.emit($event)\">\n          {{ textContent?.buttons?.retry }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>", styles: [".icon--medium{font-size:48px}.actions__btn{min-width:125px}.icon--close{float:right;margin-right:30px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OverlayErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-overlay-error', template: "<div class=\"container u-margin-top-medium u-margin-right-medium\">\n  <div class=\"row\">\n    <div class=\"col-12 u-float-right\">\n      <i class=\"icon icon--close\" (click)=\"cancel$.next($event)\"></i>\n    </div>\n  </div>\n  <div class=\"row u-margin-top-mediu\">\n\n    <div class=\"col-12 align-self-center u-margin-top-default\">\n      <div class=\"u-text-center p-2\">\n        <span class=\"status display-5\">\n          {{ textContent?.title }}\n        </span>\n      </div>\n      <div class=\"u-text-center p-2 u-margin-top-medium\">\n        <i class=\"icon icon--warning icon--medium\"></i>\n      </div>\n      <div class=\"actions u-text-center u-margin-top-xlarge\">\n        <button class=\"actions__btn  btn btn--primary u-margin-right-default\" (click)=\"tryAgain$.emit($event)\">\n          {{ textContent?.buttons?.retry }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>", styles: [".icon--medium{font-size:48px}.actions__btn{min-width:125px}.icon--close{float:right;margin-right:30px}\n"] }]
        }], propDecorators: { textContent: [{
                type: Input
            }], tryAgain$: [{
                type: Output
            }], cancel$: [{
                type: Output
            }] } });

class FileUploadOverlayComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.filesCounter = 0;
        this._err = false;
        this.close$ = new EventEmitter();
        this.tryAgain$ = new EventEmitter();
        this.stateComponents = [
            {
                component: OverlaySuccessComponent,
                prepareComponent: this.prepareSuccessComponent.bind(this)
            },
            {
                component: OverlayUploadingComponent,
                prepareComponent: this.prepareUploadingComponent.bind(this)
            }
        ];
        this.steps = [...this.stateComponents];
        this.cancel = () => {
            // reset steps state
            this.steps = [...this.stateComponents];
            // trigger close event
            this.close$.emit(false);
        };
        this.continue = () => {
            const nextComponent = this.steps.pop();
            if (nextComponent) {
                this.instantiateComponent(nextComponent);
            }
            else {
                this.close$.emit(true);
            }
        };
    }
    ngOnInit() {
        this.instantiateComponent(this.steps.pop());
        this.streamConnection$.subscribe((data) => {
            if (data.error) {
                this._err = true;
                this.steps = [{
                        component: OverlayErrorComponent,
                        prepareComponent: this.prepareErrorComponent.bind(this)
                    }];
                this.continue();
            }
        });
    }
    prepareErrorComponent(componentRef) {
        componentRef.instance['textContent'] = this.textContent.errors;
        componentRef.instance['cancel$'].subscribe(this.cancel);
        componentRef.instance['tryAgain$'].subscribe(() => {
            this.steps = [...this.stateComponents];
            this.tryAgain$.emit();
            this._err = false;
            this.continue();
        });
    }
    prepareSuccessComponent(componentRef) {
        componentRef.instance['textContent'] = this.textContent.complete;
        componentRef.instance['continue$'].subscribe(this.continue);
    }
    prepareUploadingComponent(componentRef) {
        componentRef.instance['textContent'] = this.textContent.progress;
        componentRef.instance['filesCounter'] = this.filesCounter;
        componentRef.instance['streamConnection$'] = this.streamConnection$;
        componentRef.instance['cancel$'].subscribe(this.cancel);
        componentRef.instance['continue$'].subscribe(this.continue);
    }
    instantiateComponent({ component, prepareComponent }) {
        if (component) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
            this.stateContainer.clear();
            const componentRef = this.stateContainer.createComponent(componentFactory);
            if (typeof prepareComponent !== 'undefined') {
                prepareComponent(componentRef);
            }
            this.stateContainer.insert(componentRef.hostView);
        }
    }
}
FileUploadOverlayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadOverlayComponent, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
FileUploadOverlayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FileUploadOverlayComponent, selector: "bis-file-upload-overlay", inputs: { textContent: "textContent", filesCounter: "filesCounter", streamConnection$: "streamConnection$" }, outputs: { close$: "close$", tryAgain$: "tryAgain$" }, viewQueries: [{ propertyName: "stateContainer", first: true, predicate: ["stateContainer"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `
        <div [ngClass]="{
            'overlay': true,
            'overlay--blue': !_err,
            'overlay--red': _err
          }">
            <ng-template #stateContainer></ng-template>
        </div>
    `, isInline: true, styles: [".overlay{position:absolute;display:block;width:100%;top:0;left:0;right:0;bottom:0}.overlay--blue{background-color:#242b43e6}.overlay--red{background-color:#da3b3be6}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-file-upload-overlay', template: `
        <div [ngClass]="{
            'overlay': true,
            'overlay--blue': !_err,
            'overlay--red': _err
          }">
            <ng-template #stateContainer></ng-template>
        </div>
    `, styles: [".overlay{position:absolute;display:block;width:100%;top:0;left:0;right:0;bottom:0}.overlay--blue{background-color:#242b43e6}.overlay--red{background-color:#da3b3be6}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; }, propDecorators: { textContent: [{
                type: Input
            }], filesCounter: [{
                type: Input
            }], streamConnection$: [{
                type: Input
            }], close$: [{
                type: Output
            }], tryAgain$: [{
                type: Output
            }], stateContainer: [{
                type: ViewChild,
                args: ['stateContainer', { read: ViewContainerRef, static: true }]
            }] } });

class FileUploadComponent {
    constructor() {
        this.submitFiles = new EventEmitter();
        this.finish = new EventEmitter();
        this.cancel = new EventEmitter();
        this.files = [];
        this.errorCounter = 0;
        this.overlayDisplay = false;
        this.footerDisplay = false;
    }
    handleInputChange(e) {
        const files = e.currentTarget.files;
        if (files && files.length) {
            this.addFiles(files);
        }
    }
    /**
     * This function is called for triggering hidden input click event.
     * We are triggering this because we want browser functionality for uploading files
     * @param input : HTMLInputElement
     */
    handleAddFilesClick(input) {
        if (input) {
            input.click();
        }
    }
    addFiles(data) {
        const { files, errorCounter } = this.prepareFiles(Object.keys(data).map(key => data[key]));
        this.files = this.files.concat(files);
        this.errorCounter += errorCounter;
        this.footerDisplay = true;
    }
    deleteFile(file) {
        if (file.error) {
            this.errorCounter--;
        }
        this.files = this.files.filter((item) => item.name !== file.name);
        if (!this.files.length) {
            this.footerDisplay = false;
        }
    }
    getFileSize(file) {
        return (file.size / Math.pow(1024, 2)).toFixed(2);
    }
    prepareFiles(files) {
        let errorCounter = 0;
        const mappedFiles = files.map((file) => {
            const extension = file.name.split('.').pop();
            file.extension = extension;
            file.nameWithoutExtension = file.name.substring(0, file.name.length - extension.length);
            if (this.validators.fileTypes.indexOf(extension) < 0) {
                errorCounter++;
                file.error = this.translations.body.fileList.errors.typeError;
            }
            else if (this.validators.maxFileSize < parseInt(this.getFileSize(file), 10)) {
                errorCounter++;
                file.error = this.translations.body.fileList.errors.sizeError;
            }
            return file;
        });
        return {
            files: mappedFiles,
            errorCounter
        };
    }
    submit() {
        this.submitFiles.emit(this.files);
        this.overlayDisplay = true;
        this.footerDisplay = false;
    }
    tryAgain() {
        this.submit();
    }
    closeOverlay(done) {
        if (done) {
            this.finish.emit();
        }
        else {
            this.cancel.emit();
            this.overlayDisplay = false;
            this.footerDisplay = true;
        }
    }
}
FileUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FileUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FileUploadComponent, selector: "bis-file-upload", inputs: { validators: "validators", streamConnection$: "streamConnection$", translations: "translations" }, outputs: { submitFiles: "submitFiles", finish: "finish", cancel: "cancel" }, ngImport: i0, template: "<div class=\"modal__header\">\n  <h3 class=\"modal-title\">\n    {{ translations.header.title }}\n  </h3>\n</div>\n\n<div class=\"modal__section u-padding-x-none\">\n\n  <bis-file-list *ngIf=\"this.files && this.files.length;else dropContainer\" [validators]=\"validators\"\n    [textContent]=\"translations?.body?.fileList\" [files]=\"this.files\" [errorCounter]=\"errorCounter\"\n    (deleteFile$)=\"deleteFile($event)\">\n  </bis-file-list>\n\n  <ng-template #dropContainer>\n    <bis-drop-container [textContent]=\"translations?.body?.fileDrop\" (buttonClick$)=\"handleAddFilesClick(fileInput)\"\n      (dropFiles$)=\"addFiles($event)\">\n    </bis-drop-container>\n  </ng-template>\n\n  <input #fileInput type=\"file\" (change)=\"handleInputChange($event)\" multiple />\n\n  <bis-file-upload-overlay *ngIf=\"overlayDisplay\" [filesCounter]=\"files?.length\"\n    [textContent]=\"translations?.body?.uploading\" [streamConnection$]=\"streamConnection$\" (close$)=\"closeOverlay($event)\"\n    (tryAgain$)=\"tryAgain()\">\n  </bis-file-upload-overlay>\n\n</div>\n\n<bis-file-upload-footer [canSubmit]=\"errorCounter === 0\" [showContent]=\"footerDisplay\"\n  [textContent]=\"translations?.footer\" [filesCounter]=\"files?.length\" (addFiles$)=\"handleAddFilesClick(fileInput)\"\n  (submit$)=\"submit()\">\n</bis-file-upload-footer>\n", styles: [":host{display:block}.modal__section{min-height:400px;background-color:#fff}[type=file]{display:none}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DropContainerComponent, selector: "bis-drop-container", inputs: ["textContent"], outputs: ["dropFiles$", "buttonClick$"] }, { kind: "component", type: FileListComponent, selector: "bis-file-list", inputs: ["files", "textContent", "validators", "errorCounter"], outputs: ["deleteFile$"] }, { kind: "component", type: FileUploadFooterComponent, selector: "bis-file-upload-footer", inputs: ["textContent", "showContent", "filesCounter", "canSubmit"], outputs: ["addFiles$", "submit$"] }, { kind: "component", type: FileUploadOverlayComponent, selector: "bis-file-upload-overlay", inputs: ["textContent", "filesCounter", "streamConnection$"], outputs: ["close$", "tryAgain$"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-file-upload', template: "<div class=\"modal__header\">\n  <h3 class=\"modal-title\">\n    {{ translations.header.title }}\n  </h3>\n</div>\n\n<div class=\"modal__section u-padding-x-none\">\n\n  <bis-file-list *ngIf=\"this.files && this.files.length;else dropContainer\" [validators]=\"validators\"\n    [textContent]=\"translations?.body?.fileList\" [files]=\"this.files\" [errorCounter]=\"errorCounter\"\n    (deleteFile$)=\"deleteFile($event)\">\n  </bis-file-list>\n\n  <ng-template #dropContainer>\n    <bis-drop-container [textContent]=\"translations?.body?.fileDrop\" (buttonClick$)=\"handleAddFilesClick(fileInput)\"\n      (dropFiles$)=\"addFiles($event)\">\n    </bis-drop-container>\n  </ng-template>\n\n  <input #fileInput type=\"file\" (change)=\"handleInputChange($event)\" multiple />\n\n  <bis-file-upload-overlay *ngIf=\"overlayDisplay\" [filesCounter]=\"files?.length\"\n    [textContent]=\"translations?.body?.uploading\" [streamConnection$]=\"streamConnection$\" (close$)=\"closeOverlay($event)\"\n    (tryAgain$)=\"tryAgain()\">\n  </bis-file-upload-overlay>\n\n</div>\n\n<bis-file-upload-footer [canSubmit]=\"errorCounter === 0\" [showContent]=\"footerDisplay\"\n  [textContent]=\"translations?.footer\" [filesCounter]=\"files?.length\" (addFiles$)=\"handleAddFilesClick(fileInput)\"\n  (submit$)=\"submit()\">\n</bis-file-upload-footer>\n", styles: [":host{display:block}.modal__section{min-height:400px;background-color:#fff}[type=file]{display:none}\n"] }]
        }], propDecorators: { validators: [{
                type: Input
            }], streamConnection$: [{
                type: Input
            }], translations: [{
                type: Input
            }], submitFiles: [{
                type: Output
            }], finish: [{
                type: Output
            }], cancel: [{
                type: Output
            }] } });

class FileUploadModule {
}
FileUploadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FileUploadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: FileUploadModule, declarations: [FileUploadComponent,
        DropContainerComponent,
        FileListComponent,
        FileUploadFooterComponent,
        FileUploadOverlayComponent,
        OverlayUploadingComponent,
        OverlaySuccessComponent,
        OverlayErrorComponent], imports: [CommonModule,
        HttpClientModule], exports: [FileUploadComponent] });
FileUploadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadModule, imports: [CommonModule,
        HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule
                    ],
                    exports: [
                        FileUploadComponent,
                    ],
                    declarations: [
                        FileUploadComponent,
                        DropContainerComponent,
                        FileListComponent,
                        FileUploadFooterComponent,
                        FileUploadOverlayComponent,
                        OverlayUploadingComponent,
                        OverlaySuccessComponent,
                        OverlayErrorComponent
                    ],
                    providers: []
                }]
        }] });

class FilterWithCloseComponent {
    constructor() {
        this.valueChange = new EventEmitter();
        this.toggleState = true;
    }
    /**
     * Method used to toggle the active / default state
     */
    toggle() {
        this.toggleState = !this.toggleState;
        // Emit the toggle state of the filter
        this.valueChange.emit(this.toggleState);
    }
}
FilterWithCloseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterWithCloseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FilterWithCloseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FilterWithCloseComponent, selector: "bis-filter-with-close", outputs: { valueChange: "valueChange" }, ngImport: i0, template: `
    <span *ngIf="toggleState" class="filter filter--with-close filter--active">
      <ng-content></ng-content>
      <span (click)="toggle()" class="filter__close"></span>
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterWithCloseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-filter-with-close',
                    template: `
    <span *ngIf="toggleState" class="filter filter--with-close filter--active">
      <ng-content></ng-content>
      <span (click)="toggle()" class="filter__close"></span>
    </span>
  `
                }]
        }], propDecorators: { valueChange: [{
                type: Output
            }] } });

class FilterComponent {
    constructor() {
        this.valueChange = new EventEmitter();
        this.toggleState = false;
        this.classes = {};
    }
    set checked(isChecked) {
        if (isChecked) {
            this.classes['filter--active'] = true;
        }
        else {
            if (this.classes) {
                this.removeAddedClasses();
            }
        }
        this.toggleState = isChecked;
    }
    ngOnInit() {
        this.classes['filter'] = true;
    }
    ngOnChanges() {
        this.setClasses(this.state);
        // If the input is set to active, set the toggle state to also be active
        if (this.state === 'active') {
            this.toggleState = true;
        }
    }
    /**
     * Method used to set the initial classes for the filter
     * @param state
     */
    setClasses(state) {
        // set the default filter class
        this.classes['filter'] = true;
        if (state) {
            this.classes[`filter--${state}`] = true;
        }
    }
    /**
     * Method used to toggle the active / default state
     */
    toggle() {
        if (this.state !== 'disabled') {
            if (this.toggleState) {
                this.removeAddedClasses();
            }
            else {
                // Set the filter to be active and alos the close class if there was input value passed in
                this.classes['filter--active'] = true;
            }
            this.toggleState = !this.toggleState;
            // Emit the toggle state of the filter
            this.valueChange.emit(this.toggleState);
        }
    }
    removeAddedClasses() {
        this.classes = {};
        this.classes['filter'] = true;
    }
}
FilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FilterComponent, selector: "bis-filter", inputs: { state: "state", checked: "checked" }, outputs: { valueChange: "valueChange" }, usesOnChanges: true, ngImport: i0, template: `
    <span [ngClass]="classes" (click)="toggle()">
      <ng-content></ng-content>
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-filter',
                    template: `
    <span [ngClass]="classes" (click)="toggle()">
      <ng-content></ng-content>
    </span>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { state: [{
                type: Input
            }], checked: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class FilterModule {
}
FilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: FilterModule, declarations: [FilterComponent,
        FilterWithCloseComponent], imports: [CommonModule], exports: [FilterComponent,
        FilterWithCloseComponent] });
FilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FilterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        FilterComponent,
                        FilterWithCloseComponent
                    ],
                    declarations: [
                        FilterComponent,
                        FilterWithCloseComponent
                    ],
                    providers: [],
                }]
        }] });

class FormBase {
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (newValue !== this._value) {
            this.writeValue(newValue);
            this._value = newValue;
        }
    }
}
FormBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormBase, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FormBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: FormBase, inputs: { value: "value" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormBase, decorators: [{
            type: Directive
        }], propDecorators: { value: [{
                type: Input
            }] } });

let _uniqueId$1 = 0;
class CheckboxComponent {
    constructor(elRef, controlContainer) {
        this.elRef = elRef;
        this.controlContainer = controlContainer;
        this.classCheckboxContainer = true;
        this._disabled = false;
        this.checked = false;
        this.tabindex = -1;
        /** Value of the checkbox and radio control. */
        this.valueChange = new EventEmitter();
        this.uniqueId = `bis-${++_uniqueId$1}`;
        this.ngOnDestroy$ = new Subject();
        this.id = this.uniqueId;
        this.onChangeCallback = () => {
        };
        this.onTouchedCallback = () => {
        }; // Not used yet but it's on the interface
    }
    set disabled(value) {
        this._disabled = value;
        if (this._disabled) {
            this.tabindex = -1;
        }
    }
    get disabled() {
        return this._disabled;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        this.setInitialValue();
    }
    /**
     * Checks if there is a value on the formControl,
     * if it is, it has priority so it setts that,
     * else setts the value on the input 'value'
     */
    setInitialValue() {
        if (this.hasControlContainer()) {
            this.checked = this.controlContainer.control.get(this.formControlName).value;
        }
        // set the checkbox to be false if no value has been provided
        if (!this.checked) {
            this.checked = false;
        }
    }
    hasControlContainer() {
        return this.controlContainer && this.formControlName && this.controlContainer.control.get(this.formControlName).value;
    }
    /**
     * When the label is clicked perform the click action also on the checkbox element
     * @param checkbox
     */
    triggerInput(checkbox, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (this.disabled) {
            return;
        }
        checkbox.checked = !checkbox.checked;
        this.writeValue(checkbox.checked);
        this.setValue(checkbox.checked);
        // Workaround for IE
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('change');
        }
        else {
            event = document.createEvent('Event');
            event.initEvent('change', false, true);
        }
        checkbox.dispatchEvent(event);
    }
    /**
     * Method that simply calls the onChangeCallback in order to propagate the data to the parrent component
     * @param selectValue
     */
    setValue(selectValue) {
        this.onChangeCallback(selectValue);
    }
    /**
     * It takes a new value from the form model and writes it into the view
     * @param value
     */
    writeValue(value) {
        if (value !== undefined) {
            this.checked = value;
        }
    }
    /**
     * Has access to a function that informs the outside world about changes
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Not used at the moment
     * Needs to be declared because of the implementation of ControlValueAccessor
     */
    registerOnTouched() {
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
CheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CheckboxComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CheckboxComponent, selector: "bis-checkbox", inputs: { checked: "checked", name: "name", formControlName: "formControlName", tabindex: "tabindex", disabled: "disabled", id: "id" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class.checkbox-container": "this.classCheckboxContainer" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CheckboxComponent, multi: true }], ngImport: i0, template: `
    <div class="checkbox" [tabindex]="tabindex">
      <input type="checkbox" [id]="id" #checkbox [checked]="checked" tabindex="-1"
             [disabled]="disabled" (change)="valueChange.emit($event)">
      <label [for]="id" (click)="triggerInput(checkbox, $event)"></label>
    </div>
    <label [for]="id" (click)="triggerInput(checkbox, $event)" [attr.type]="disabled ? 'disabled' : ''">
      <ng-content></ng-content>
    </label>`, isInline: true, styles: ["label[type=disabled]{color:#c4c4c4}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-checkbox', template: `
    <div class="checkbox" [tabindex]="tabindex">
      <input type="checkbox" [id]="id" #checkbox [checked]="checked" tabindex="-1"
             [disabled]="disabled" (change)="valueChange.emit($event)">
      <label [for]="id" (click)="triggerInput(checkbox, $event)"></label>
    </div>
    <label [for]="id" (click)="triggerInput(checkbox, $event)" [attr.type]="disabled ? 'disabled' : ''">
      <ng-content></ng-content>
    </label>`, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CheckboxComponent, multi: true }], preserveWhitespaces: false, styles: ["label[type=disabled]{color:#c4c4c4}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: i1$2.ControlContainer, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { classCheckboxContainer: [{
                type: HostBinding,
                args: ['class.checkbox-container']
            }], checked: [{
                type: Input
            }], name: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], disabled: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], id: [{
                type: Input
            }] } });

class BorderedCheckboxComponent {
    constructor() {
        this.borderedClass = true;
    }
}
BorderedCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BorderedCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BorderedCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: BorderedCheckboxComponent, selector: "bis-bordered-checkbox", inputs: { class: "class" }, host: { properties: { "class": "this.class", "class.checkbox--bordered": "this.borderedClass" } }, ngImport: i0, template: `
    <div class="checkbox--bordered__checkbox">
      <ng-content></ng-content>
    </div>

    <div class="checkbox--bordered__icon">
      <ng-content select="i, bis-icon, bis-note, bis-tooltip"></ng-content>
    </div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BorderedCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-bordered-checkbox',
                    template: `
    <div class="checkbox--bordered__checkbox">
      <ng-content></ng-content>
    </div>

    <div class="checkbox--bordered__icon">
      <ng-content select="i, bis-icon, bis-note, bis-tooltip"></ng-content>
    </div>
  `
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }, {
                type: Input
            }], borderedClass: [{
                type: HostBinding,
                args: ['class.checkbox--bordered']
            }] } });

class ListItemKeyComponent {
}
ListItemKeyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListItemKeyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ListItemKeyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ListItemKeyComponent, selector: "bis-list-item-key", viewQueries: [{ propertyName: "elementRef", first: true, predicate: ["listItemKey"], descendants: true }], ngImport: i0, template: `
    <dt #listItemKey class="descriptive-list__term">
      <ng-content></ng-content>
    </dt>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListItemKeyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-list-item-key',
                    template: `
    <dt #listItemKey class="descriptive-list__term">
      <ng-content></ng-content>
    </dt>
  `
                }]
        }], propDecorators: { elementRef: [{
                type: ViewChild,
                args: ['listItemKey', { static: false }]
            }] } });
class ListItemValueComponent {
}
ListItemValueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListItemValueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ListItemValueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ListItemValueComponent, selector: "bis-list-item-value", viewQueries: [{ propertyName: "elementRef", first: true, predicate: ["listItemValue"], descendants: true }], ngImport: i0, template: `
    <dd #listItemValue class="descriptive-list__description">
      <ng-content></ng-content>
    </dd>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListItemValueComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-list-item-value',
                    template: `
    <dd #listItemValue class="descriptive-list__description">
      <ng-content></ng-content>
    </dd>
  `
                }]
        }], propDecorators: { elementRef: [{
                type: ViewChild,
                args: ['listItemValue', { static: false }]
            }] } });
class DescriptiveItemComponent {
}
DescriptiveItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DescriptiveItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DescriptiveItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DescriptiveItemComponent, selector: "bis-descriptive-item", ngImport: i0, template: `
    <ng-content select="bis-list-item-key"></ng-content>
    <ng-content select="bis-list-item-value"></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DescriptiveItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-descriptive-item',
                    template: `
    <ng-content select="bis-list-item-key"></ng-content>
    <ng-content select="bis-list-item-value"></ng-content>
  `
                }]
        }] });
class ListItemComponent {
    constructor(elementRef, cd) {
        this.elementRef = elementRef;
        this.cd = cd;
        this.role = 'listitem';
        this.classes = {};
    }
    get classesAsString() {
        let classes = '';
        for (const item in this.classes) {
            if (this.classes.hasOwnProperty(item)) {
                classes += `${item} `;
            }
        }
        return classes;
    }
    // tslint:disable-next-line:no-input-rename
    set bulletColor(color) {
        this._bulletColor = color;
        this.attachBulletColor(color);
    }
    get bulletColor() {
        return this._bulletColor;
    }
    // tslint:disable-next-line:no-input-rename
    set listSpacer(_) {
        console.warn('list-spacer input is deprecated and will be removed in a future release. This functionality is no longer part of @bisnode/ui');
    }
    setClasses(type) {
        switch (type) {
            case 'unstyled':
                this.classes['unstyled-list__item'] = true;
                break;
            case 'colored':
                this.classes['colored-list__item'] = true;
                break;
            case 'dropdown':
                this.classes['dropdown-list__item'] = true;
                break;
            default:
                this.classes['list__item'] = true;
        }
        this.cd.detectChanges();
    }
    attachBulletColor(bulletColor) {
        if (!bulletColor) {
            return;
        }
        const className = 'colored-list__item--' + bulletColor;
        this.classes['colored-list__item'] = true;
        this.classes[className] = true;
    }
}
ListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListItemComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
ListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ListItemComponent, selector: "bis-list-item", inputs: { bulletColor: ["bullet-color", "bulletColor"], listSpacer: ["list-spacer", "listSpacer"] }, host: { properties: { "attr.role": "this.role", "class": "this.classesAsString" } }, queries: [{ propertyName: "listItemKeyComponent", first: true, predicate: ListItemKeyComponent, descendants: true }, { propertyName: "listItemValueComponent", first: true, predicate: ListItemValueComponent, descendants: true }], ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{display:list-item}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-list-item', template: `
    <ng-content></ng-content>
  `, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: [":host{display:list-item}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { listItemKeyComponent: [{
                type: ContentChild,
                args: [ListItemKeyComponent, { static: false }]
            }], listItemValueComponent: [{
                type: ContentChild,
                args: [ListItemValueComponent, { static: false }]
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], classesAsString: [{
                type: HostBinding,
                args: ['class']
            }], bulletColor: [{
                type: Input,
                args: ['bullet-color']
            }], listSpacer: [{
                type: Input,
                args: ['list-spacer']
            }] } });
class ListComponent {
    constructor() {
        this.classes = {};
    }
    set listItems(listItems) {
        listItems.map((listItem) => listItem.setClasses(this.type));
    }
    ngAfterContentInit() {
        this.setClasses(this.type);
    }
    ngOnChanges() {
        this.setClasses(this.type);
    }
    setClasses(type) {
        switch (type) {
            case 'unstyled':
                this.classes['list'] = true;
                this.classes['unstyled-list'] = true;
                break;
            case 'colored':
                this.classes['colored-list'] = true;
                break;
            case 'descriptive':
                this.classes['descriptive-list'] = true;
                break;
            case 'dropdown':
                this.classes['dropdown-list'] = true;
                break;
            default:
                this.classes['list'] = true;
        }
    }
}
ListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ListComponent, selector: "bis-list", inputs: { type: "type" }, queries: [{ propertyName: "listItems", predicate: ListItemComponent }], viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <ng-template #unorderedList>
      <ul #container [ngClass]="classes">
        <ng-content select="bis-list-item"></ng-content>
      </ul>
    </ng-template>

    <ng-template #descriptiveList>
      <dl #container [ngClass]="classes">
        <ng-content select="bis-descriptive-item"></ng-content>
      </dl>
    </ng-template>

    <ng-container
      *ngTemplateOutlet="type === 'descriptive' ? descriptiveList : unorderedList">
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-list',
                    template: `
    <ng-template #unorderedList>
      <ul #container [ngClass]="classes">
        <ng-content select="bis-list-item"></ng-content>
      </ul>
    </ng-template>

    <ng-template #descriptiveList>
      <dl #container [ngClass]="classes">
        <ng-content select="bis-descriptive-item"></ng-content>
      </dl>
    </ng-template>

    <ng-container
      *ngTemplateOutlet="type === 'descriptive' ? descriptiveList : unorderedList">
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { type: [{
                type: Input
            }], container: [{
                type: ViewChild,
                args: ['container', { static: false }]
            }], listItems: [{
                type: ContentChildren,
                args: [ListItemComponent]
            }] } });

class OptionDropdownSelectComponent {
    constructor(cd) {
        this.cd = cd;
        this.clicked$ = new EventEmitter();
        this.ngOnDestroy$ = new Subject();
        this.disabled = false;
        this.initialValues$ = new BehaviorSubject({ templateValue: null, content: null });
        this._isSelected = false;
    }
    get isSelected() {
        return this._isSelected;
    }
    set isSelected(newVal) {
        this._isSelected = newVal;
        this.cd.detectChanges();
    }
    clickHandler(event) {
        if (this.disabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        event.target.selectedValue = this.value;
        this.clicked$.emit({
            templateValue: this.value,
            content: this.listItemComponent.elementRef.nativeElement.textContent,
            domEvent: event
        });
    }
    ngAfterViewInit() {
        this.initialValues$.next({ templateValue: this.value, content: this.listItemComponent.elementRef.nativeElement.textContent });
        this.cd.detectChanges();
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
OptionDropdownSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OptionDropdownSelectComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
OptionDropdownSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: OptionDropdownSelectComponent, selector: "bis-option-dropdown-select", inputs: { value: "value", disabled: "disabled", isSelected: "isSelected" }, host: { listeners: { "click": "clickHandler($event)" }, properties: { "class.disabled": "this.disabled" } }, viewQueries: [{ propertyName: "listItemComponent", first: true, predicate: ListItemComponent, descendants: true, static: true }], ngImport: i0, template: `
    <bis-list-item>
      <ng-content class="content"></ng-content>
      <i *ngIf="isSelected" class="icon icon--check icon--small u-margin-left-small"></i>
    </bis-list-item>
  `, isInline: true, styles: [":host{display:block;padding:.25rem}:host.disabled{color:#aaa;cursor:default}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ListItemComponent, selector: "bis-list-item", inputs: ["bullet-color", "list-spacer"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: OptionDropdownSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-option-dropdown-select', template: `
    <bis-list-item>
      <ng-content class="content"></ng-content>
      <i *ngIf="isSelected" class="icon icon--check icon--small u-margin-left-small"></i>
    </bis-list-item>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:block;padding:.25rem}:host.disabled{color:#aaa;cursor:default}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { value: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: Input
            }], listItemComponent: [{
                type: ViewChild,
                args: [ListItemComponent, { static: true }]
            }], isSelected: [{
                type: Input
            }], clickHandler: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class DropdownSelectComponent {
    constructor(controlContainer, cd) {
        this.controlContainer = controlContainer;
        this.cd = cd;
        this.disabled = false;
        this.uppercase = false;
        this.addon = false;
        this.valueChange = new EventEmitter();
        this.optionMap = {};
        this.ngOnDestroy$ = new Subject();
        this.onChangeCallback = () => {
        };
        this.onTouchedCallback = () => {
        }; // Not used yet but it's on the interface
    }
    /** Value of the select control. */
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (newValue !== this._value) {
            this._value = newValue;
            if (this.defaultOptionSelect && this.defaultOption && this.defaultOptionSelect.value === newValue) {
                this.markSelectionForSingleElement(this.defaultOptionSelect);
            }
            if (this.optionElementList) {
                this.optionElementList.map((el) => {
                    if (el.value === newValue) {
                        this.markSelectionForSingleElement(el);
                    }
                });
            }
        }
    }
    onClick(event) {
        if (this.disabled === true) {
            event.stopPropagation();
        }
    }
    ngAfterContentInit() {
        this.setInitialValue();
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
        const optionMap = this.optionMap;
        this.optionElementList.map(function (option) {
            const optionObj = option.initialValues$.value;
            if (optionObj.templateValue !== null) {
                optionMap[optionObj.templateValue] = optionObj.content;
            }
        });
        if (this.defaultOptionSelect && this.defaultOption) {
            const defaultOptionSelectValue = this.defaultOptionSelect.initialValues$.value;
            optionMap[defaultOptionSelectValue.templateValue] = defaultOptionSelectValue.content;
        }
    }
    /**
     * Checks if there is a value on the formControl,
     * if it is, it has priority so it setts that,
     * else setts the value on the input 'value'
     */
    setInitialValue() {
        let value;
        if (this.hasControlContainer()) {
            this.controlContainer.control.get(this.formControlName).valueChanges
                .pipe(takeUntil(this.ngOnDestroy$), distinctUntilChanged())
                .subscribe((next) => {
                this.updateSelectValue(next.toString());
                this.cd.detectChanges();
            });
            value = this.controlContainer.control.get(this.formControlName).value;
        }
        else {
            value = this._value;
        }
        this.updateSelectedOptionValue(value);
        this.updateSelectValue(value);
    }
    hasControlContainer() {
        return this.controlContainer && this.formControlName && this.controlContainer.control.get(this.formControlName).value;
    }
    updateSelectedOptionValue(value) {
        if (!this.optionElementList) {
            return;
        }
        this.optionElementList
            .map((option) => {
            option.initialValues$
                .pipe(takeUntil(option.ngOnDestroy$), filter((elem) => elem.templateValue !== null && elem.content !== null))
                .subscribe((optionObj) => {
                if (this.value === optionObj.templateValue) {
                    this.markSelectionForSingleElement(option);
                    this.optionMap[optionObj.templateValue] = optionObj.content;
                }
            });
            option.clicked$
                .pipe(takeUntil(option.ngOnDestroy$))
                .subscribe((optionObj) => {
                this.updateOptionValueOnClick(optionObj, option);
            });
        });
        this.optionElementList.changes
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((list) => {
            list.map((option) => {
                option.clicked$
                    .pipe(takeUntil(option.ngOnDestroy$))
                    .subscribe((optionObj) => {
                    this.updateOptionValueOnClick(optionObj, option);
                });
            });
        });
    }
    updateOptionValueOnClick(optionObj, option) {
        this.updateSelectValue(optionObj.templateValue);
        this.optionMap[optionObj.templateValue] = optionObj.content;
        this.markSelectionForSingleElement(option);
        this.onChange(optionObj.domEvent);
    }
    markSelectionForSingleElement(element) {
        this.optionElementList.map(el => {
            el.isSelected = false;
            if (this.defaultOptionSelect) {
                this.defaultOptionSelect.isSelected = false;
            }
        });
        element.isSelected = true;
        this.cd.detectChanges();
    }
    updateSelectValue(value) {
        this.writeValue(value);
        this.setValue(value);
    }
    /**
     * Method used to emit a the passed in event to the subscribers of this EventEmitter
     * @param event
     */
    onChange(event) {
        this.valueChange.emit(event);
    }
    /**
     * Method that simply calls the onChangeCallback in order to propagate the data to the parrent component
     * @param selectValue
     */
    setValue(selectValue) {
        this.onChangeCallback(selectValue);
    }
    /**
     * It takes a new value from the form model and writes it into the view
     * @param value
     */
    writeValue(value) {
        if (value !== undefined) {
            this.value = value;
        }
    }
    /**
     * Has access to a function that informs the outside world about changes
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Not used at the moment
     * Needs to be declared because of the implementation of ControlValueAccessor
     */
    registerOnTouched() {
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
DropdownSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownSelectComponent, deps: [{ token: i1$2.ControlContainer, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DropdownSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: DropdownSelectComponent, selector: "bis-dropdown-select", inputs: { id: "id", formControlName: "formControlName", disabled: "disabled", size: "size", uppercase: "uppercase", addon: "addon", defaultOption: "defaultOption", value: "value" }, outputs: { valueChange: "valueChange" }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: DropdownSelectComponent, multi: true }], queries: [{ propertyName: "optionElementList", predicate: OptionDropdownSelectComponent }], viewQueries: [{ propertyName: "select", first: true, predicate: ["select"], descendants: true, static: true }, { propertyName: "defaultOptionSelect", first: true, predicate: ["defaultOptionSelected"], descendants: true }], ngImport: i0, template: `
    <bis-dropdown [disabled]="disabled">
      <button bis-btn btn-type="dropdown" (click)="onClick($event)" [ngClass]="{'u-text-capitalize': uppercase === false}" [disabled]="disabled">
      {{optionMap[value]}}
      <i class="icon icon--angle-down icon--small u-margin-left-xsmall"></i>
      </button>
      <bis-dropdown-body>
        <ul class="dropdown-list">
          <ng-container *ngIf="defaultOption">
            <bis-option-dropdown-select #defaultOptionSelected [value]="undefined" [disabled]="true"
                                        [isSelected]="true">
              {{defaultOption}}
            </bis-option-dropdown-select>
          </ng-container>
          <ng-content></ng-content>
        </ul>
      </bis-dropdown-body>
    </bis-dropdown>
  `, isInline: true, styles: [".dropdown-list{padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DropdownComponent, selector: "bis-dropdown", inputs: ["tabindex", "disabled"] }, { kind: "component", type: DropdownBodyComponent, selector: "bis-dropdown-body", inputs: ["position", "closeOnClick", "showBody"] }, { kind: "directive", type: ButtonDirective, selector: "button[bis-btn], a[bis-btn], input[bis-btn]", inputs: ["btn-type", "dropdown", "addon", "disabled"] }, { kind: "component", type: OptionDropdownSelectComponent, selector: "bis-option-dropdown-select", inputs: ["value", "disabled", "isSelected"] }], changeDetection: i0.ChangeDetectionStrategy.Default });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: DropdownSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-dropdown-select', template: `
    <bis-dropdown [disabled]="disabled">
      <button bis-btn btn-type="dropdown" (click)="onClick($event)" [ngClass]="{'u-text-capitalize': uppercase === false}" [disabled]="disabled">
      {{optionMap[value]}}
      <i class="icon icon--angle-down icon--small u-margin-left-xsmall"></i>
      </button>
      <bis-dropdown-body>
        <ul class="dropdown-list">
          <ng-container *ngIf="defaultOption">
            <bis-option-dropdown-select #defaultOptionSelected [value]="undefined" [disabled]="true"
                                        [isSelected]="true">
              {{defaultOption}}
            </bis-option-dropdown-select>
          </ng-container>
          <ng-content></ng-content>
        </ul>
      </bis-dropdown-body>
    </bis-dropdown>
  `, changeDetection: ChangeDetectionStrategy.Default, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: DropdownSelectComponent, multi: true }], preserveWhitespaces: false, styles: [".dropdown-list{padding:0}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1$2.ControlContainer, decorators: [{
                        type: Optional
                    }] }, { type: i0.ChangeDetectorRef }];
    }, propDecorators: { id: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], uppercase: [{
                type: Input
            }], addon: [{
                type: Input
            }], defaultOption: [{
                type: Input
            }], select: [{
                type: ViewChild,
                args: ['select', { static: true }]
            }], valueChange: [{
                type: Output
            }], optionElementList: [{
                type: ContentChildren,
                args: [OptionDropdownSelectComponent]
            }], defaultOptionSelect: [{
                type: ViewChild,
                args: ['defaultOptionSelected']
            }], value: [{
                type: Input
            }] } });

class InputDirective {
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
        this.addon = false;
        this.valueChange = new EventEmitter();
        this.tabindex = 0;
    }
    set state(state) {
        this._state = state;
        this.setStateClass(state);
    }
    get state() {
        return this._state;
    }
    ngOnInit() {
        this.setClasses();
        // Listen to changes and emit the event
        this.renderer.listen(this.elRef.nativeElement, 'change', this.onChange.bind(this));
    }
    /**
     * Method used to set the classes on the classes property
     * classes added here are set on the host component -> bis-input
     */
    setClasses() {
        if (!this.addon && (this.type === 'text' || this.type === 'email' || this.type === 'password' || this.type === 'date')) {
            this.renderer.addClass(this.elRef.nativeElement, 'form-control');
        }
        else {
            this.renderer.addClass(this.elRef.nativeElement, 'form-addon__input');
        }
    }
    setStateClass(state) {
        this.removePreviousStateClass();
        this.renderer.addClass(this.elRef.nativeElement, `form-control--${state}`);
    }
    removePreviousStateClass() {
        this.renderer.removeClass(this.elRef.nativeElement, 'form-control--success');
        this.renderer.removeClass(this.elRef.nativeElement, 'form-control--error');
    }
    /**
     * Method used to emit a the passed in event to the subscribers of this EventEmitter
     * @param event
     */
    onChange(event) {
        this.valueChange.emit(event);
    }
}
InputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: InputDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
InputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: InputDirective, selector: "input[bis-input]", inputs: { type: "type", addon: "addon", state: "state" }, outputs: { valueChange: "valueChange" }, host: { properties: { "attr.tabindex": "this.tabindex" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: InputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[bis-input]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { type: [{
                type: Input
            }], addon: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], state: [{
                type: Input
            }] } });

let _uniqueId = 0;
class RadioComponent extends FormBase {
    constructor(elRef, controlContainer) {
        super();
        this.elRef = elRef;
        this.controlContainer = controlContainer;
        this.classRadioContainer = true;
        this._disabled = false;
        this.checked = false;
        // Functionality inherited from the base class
        // It's defined here as well as typescript checks input properties on the child class
        this.tabindex = -1;
        this.valueChange = new EventEmitter();
        this.elementType = 'radio';
        this.uniqueId = `bis-${++_uniqueId}`;
        this.id = this.uniqueId;
        this.ngOnDestroy$ = new Subject();
        this.onChangeCallback = () => {
        };
        this.onTouchedCallback = () => {
        }; // Not used yet but it's on the interface
    }
    set disabled(value) {
        this._disabled = value;
        if (this._disabled) {
            this.tabindex = -1;
        }
    }
    get disabled() {
        return this._disabled;
    }
    ngAfterContentInit() {
        this.setInitialValue();
    }
    /**
     * Checks if there is a value on the formControl,
     * if it is, it has priority so it setts that,
     * else setts the value on the input 'value'
     */
    setInitialValue() {
        let value;
        if (this.hasControlContainer()) {
            this.controlContainer.control.get(this.formControlName).valueChanges
                .pipe(takeUntil(this.ngOnDestroy$))
                .subscribe((next) => {
                value = next;
                this.value = value;
            });
            value = this.controlContainer.control.get(this.formControlName).value;
        }
        else {
            value = this.value;
        }
        this.onChangeCallback(value);
    }
    hasControlContainer() {
        return this.controlContainer && this.formControlName && this.controlContainer.control.get(this.formControlName).value;
    }
    /**
     * When the label is clicked perform the click action also on the checkbox element
     * @param radio
     */
    triggerInput(radio, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (this.disabled) {
            return;
        }
        // when the radio is selected we don't want it to be unselected by itself - only if another radio is selected
        if (radio.checked) {
            return;
        }
        radio.checked = !radio.checked;
        // Workaround for IE
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('change');
        }
        else {
            event = document.createEvent('Event');
            event.initEvent('change', false, true);
        }
        radio.dispatchEvent(event);
    }
    writeValue() { }
    /**
     * Method used to emit a the passed in event to the subscribers of this EventEmitter
     * @param event
     */
    onChange(event) {
        this.valueChange.emit(this.value);
        this.setValue(this.value);
    }
    /**
     * Method that simply calls the onChangeCallback in order to propagate the data to the parrent component
     * @param selectValue
     */
    setValue(selectValue) {
        this.onChangeCallback(selectValue);
    }
    /**
     * Has access to a function that informs the outside world about changes
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Not used at the moment
     * Needs to be declared because of the implementation of ControlValueAccessor
     */
    registerOnTouched() {
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
RadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RadioComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Component });
RadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: RadioComponent, selector: "bis-radio", inputs: { checked: "checked", name: "name", formControlName: "formControlName", tabindex: "tabindex", disabled: "disabled", id: "id" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class.radio-container": "this.classRadioContainer", "attr.tabindex": "this.tabindex" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: RadioComponent, multi: true }], usesInheritance: true, ngImport: i0, template: `
    <div class="radio">
      <input type="radio" [id]="id" #radio [name]="name"
             [disabled]="disabled" [value]="value" (change)="onChange($event)" [checked]="checked">
      <label [for]="id" (click)="triggerInput(radio, $event)"></label>
    </div>
    <label [for]="id" (click)="triggerInput(radio, $event)" [attr.type]="disabled ? 'disabled' : ''">
      <ng-content></ng-content>
    </label>`, isInline: true, styles: ["label[type=disabled]{color:#c4c4c4}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-radio', template: `
    <div class="radio">
      <input type="radio" [id]="id" #radio [name]="name"
             [disabled]="disabled" [value]="value" (change)="onChange($event)" [checked]="checked">
      <label [for]="id" (click)="triggerInput(radio, $event)"></label>
    </div>
    <label [for]="id" (click)="triggerInput(radio, $event)" [attr.type]="disabled ? 'disabled' : ''">
      <ng-content></ng-content>
    </label>`, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: RadioComponent, multi: true }], preserveWhitespaces: false, styles: ["label[type=disabled]{color:#c4c4c4}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: i1$2.ControlContainer, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { classRadioContainer: [{
                type: HostBinding,
                args: ['class.radio-container']
            }], checked: [{
                type: Input
            }], name: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], tabindex: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.tabindex']
            }], disabled: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], id: [{
                type: Input
            }] } });

class SwitcherComponent extends FormBase {
    constructor(elRef, controlContainer) {
        super();
        this.elRef = elRef;
        this.controlContainer = controlContainer;
        this.classSwitchContainer = true;
        this.hostTabindex = -1;
        this._disabled = false;
        this.checked = false;
        this.tabindex = -1;
        this.valueChange = new EventEmitter();
        this.ngOnDestroy$ = new Subject();
        this.onChangeCallback = () => {
        };
        this.onTouchedCallback = () => {
        }; // Not used yet but it's on the interface
    }
    get value() {
        return this.switcherValue;
    }
    set value(value) {
        this.switcherValue = value;
    }
    set disabled(value) {
        this._disabled = value;
        if (this._disabled) {
            this.tabindex = -1;
        }
    }
    get disabled() {
        return this._disabled;
    }
    ngOnInit() {
        if (this._value) {
            this.setValue(this._value);
        }
        else {
            this.setValue(this.checked);
        }
        this.setInitialValue();
    }
    setInitialValue() {
        let value;
        if (this.hasControlContainer()) {
            this.controlContainer.control.get(this.formControlName).valueChanges
                .pipe(takeUntil(this.ngOnDestroy$), distinctUntilChanged())
                .subscribe((next) => {
                value = next;
                this.updateSelectValue(value);
            });
        }
        if (this.controlContainer && this.formControlName && this.controlContainer.control.get(this.formControlName).value) {
            value = this.controlContainer.control.get(this.formControlName).value;
        }
        else {
            value = this.value;
        }
        this.updateSelectValue(value);
    }
    hasControlContainer() {
        return this.controlContainer && this.formControlName && this.controlContainer.control.get(this.formControlName);
    }
    updateSelectValue(value) {
        this.writeValue(value);
    }
    /**
     * When the label is clicked perform the click action also on the checkbox element
     * @param checkbox
     */
    triggerInput(checkbox, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (this.disabled) {
            return;
        }
        // when the radio swicth is selected we don't want it to be unselected by itself - only if another radio is selected
        if (checkbox.getAttribute('type') === 'radio' && checkbox.checked) {
            return;
        }
        checkbox.checked = !checkbox.checked;
        // Workaround for IE
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('change');
        }
        else {
            event = document.createEvent('Event');
            event.initEvent('change', false, true);
        }
        checkbox.dispatchEvent(event);
    }
    /**
     * Method used to emit a the passed in event to the subscribers of this EventEmitter
     * @param event
     */
    onChange(event) {
        if (this.value && this.value.length) {
            this.valueChange.emit(this.value);
            this.setValue(this.value);
        }
        else {
            this.valueChange.emit(event);
            this.setValue(event.target.checked);
        }
    }
    /**
     * Method that simply calls the onChangeCallback in order to propagate the data to the parrent component
     * @param selectValue
     */
    setValue(selectValue) {
        this.onChangeCallback(selectValue);
    }
    /**
     * It takes a new value from the form model and writes it into the view
     * @param value
     */
    writeValue(value) {
        if (value !== undefined) {
            this._value = value;
            this.checked = !!value;
        }
    }
    /**
     * Has access to a function that informs the outside world about changes
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Not used at the moment
     * Needs to be declared because of the implementation of ControlValueAccessor
     */
    registerOnTouched() {
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
SwitcherComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SwitcherComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SwitcherComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: SwitcherComponent, selector: "bis-switch", inputs: { id: "id", checked: "checked", name: "name", formControlName: "formControlName", value: "value", tabindex: "tabindex", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class.switch-container": "this.classSwitchContainer", "attr.tabindex": "this.hostTabindex" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: SwitcherComponent, multi: true }], usesInheritance: true, ngImport: i0, template: `
    <div class="switch" (keydown.space)="triggerInput(checkbox, $event)" [tabindex]="tabindex">
      <input type="checkbox" [id]="id" #checkbox [checked]="checked" (change)="onChange($event)" [name]="name"
            [disabled]="disabled" tabindex="-1">
      <label [for]="id" (click)="triggerInput(checkbox, $event)"></label>
    </div>
    <label [for]="id" (click)="triggerInput(checkbox, $event)" [attr.type]="disabled ? 'disabled' : ''">
      <ng-content></ng-content>
    </label>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SwitcherComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-switch',
                    template: `
    <div class="switch" (keydown.space)="triggerInput(checkbox, $event)" [tabindex]="tabindex">
      <input type="checkbox" [id]="id" #checkbox [checked]="checked" (change)="onChange($event)" [name]="name"
            [disabled]="disabled" tabindex="-1">
      <label [for]="id" (click)="triggerInput(checkbox, $event)"></label>
    </div>
    <label [for]="id" (click)="triggerInput(checkbox, $event)" [attr.type]="disabled ? 'disabled' : ''">
      <ng-content></ng-content>
    </label>
  `,
                    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: SwitcherComponent, multi: true }],
                    preserveWhitespaces: false,
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: i1$2.ControlContainer, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { classSwitchContainer: [{
                type: HostBinding,
                args: ['class.switch-container']
            }], hostTabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], id: [{
                type: Input
            }], checked: [{
                type: Input
            }], name: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], value: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], disabled: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class RadioGroupDirective {
    constructor(controlContainer) {
        this.controlContainer = controlContainer;
        this.formControlName = null;
        this.valueChange = new EventEmitter();
        this._value = null;
        this._name = null;
        this.ngOnDestroy$ = new Subject();
        this.unsubscribe$ = new Subject();
        this.subscriptionMap = new Map();
        this.onChangeCallback = () => {
        };
        this.onTouchedCallback = () => {
        }; // Not used yet but it's on the interface
    }
    ngAfterContentInit() {
        if (this._switchers.length) {
            this.handleChildElementsValue(this._switchers);
            this._registerSwitcherChanges();
        }
        if (this._radios.length) {
            this.handleChildElementsValue(this._radios);
            this._registerRadioChanges();
        }
    }
    _registerSwitcherChanges() {
        this._switchers.changes
            .subscribe(changes => {
            this.handleChildElementsValue(changes);
        });
    }
    _registerRadioChanges() {
        this._radios.changes
            .subscribe(changes => {
            this.handleChildElementsValue(changes);
        });
    }
    ngOnChanges() {
        if (this._switchers && this._switchers.length) {
            this.handleChildElementsValue(this._switchers);
        }
        if (this._radios && this._radios.length) {
            this.handleChildElementsValue(this._radios);
        }
    }
    /**
     * Method that handles the switcher component / radio component so that their initial value is set if needed
     * Also emits on the valueChange event emiter if
     * @param elementList
     */
    handleChildElementsValue(elementList) {
        this.setValueFromControlContainer();
        this.checkElement(elementList);
        this.getCheckedElementValue(elementList);
        this.subscribeToElements(elementList);
    }
    /**
     * if there is value on the _value it'll goe through to the switchers
     * sets the switcher with coresponding value to be checked
     * @param elementList QueryList<SwitcherComponent | CheckboxComponent>
     */
    checkElement(elementList) {
        elementList
            .map((element) => element.checked = false);
        elementList
            .filter((element) => element.value === this._value)
            .map((element) => element.checked = true);
    }
    /**
     * Get initial switcher value if the switcher is checked
     * @param elementList QueryList<SwitcherComponent | CheckboxComponent>
     */
    getCheckedElementValue(elementList) {
        elementList
            .filter((element) => element.checked)
            .map((element) => this.setValue(element.value));
    }
    /**
     * Listen to changes on the switchers and update the value on the model
     * @param elementList QueryList<SwitcherComponent | CheckboxComponent>
     */
    subscribeToElements(elementList) {
        // unsubscribe from the previous valueChange observables
        this.unsubscribe$.next(true);
        elementList
            .map((element) => {
            element.valueChange
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(this.setValue.bind(this, element.value));
        });
    }
    /**
     * Checks if there is a value on the formControl,
     * if it is, it has priority so it setts that,
     * else sets the value on the input 'value'
     */
    setValueFromControlContainer() {
        if (this.hasControlContainer()) {
            let value;
            const control = this.controlContainer.control.get(this.formControlName);
            const oldSubscription = this.subscriptionMap.get(control);
            if (oldSubscription) {
                oldSubscription.unsubscribe();
            }
            const newSubscription = control.valueChanges
                .pipe(takeUntil(this.ngOnDestroy$))
                .subscribe((next) => {
                value = next;
                this.writeValue(value);
            });
            this.subscriptionMap.set(control, newSubscription);
            value = control.value;
            this.setValue(value);
            this.writeValue(value);
        }
        else {
            this.setValue(this.value);
            this.writeValue(this.value);
        }
    }
    hasControlContainer() {
        return this.controlContainer && this.formControlName && this.controlContainer.control.get(this.formControlName);
    }
    /**
     * Method that simply calls the onChangeCallback in order to propagate the data to the parent component
     * also emits on the valueChange Event Emitter
     * @param selectValue
     */
    setValue(value) {
        this.onChangeCallback(value);
        this.valueChange.emit(value);
    }
    /**
     * It takes a new value from the form model and writes it into the view
     * @param value
     */
    writeValue(value) {
        if (value !== undefined) {
            this._value = value;
            // value on the ngModel is sent after the component is inited
            // so there needs to be a retrigger for the cheking of the child elements
            if (this._switchers && this._switchers.length) {
                this.checkElement(this._switchers);
            }
            if (this._switchers && this._radios.length) {
                this.checkElement(this._radios);
            }
        }
    }
    /**
     * Has access to a function that informs the outside world about changes
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Not used at the moment
     * Needs to be declared because of the implementation of ControlValueAccessor
     */
    registerOnTouched() {
    }
    ngOnDestroy() {
        this.ngOnDestroy$.next(true);
        this.unsubscribe$.next(true);
    }
}
RadioGroupDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RadioGroupDirective, deps: [{ token: i1$2.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
RadioGroupDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: RadioGroupDirective, selector: "[bis-radio-group]", inputs: { formControlName: "formControlName", value: "value" }, outputs: { valueChange: "valueChange" }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: RadioGroupDirective, multi: true }], queries: [{ propertyName: "_switchers", predicate: SwitcherComponent, descendants: true }, { propertyName: "_radios", predicate: RadioComponent, descendants: true }], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RadioGroupDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bis-radio-group]',
                    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: RadioGroupDirective, multi: true }]
                }]
        }], ctorParameters: function () {
        return [{ type: i1$2.ControlContainer, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { formControlName: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], _switchers: [{
                type: ContentChildren,
                args: [SwitcherComponent, { descendants: true }]
            }], _radios: [{
                type: ContentChildren,
                args: [RadioComponent, { descendants: true }]
            }] } });

class FormGroupComponent {
    constructor() {
        this.formGroupClass = true;
    }
}
FormGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FormGroupComponent, selector: "bis-form-group", host: { properties: { "class.form-group": "this.formGroupClass" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-form-group', template: `
    <ng-content></ng-content>
  `, styles: [":host{display:block}\n"] }]
        }], propDecorators: { formGroupClass: [{
                type: HostBinding,
                args: ['class.form-group']
            }] } });
class FormAddonComponent {
    constructor() {
        this.formAddonClass = true;
    }
}
FormAddonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormAddonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormAddonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: FormAddonComponent, selector: "bis-form-addon", host: { properties: { "class.form-addon": "this.formAddonClass" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormAddonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-form-addon',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], propDecorators: { formAddonClass: [{
                type: HostBinding,
                args: ['class.form-addon']
            }] } });

class ListModule {
}
ListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ListModule, declarations: [ListComponent,
        ListItemComponent,
        ListItemKeyComponent,
        ListItemValueComponent,
        DescriptiveItemComponent], imports: [CommonModule], exports: [ListComponent,
        ListItemComponent,
        ListItemKeyComponent,
        ListItemValueComponent,
        DescriptiveItemComponent] });
ListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ListComponent,
                        ListItemComponent,
                        ListItemKeyComponent,
                        ListItemValueComponent,
                        DescriptiveItemComponent
                    ],
                    declarations: [
                        ListComponent,
                        ListItemComponent,
                        ListItemKeyComponent,
                        ListItemValueComponent,
                        DescriptiveItemComponent
                    ],
                    providers: [],
                }]
        }] });

const DECLARATIONS_EXPORTS = [
    InputDirective,
    FormGroupComponent,
    DropdownSelectComponent,
    OptionDropdownSelectComponent,
    CheckboxComponent,
    SwitcherComponent,
    RadioGroupDirective,
    RadioComponent,
    FormAddonComponent,
    BorderedCheckboxComponent
];
class FormModule {
}
FormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: FormModule, declarations: [InputDirective,
        FormGroupComponent,
        DropdownSelectComponent,
        OptionDropdownSelectComponent,
        CheckboxComponent,
        SwitcherComponent,
        RadioGroupDirective,
        RadioComponent,
        FormAddonComponent,
        BorderedCheckboxComponent], imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        DropdownModule,
        ListModule,
        ButtonModule], exports: [InputDirective,
        FormGroupComponent,
        DropdownSelectComponent,
        OptionDropdownSelectComponent,
        CheckboxComponent,
        SwitcherComponent,
        RadioGroupDirective,
        RadioComponent,
        FormAddonComponent,
        BorderedCheckboxComponent, FormsModule] });
FormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormModule, imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        DropdownModule,
        ListModule,
        ButtonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: FormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        ReactiveFormsModule,
                        CommonModule,
                        DropdownModule,
                        ListModule,
                        ButtonModule
                    ],
                    exports: [
                        DECLARATIONS_EXPORTS,
                        FormsModule,
                    ],
                    declarations: [
                        DECLARATIONS_EXPORTS,
                    ],
                    providers: [],
                }]
        }] });

class GridColumnClassCreator {
    constructor() {
        this.finalClassName = [];
    }
    setBreakPoints(responsiveColumn) {
        const breakpointAttributes = responsiveColumn
            ? Object.keys(responsiveColumn).map((breakpointKey) => `col-${breakpointKey}-${responsiveColumn[breakpointKey]}`)
            : null;
        if (breakpointAttributes) {
            this.finalClassName = this.finalClassName.concat(breakpointAttributes);
        }
    }
    setColumns(columns, collapse) {
        if (columns && collapse) {
            this.finalClassName = this.finalClassName.concat([`col-${collapse}-${columns}`]);
        }
        else if (columns) {
            this.finalClassName = this.finalClassName.concat([`col-${columns}`]);
        }
    }
    setOffset(offset) {
        const pushAttributes = offset
            ? Object.keys(offset).map(breakpointKey => `offset-${breakpointKey}-${offset[breakpointKey]}`)
            : null;
        if (pushAttributes) {
            this.finalClassName = this.finalClassName.concat(pushAttributes);
        }
    }
    setAlign(valign) {
        if (valign) {
            this.finalClassName = this.finalClassName.concat([`align-self-${valign}`]);
        }
    }
    setDefaultColumn(columns, responsiveColumn) {
        // Checks if any of the fields that hold column data has been set previously, adds 'col' as default behaviour
        if (!columns && !responsiveColumn) {
            this.finalClassName = this.finalClassName.concat(['col']);
        }
    }
    getFinalClassname() {
        return this.finalClassName;
    }
}
GridColumnClassCreator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: GridColumnClassCreator, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GridColumnClassCreator.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: GridColumnClassCreator });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: GridColumnClassCreator, decorators: [{
            type: Injectable
        }] });

class ColumnComponent {
    constructor(element, renderer, gridClass) {
        this.element = element;
        this.renderer = renderer;
        this.gridClass = gridClass;
        this.hostName = true;
    }
    ngOnInit() {
        this.gridClass.setBreakPoints(this.responsiveColumn);
        this.gridClass.setColumns(this.columns, this.collapse);
        this.gridClass.setOffset(this.offset);
        this.gridClass.setAlign(this.valign);
        this.gridClass.setDefaultColumn(this.columns, this.responsiveColumn);
        this.setClass(this.gridClass.getFinalClassname());
    }
    setClass(classNames) {
        classNames.forEach((className) => this.renderer.addClass(this.element.nativeElement, className));
    }
}
ColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ColumnComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: GridColumnClassCreator }], target: i0.ɵɵFactoryTarget.Component });
ColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ColumnComponent, selector: "bis-column", inputs: { responsiveColumn: "responsiveColumn", columns: "columns", offset: "offset", valign: "valign", collapse: "collapse" }, host: { properties: { "class.bis-host-column": "this.hostName" } }, providers: [GridColumnClassCreator], ngImport: i0, template: "<ng-content></ng-content>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-column', providers: [GridColumnClassCreator], template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: GridColumnClassCreator }]; }, propDecorators: { hostName: [{
                type: HostBinding,
                args: ['class.bis-host-column']
            }], responsiveColumn: [{
                type: Input
            }], columns: [{
                type: Input
            }], offset: [{
                type: Input
            }], valign: [{
                type: Input
            }], collapse: [{
                type: Input
            }] } });

class ContainerComponent {
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
        this.fluid = false;
    }
    ngOnInit() {
        this.containerType = this.fluid ? 'container-fluid' : 'container';
        this.renderer.addClass(this.elRef.nativeElement, this.containerType);
    }
}
ContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ContainerComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
ContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ContainerComponent, selector: "bis-container", inputs: { fluid: "fluid" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-container', template: `
    <ng-content></ng-content>
  `, styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { fluid: [{
                type: Input
            }] } });

class RowComponent {
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.hostName = true;
    }
    ngOnInit() {
        this.renderer.addClass(this.element.nativeElement, 'row');
        if (this.valign) {
            this.renderer.addClass(this.element.nativeElement, `align-items-${this.valign}`);
        }
        if (this.justify) {
            this.renderer.addClass(this.element.nativeElement, `justify-content-${this.justify}`);
        }
    }
}
RowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RowComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
RowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: RowComponent, selector: "bis-row", inputs: { valign: "valign", justify: "justify" }, host: { properties: { "class.bis-host-row": "this.hostName" } }, ngImport: i0, template: "<ng-content></ng-content>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: RowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-row', template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { hostName: [{
                type: HostBinding,
                args: ['class.bis-host-row']
            }], valign: [{
                type: Input
            }], justify: [{
                type: Input
            }] } });

class GridModule {
    static forRoot() {
        return {
            ngModule: GridModule
        };
    }
}
GridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: GridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: GridModule, declarations: [ContainerComponent,
        RowComponent,
        ColumnComponent], imports: [CommonModule], exports: [ContainerComponent,
        RowComponent,
        ColumnComponent] });
GridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: GridModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: GridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        ContainerComponent,
                        RowComponent,
                        ColumnComponent
                    ],
                    exports: [
                        ContainerComponent,
                        RowComponent,
                        ColumnComponent
                    ]
                }]
        }] });

class LevelComponent {
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
    }
    ngOnInit() {
        this.addClass();
    }
    addClass() {
        if (this.collapse) {
            this.renderer.addClass(this.elRef.nativeElement, `level--${this.collapse}-collapse`);
        }
        else {
            this.renderer.addClass(this.elRef.nativeElement, `level--md-collapse`);
        }
    }
}
LevelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
LevelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: LevelComponent, selector: "bis-level", inputs: { collapse: "collapse" }, host: { classAttribute: "level" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-level',
                    template: `
    <ng-content></ng-content>
  `,
                    host: {
                        'class': 'level'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { collapse: [{
                type: Input
            }] } });
class LevelGroupComponent {
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
    }
    ngOnInit() {
        this.addClass();
    }
    addClass() {
        this.renderer.addClass(this.elRef.nativeElement, `level__${this.position}`);
    }
}
LevelGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelGroupComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
LevelGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: LevelGroupComponent, selector: "bis-level-group", inputs: { position: "position" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-level-group',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { position: [{
                type: Input
            }] } });
class LevelItemComponent {
}
LevelItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LevelItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: LevelItemComponent, selector: "bis-level-item", host: { classAttribute: "level__item" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-level-item',
                    template: `
    <ng-content></ng-content>
  `,
                    host: {
                        'class': 'level__item'
                    }
                }]
        }] });

class LevelModule {
}
LevelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LevelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: LevelModule, declarations: [LevelComponent,
        LevelGroupComponent,
        LevelItemComponent], exports: [LevelComponent,
        LevelGroupComponent,
        LevelItemComponent] });
LevelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: LevelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [
                        LevelComponent,
                        LevelGroupComponent,
                        LevelItemComponent
                    ],
                    declarations: [
                        LevelComponent,
                        LevelGroupComponent,
                        LevelItemComponent
                    ],
                    providers: [],
                }]
        }] });

class MediaObjectComponent {
}
MediaObjectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MediaObjectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: MediaObjectComponent, selector: "bis-media-object", host: { classAttribute: "media-object" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-media-object',
                    template: `
    <ng-content></ng-content>
  `,
                    host: { 'class': 'media-object' }
                }]
        }] });
class MediaObjectTitleComponent {
}
MediaObjectTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectTitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MediaObjectTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: MediaObjectTitleComponent, selector: "bis-media-object-title", host: { classAttribute: "media-object__title" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectTitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-media-object-title',
                    template: `
    <ng-content></ng-content>
  `,
                    host: { 'class': 'media-object__title' }
                }]
        }] });
class MediaObjectImageComponent {
}
MediaObjectImageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectImageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MediaObjectImageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: MediaObjectImageComponent, selector: "bis-media-object-image", inputs: { src: "src", height: "height", width: "width" }, host: { classAttribute: "media-object__image" }, ngImport: i0, template: `
    <img src="{{src}}" height="{{height}}" width="{{width}}">
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectImageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-media-object-image',
                    template: `
    <img src="{{src}}" height="{{height}}" width="{{width}}">
  `,
                    host: { 'class': 'media-object__image' }
                }]
        }], propDecorators: { src: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }] } });
class MediaObjectToolbarComponent {
}
MediaObjectToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MediaObjectToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: MediaObjectToolbarComponent, selector: "bis-media-object-toolbar", host: { classAttribute: "media-object__toolbar" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectToolbarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-media-object-toolbar',
                    template: `
    <ng-content></ng-content>
  `,
                    host: { 'class': 'media-object__toolbar' }
                }]
        }] });

class MediaObjectModule {
}
MediaObjectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MediaObjectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectModule, declarations: [MediaObjectComponent,
        MediaObjectTitleComponent,
        MediaObjectImageComponent,
        MediaObjectToolbarComponent], imports: [CommonModule], exports: [MediaObjectComponent,
        MediaObjectTitleComponent,
        MediaObjectImageComponent,
        MediaObjectToolbarComponent] });
MediaObjectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: MediaObjectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MediaObjectComponent,
                        MediaObjectTitleComponent,
                        MediaObjectImageComponent,
                        MediaObjectToolbarComponent,
                    ],
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        MediaObjectComponent,
                        MediaObjectTitleComponent,
                        MediaObjectImageComponent,
                        MediaObjectToolbarComponent,
                    ],
                    providers: [],
                }]
        }] });

class ModalComponent {
    constructor() {
        this.open = false;
        this.modalBackdrop = true;
        this.size = 'medium';
        this.scrollable = true;
    }
}
ModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ModalComponent, selector: "bis-modal", inputs: { open: "open", size: "size", scrollable: "scrollable" }, host: { properties: { "class.modal-backdrop--open": "this.open", "class.modal-backdrop": "this.modalBackdrop" } }, ngImport: i0, template: `
    <div class="modal modal--{{size}}" [class.modal--scroll]="scrollable">
      <ng-content></ng-content>
    </div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-modal',
                    template: `
    <div class="modal modal--{{size}}" [class.modal--scroll]="scrollable">
      <ng-content></ng-content>
    </div>
  `
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { open: [{
                type: HostBinding,
                args: ['class.modal-backdrop--open']
            }, {
                type: Input
            }], modalBackdrop: [{
                type: HostBinding,
                args: ['class.modal-backdrop']
            }], size: [{
                type: Input
            }], scrollable: [{
                type: Input
            }] } });

class ModalModule {
}
ModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ModalModule, declarations: [ModalComponent], exports: [ModalComponent] });
ModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ModalModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [ModalComponent],
                    declarations: [ModalComponent],
                    providers: [],
                }]
        }] });

class NavigationService {
    constructor() {
        this.toggleMenu$ = new Subject();
    }
    setToggleMenuObservable(type, isActive) {
        this.toggleMenu$.next({ type, isActive });
    }
    getToggleMenuObservable() {
        return this.toggleMenu$;
    }
}
NavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable
        }] });

class ContentBelowBreakpointComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
        this.breakpoint = 'lg';
        this.onClick = new EventEmitter();
        this.active = false;
        this.destroySubscription$ = new EventEmitter();
        this.classes = {};
        this.navigationService.getToggleMenuObservable()
            .pipe(takeUntil(this.destroySubscription$), filter(({ type }) => type === this.contentFor))
            .subscribe(({ isActive }) => {
            this.active = isActive;
        });
    }
    ngOnInit() {
        this.setClasses();
    }
    /**
     * Method used to emit on the onClik EventEmitter when a click was performed
     * @param event
     */
    handleClick(event) {
        this.active = !this.active;
        event.stopPropagation();
        this.onClick.emit();
    }
    /**
     * Method used to set classes on the span element
     */
    setClasses() {
        this.classes['navbar__menu-item'] = true;
        this.classes['icon-field'] = true;
        this.classes['icon-field--vertical'] = true;
        this.classes[`u-display-${this.breakpoint}-none`] = true;
    }
    ngOnDestroy() {
        this.destroySubscription$.next(true);
    }
}
ContentBelowBreakpointComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ContentBelowBreakpointComponent, deps: [{ token: NavigationService }], target: i0.ɵɵFactoryTarget.Component });
ContentBelowBreakpointComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ContentBelowBreakpointComponent, selector: "bis-content-below-breakpoint", inputs: { breakpoint: "breakpoint", contentFor: ["content-for", "contentFor"] }, outputs: { onClick: "onClick" }, viewQueries: [{ propertyName: "breakpointElRef", first: true, predicate: ["breakpoint"], descendants: true }], ngImport: i0, template: `
    <span [ngClass]="classes" #breakpoint [class.navbar__menu-item--selected]="active" (click)="handleClick($event)">
      <ng-content></ng-content>
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ContentBelowBreakpointComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-content-below-breakpoint',
                    template: `
    <span [ngClass]="classes" #breakpoint [class.navbar__menu-item--selected]="active" (click)="handleClick($event)">
      <ng-content></ng-content>
    </span>
  `
                }]
        }], ctorParameters: function () { return [{ type: NavigationService }]; }, propDecorators: { breakpoint: [{
                type: Input
            }], contentFor: [{
                type: Input,
                args: ['content-for']
            }], breakpointElRef: [{
                type: ViewChild,
                args: ['breakpoint', { static: false }]
            }], onClick: [{
                type: Output
            }] } });
class NavigationItemComponent {
    constructor(renderer, navigationItem, navigationService) {
        this.renderer = renderer;
        this.navigationItem = navigationItem;
        this.navigationService = navigationService;
        this.tabindex = -1;
    }
    set selected(value) {
        if (value !== this._selected) {
            this._selected = value;
            this.selected ? this.markAsSelected() : this.unmarkSelected();
        }
    }
    get selected() {
        return this._selected;
    }
    ngOnChanges() {
        // On changes handle the selection actions
        // this.selected ? this.markAsSelected() : this.unmarkSelected();
    }
    /**
     * Method that adds the selected class to the host element
    */
    markAsSelected() {
        // Toggle menu dropdown only if selected is set to false
        Promise.resolve().then(() => this.navigationService.setToggleMenuObservable('menu', false));
        this.renderer.addClass(this.navigationItem.nativeElement, 'navbar__menu-item--selected');
    }
    /**
     * Method that removes the selected class from the host element
    */
    unmarkSelected() {
        this.renderer.removeClass(this.navigationItem.nativeElement, 'navbar__menu-item--selected');
    }
}
NavigationItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationItemComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Component });
NavigationItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NavigationItemComponent, selector: "bis-navigation-item", inputs: { selected: "selected", tabindex: "tabindex" }, host: { properties: { "attr.tabindex": "this.tabindex" }, classAttribute: "navbar__menu-item icon-field icon-field--vertical icon-field--vertical-md-collapse" }, usesOnChanges: true, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host:focus{outline:none}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-navigation-item', template: `
    <ng-content></ng-content>
  `, host: {
                        'class': 'navbar__menu-item icon-field icon-field--vertical icon-field--vertical-md-collapse'
                    }, styles: [":host:focus{outline:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: NavigationService }]; }, propDecorators: { selected: [{
                type: Input
            }], tabindex: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.tabindex']
            }] } });
const MD_WIDTH = 991;
class CollapsableComponent {
    constructor(navigationService, document, collapsableElement) {
        this.navigationService = navigationService;
        this.document = document;
        this.collapsableElement = collapsableElement;
        // tslint:disable-next-line:no-input-rename
        this.collapsePoint = 'md';
        this.inverse = false;
        this.open = false;
        this.stringClasses = '';
        this.classes = {};
        this.collapsed = false;
        this.navTypeClasses = {};
    }
    onResize() {
        this.collapsed = window.innerWidth <= MD_WIDTH;
        const selectedTab = this.selectedTab(this.type);
        if (!this.collapsed) {
            this.navigationService.setToggleMenuObservable(selectedTab, false);
        }
    }
    selectedTab(type) {
        return type === this.type ? this.type : undefined;
    }
    clickout(event) {
        if (this.type && !this.collapsableElement.nativeElement.contains(event.target) && this.open) {
            this.navigationService.setToggleMenuObservable(this.type, false);
        }
    }
    closeOnEnter(event) {
        if (this.type === 'search' && event.key === 'Enter') {
            this.navigationService.setToggleMenuObservable('search', false);
        }
    }
    convertClassesAsString(classes) {
        this.stringClasses = '';
        Object.keys(classes)
            .forEach(className => this.stringClasses += `${className} `);
    }
    ngOnInit() {
        this.applyClasses();
        this.createBackDropContainer();
    }
    ngOnDestroy() {
        this.document.body.removeChild(this.backDropContainer);
    }
    createBackDropContainer() {
        const body = this.document.body;
        this.backDropContainer = this.document.createElement('div');
        this.backDropContainer.classList.add('modal-backdrop-container');
        this.backDropContainer.classList.add('navbar-backdrop');
        body.appendChild(this.backDropContainer);
    }
    ngAfterContentInit() {
        this.navigationService.getToggleMenuObservable()
            .subscribe(({ type, isActive }) => {
            this.handleCollapsableToggle(type, isActive);
        });
    }
    /**
     * Applies classes on the container and nav elements
     */
    applyClasses() {
        this.applyContainerClasses();
        this.applyNavClasses();
        this.convertClassesAsString(this.classes);
    }
    /**
     * Applies classes on the wrapper element
     */
    applyContainerClasses() {
        this.classes['collapsable'] = true;
        this.classes[`collapsable--${this.collapsePoint}-collapse`] = true;
        if (this.width) {
            this.classes[`u-width-${this.width}`] = true;
        }
    }
    /**
     * Applies classes on the child element which contains either a search or a menu
     */
    applyNavClasses() {
        this.navTypeClasses['collapsable__inner'] = true;
        if (this.type === 'search') {
            this.navTypeClasses['form-addon'] = true;
        }
        else {
            this.navTypeClasses['navbar__menu'] = true;
        }
    }
    /**
     * update backdrop html element when menu is toggled
     */
    updateBackdropHTMLElement() {
        if (this.backDropContainer.hasChildNodes()) {
            this.backDropContainer.removeChild(this.backDropContainer.childNodes[0]);
        }
        if (this.open) {
            const backdropElement = this.document.createElement('div');
            backdropElement.classList.add('modal-backdrop');
            backdropElement.style.display = 'block';
            this.backDropContainer.appendChild(backdropElement);
        }
    }
    /**
     * Method used to handle the toggle of the collapsable based on the nav type clicked
     * @param type
     */
    handleCollapsableToggle(type, isOpen) {
        if (type === this.type) {
            this.open = isOpen;
        }
        else {
            this.open = false;
        }
        this.updateBackdropHTMLElement();
    }
}
CollapsableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CollapsableComponent, deps: [{ token: NavigationService }, { token: DOCUMENT }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CollapsableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: CollapsableComponent, selector: "bis-collapsable", inputs: { collapsePoint: ["collapse-point", "collapsePoint"], type: "type", width: "width", inverse: "inverse" }, host: { listeners: { "window:resize": "onResize()", "document:click": "clickout($event)", "document:keyup": "closeOnEnter($event)" }, properties: { "class.collapsable--open": "this.open", "class": "this.stringClasses" } }, queries: [{ propertyName: "queryListNavItemComponents", predicate: NavigationItemComponent }], ngImport: i0, template: `
    <div [ngClass]="navTypeClasses" [class.nav-search--inverse]="inverse">
      <ng-content></ng-content>
    </div>
 `, isInline: true, styles: [":host{-webkit-appearance:none;outline-offset:0}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: CollapsableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-collapsable', template: `
    <div [ngClass]="navTypeClasses" [class.nav-search--inverse]="inverse">
      <ng-content></ng-content>
    </div>
 `, styles: [":host{-webkit-appearance:none;outline-offset:0}\n"] }]
        }], ctorParameters: function () {
        return [{ type: NavigationService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: i0.ElementRef }];
    }, propDecorators: { collapsePoint: [{
                type: Input,
                args: ['collapse-point']
            }], type: [{
                type: Input
            }], width: [{
                type: Input
            }], inverse: [{
                type: Input
            }], queryListNavItemComponents: [{
                type: ContentChildren,
                args: [NavigationItemComponent]
            }], open: [{
                type: HostBinding,
                args: ['class.collapsable--open']
            }], stringClasses: [{
                type: HostBinding,
                args: ['class']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }], clickout: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }], closeOnEnter: [{
                type: HostListener,
                args: ['document:keyup', ['$event']]
            }] } });
class NavigationbarContentComponent {
    // public setActive = false;
    constructor(elRef, renderer, navigationService) {
        this.elRef = elRef;
        this.renderer = renderer;
        this.navigationService = navigationService;
        this.classes = {};
    }
    ngOnInit() {
        this.setClasses(this.position);
    }
    ngAfterViewInit() {
        this.checkBeforeAppend();
        this.onToggleableContentEvent(this.belowBreakpointElements);
    }
    /**
     * Method used to apply the correct class on the container element depending on the input provided through attribute binding
     * @param position
     */
    setClasses(position) {
        if (!position) {
            return;
        }
        this.classes[`navbar__${position}`] = true;
    }
    /**
     * Method used to check if the selector is bis-navigation,
     * then it renders the correct template for the bis-navigation
     */
    checkForNavigationSelector() {
        if (this.elRef.nativeElement.tagName === 'BIS-NAVIGATION') {
            return true;
        }
        return false;
    }
    /**
     * Calls the appendChild, appendChildren methods if criterias ar met
     * if there is a collapsable element inside the bis-navbar-content, it appends the collapsable element
     * if there are also below breakpoint elements it appends them as well
     */
    checkBeforeAppend() {
        // If there is no collapsable element just return we should not append children because there are none
        if (!this.collapsableElement) {
            return;
        }
        // If we have belowBreakpointElements append them to the container
        if (this.belowBreakpointElements) {
            this.appendChildren(this.navbarContentContainer, this.belowBreakpointElements);
        }
    }
    /**
     * Method used to append belowBreakpoint QueryList components to the container element in the view using the renderer
     */
    appendChildren(container, queryElements) {
        queryElements.map((element) => {
            this.renderer.appendChild(container.nativeElement, element.breakpointElRef.nativeElement);
        });
    }
    /**
     * Subscribe to event emitters
     * @param menuElements
     */
    onToggleableContentEvent(menuElements) {
        menuElements.map((element, index) => {
            element.onClick
                .subscribe(this.onToggleableContentClick.bind(this, index));
        });
    }
    onToggleableContentClick(index) {
        const element = this.belowBreakpointElements.toArray()[index];
        const clickedElementState = this.belowBreakpointElements.toArray()[index].active;
        this.belowBreakpointElements
            .map((breakpointElement) => {
            breakpointElement.active = false;
        });
        // Set only current element that was clicked on to true
        element.active = clickedElementState;
        // send the breakpoint content type to the service so that the toggle will be based on that
        const { active } = this.belowBreakpointElements.find((component) => component.contentFor === element.contentFor);
        this.navigationService.setToggleMenuObservable(element.contentFor, active);
    }
}
NavigationbarContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationbarContentComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Component });
NavigationbarContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NavigationbarContentComponent, selector: "bis-navbar-content", inputs: { position: "position" }, queries: [{ propertyName: "collapsableElement", first: true, predicate: CollapsableComponent, descendants: true }, { propertyName: "belowBreakpointElements", predicate: ContentBelowBreakpointComponent }], viewQueries: [{ propertyName: "navbarContentContainer", first: true, predicate: ["navbarContent"], descendants: true }], ngImport: i0, template: `
    <div [ngClass]="classes" #navbarContent>
      <ng-content></ng-content>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationbarContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-navbar-content',
                    template: `
    <div [ngClass]="classes" #navbarContent>
      <ng-content></ng-content>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: NavigationService }]; }, propDecorators: { position: [{
                type: Input
            }], navbarContentContainer: [{
                type: ViewChild,
                args: ['navbarContent', { static: false }]
            }], collapsableElement: [{
                type: ContentChild,
                args: [CollapsableComponent, { static: false }]
            }], belowBreakpointElements: [{
                type: ContentChildren,
                args: [ContentBelowBreakpointComponent]
            }] } });
class NavigationbarContainerComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.inverse = false;
        this.fixed = false;
    }
    ngAfterViewInit() {
        this.appendChildren(this.navbarContainer, this.navigationbarContentElements);
    }
    /**
     * Method used to append the elements inside the NavigationbarContentComponent
     * due to the fact it has two selectors and templates which change based on the selector used,
     * we need to append the different types of elements nad a check is performed for this
     * renderer is used to append the content to the container element without adding the angular selector to the DOM
     * @param container
     * @param children
     */
    appendChildren(container, children) {
        children.map((element) => {
            if (element.navbarContentContainer) {
                this.renderer.appendChild(container.nativeElement, element.navbarContentContainer.nativeElement);
            }
        });
    }
}
NavigationbarContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationbarContainerComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
NavigationbarContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NavigationbarContainerComponent, selector: "bis-navbar", inputs: { inverse: "inverse", fixed: "fixed" }, queries: [{ propertyName: "navigationbarContentElements", predicate: NavigationbarContentComponent }], viewQueries: [{ propertyName: "navbarContainer", first: true, predicate: ["navbarContainer"], descendants: true }], ngImport: i0, template: `
    <section class="navbar-container" [class.navbar-container--inverse]="inverse" [class.navbar-container--fixed]="fixed">
      <div class="navbar" #navbarContainer></div>
    </section>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationbarContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-navbar',
                    template: `
    <section class="navbar-container" [class.navbar-container--inverse]="inverse" [class.navbar-container--fixed]="fixed">
      <div class="navbar" #navbarContainer></div>
    </section>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { inverse: [{
                type: Input
            }], fixed: [{
                type: Input
            }], navbarContainer: [{
                type: ViewChild,
                args: ['navbarContainer', { static: false }]
            }], navigationbarContentElements: [{
                type: ContentChildren,
                args: [NavigationbarContentComponent]
            }] } });

class NavigationModule {
}
NavigationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavigationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: NavigationModule, declarations: [NavigationbarContainerComponent,
        NavigationbarContentComponent,
        CollapsableComponent,
        NavigationItemComponent,
        ContentBelowBreakpointComponent], imports: [CommonModule], exports: [NavigationbarContainerComponent,
        NavigationbarContentComponent,
        CollapsableComponent,
        NavigationItemComponent,
        ContentBelowBreakpointComponent] });
NavigationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationModule, providers: [
        NavigationService
    ], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        NavigationbarContainerComponent,
                        NavigationbarContentComponent,
                        CollapsableComponent,
                        NavigationItemComponent,
                        ContentBelowBreakpointComponent
                    ],
                    declarations: [
                        NavigationbarContainerComponent,
                        NavigationbarContentComponent,
                        CollapsableComponent,
                        NavigationItemComponent,
                        ContentBelowBreakpointComponent
                    ],
                    providers: [
                        NavigationService
                    ],
                }]
        }] });

class NoteTitleComponent {
    constructor() {
        this.onClose = new EventEmitter();
    }
    /**
     * Method used to emit to the onClose EventEmitter
     */
    close() {
        this.onClose.emit();
    }
}
NoteTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteTitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NoteTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NoteTitleComponent, selector: "bis-note-title", outputs: { onClose: "onClose" }, viewQueries: [{ propertyName: "headerRef", first: true, predicate: ["headerRef"], descendants: true }], ngImport: i0, template: `
    <h2 class="note-content__header" #headerRef>
      <span>
        <ng-content></ng-content>
      </span>
      <i class="icon icon--close" (click)="close()"></i>
    </h2>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteTitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-note-title',
                    template: `
    <h2 class="note-content__header" #headerRef>
      <span>
        <ng-content></ng-content>
      </span>
      <i class="icon icon--close" (click)="close()"></i>
    </h2>
  `
                }]
        }], propDecorators: { headerRef: [{
                type: ViewChild,
                args: ['headerRef', { static: false }]
            }], onClose: [{
                type: Output
            }] } });
class NoteContentComponent {
}
NoteContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NoteContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NoteContentComponent, selector: "bis-note-content", viewQueries: [{ propertyName: "contentRef", first: true, predicate: ["contentRef"], descendants: true }], ngImport: i0, template: `
    <p class="note-content__text" #contentRef>
      <ng-content></ng-content>
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-note-content',
                    template: `
    <p class="note-content__text" #contentRef>
      <ng-content></ng-content>
    </p>
  `
                }]
        }], propDecorators: { contentRef: [{
                type: ViewChild,
                args: ['contentRef', { static: false }]
            }] } });
class NoteListItemComponent {
}
NoteListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NoteListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NoteListItemComponent, selector: "bis-note-list-item", viewQueries: [{ propertyName: "listItemRef", first: true, predicate: ["listItem"], descendants: true }], ngImport: i0, template: `
    <li class="list__item note-content__text" #listItem>
      <ng-content></ng-content>
    </li>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteListItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-note-list-item',
                    template: `
    <li class="list__item note-content__text" #listItem>
      <ng-content></ng-content>
    </li>
  `
                }]
        }], propDecorators: { listItemRef: [{
                type: ViewChild,
                args: ['listItem', { static: false }]
            }] } });
class NoteListComponent {
    constructor(renderer) {
        this.renderer = renderer;
    }
    ngAfterViewInit() {
        if (this.listItemList) {
            this.listItemList.map((item) => {
                this.renderer.appendChild(this.listRef.nativeElement, item.listItemRef.nativeElement);
                this.renderer.setStyle(this.listRef.nativeElement, 'list-style-type', 'disc');
            });
        }
    }
}
NoteListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteListComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
NoteListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NoteListComponent, selector: "bis-note-list", queries: [{ propertyName: "listItemList", predicate: NoteListItemComponent }], viewQueries: [{ propertyName: "listRef", first: true, predicate: ["list"], descendants: true }], ngImport: i0, template: `
    <ul class="list" #list>
      <ng-content></ng-content>
    </ul>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-note-list',
                    template: `
    <ul class="list" #list>
      <ng-content></ng-content>
    </ul>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { listRef: [{
                type: ViewChild,
                args: ['list', { static: false }]
            }], listItemList: [{
                type: ContentChildren,
                args: [NoteListItemComponent]
            }] } });
class NoteComponent {
    constructor(renderer, cd, elRef) {
        this.renderer = renderer;
        this.cd = cd;
        this.elRef = elRef;
        this.bodyVisible = false;
        this.classes = {};
        this.listenerFn = null;
        this.onDestroy$ = new EventEmitter();
        this.hideBody = () => {
            this.bodyVisible = false;
            this.cd.markForCheck();
        };
    }
    set titleComponent(titleComponent) {
        if (!titleComponent) {
            return;
        }
        // destroy previous subscription if the title component has been reset (ex: *ngIf)
        this.onDestroy$.next(undefined);
        this.registerTitleCloseEvents(titleComponent);
    }
    ngOnInit() {
        this.addClasses();
        this.closeWhenClickedOutside();
    }
    showBody() {
        this.bodyVisible = true;
    }
    /**
     * Method used to add classes to the
     */
    addClasses() {
        if (this.direction) {
            this.classes[`note__body--${this.direction}`] = true;
        }
    }
    registerTitleCloseEvents(titleComponent) {
        titleComponent.onClose
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(this.hideBody);
    }
    closeWhenClickedOutside() {
        this.listenerFn = this.renderer.listen(document, 'click', (event) => {
            if (this.bodyVisible && !this.bodyClicked(event.target)) {
                this.hideBody();
            }
        });
    }
    bodyClicked(targetElement) {
        return this.elRef.nativeElement.contains(targetElement);
    }
    ngOnDestroy() {
        this.listenerFn();
        this.onDestroy$.next(undefined);
    }
}
NoteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
NoteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: NoteComponent, selector: "bis-note", inputs: { direction: "direction" }, queries: [{ propertyName: "titleComponent", first: true, predicate: NoteTitleComponent, descendants: true }], ngImport: i0, template: `
    <div class="note" tabindex="0">
      <span (click)="showBody()" class="note__label">
        <ng-content select="[bis-note-label]"></ng-content>
      </span>
      <div class="note__body note__body--visible" *ngIf="bodyVisible" [ngClass]="classes">
        <div class="note-content">
          <ng-content ngProjectAs="bis-note-title"></ng-content>
          <ng-content ngProjectAs="bis-note-content"></ng-content>
          <ng-content ngProjectAs="bis-note-list"></ng-content>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".note__body--visible{display:block;visibility:visible;opacity:1}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-note', template: `
    <div class="note" tabindex="0">
      <span (click)="showBody()" class="note__label">
        <ng-content select="[bis-note-label]"></ng-content>
      </span>
      <div class="note__body note__body--visible" *ngIf="bodyVisible" [ngClass]="classes">
        <div class="note-content">
          <ng-content ngProjectAs="bis-note-title"></ng-content>
          <ng-content ngProjectAs="bis-note-content"></ng-content>
          <ng-content ngProjectAs="bis-note-list"></ng-content>
        </div>
      </div>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: [".note__body--visible{display:block;visibility:visible;opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { direction: [{
                type: Input
            }], titleComponent: [{
                type: ContentChild,
                args: [NoteTitleComponent, { static: false }]
            }] } });

class NoteModule {
}
NoteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NoteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: NoteModule, declarations: [NoteComponent,
        NoteContentComponent,
        NoteTitleComponent,
        NoteListComponent,
        NoteListItemComponent], imports: [CommonModule], exports: [NoteComponent,
        NoteContentComponent,
        NoteTitleComponent,
        NoteListComponent,
        NoteListItemComponent] });
NoteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: NoteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        NoteComponent,
                        NoteContentComponent,
                        NoteTitleComponent,
                        NoteListComponent,
                        NoteListItemComponent
                    ],
                    declarations: [
                        NoteComponent,
                        NoteContentComponent,
                        NoteTitleComponent,
                        NoteListComponent,
                        NoteListItemComponent
                    ],
                    providers: [],
                }]
        }] });

class PaginationV2Component {
    constructor(cd) {
        this.cd = cd;
        this.hostName = true;
        this.prevPageItem = null;
        this.nextPageItem = null;
        this.initialized = new Subject();
        this.scrollToTop = false;
        this.pageChange = new EventEmitter();
        this.pageSizeChange = new EventEmitter();
        this.pageLabel = 'Page';
        this.ofLabel = 'of';
        this.itemsOfLabel = 'Items of';
        this.pageSizeEntries = [5, 10, 15, 20];
        this.showPaginationOptions = true;
    }
    get config() {
        return this._config;
    }
    set config(config) {
        if (config && config !== this.config) {
            this._config = config;
            this._updatePagination();
            this.cd.detectChanges();
            this.initialized.next('');
            this.initialized.complete();
        }
    }
    /**
     * The main build function used to determine
     * the paging logic.
     */
    _updatePagination() {
        //Reset next and previous page
        this.nextPageItem = null;
        this.prevPageItem = null;
        const length = this.config.length;
        const pageSize = (!this.config.pageSize || this.config.pageSize <= 0) ? 1 : this.config.pageSize; // Block divide by 0 and empty page size
        const pageIndex = this.config.pageIndex || 1;
        this.pageCount = Math.ceil(length / pageSize);
        this.prevPageItem = this.buildPrevPageItem(pageIndex);
        this.nextPageItem = this.buildNextPageItem(pageIndex, this.pageCount);
    }
    /**
     * Create's the previous page item
     *
     * @param pageIndex - the current page
     */
    buildPrevPageItem(pageIndex) {
        const disabled = pageIndex - 1 <= 0;
        const previousPage = pageIndex - 1 <= 0 ? 1 : pageIndex - 1;
        return this.buildPageItem(previousPage, disabled, false);
    }
    /**
     * Create's the next page item
     *
     * @param pageIndex - the current page
     * @param pageCount - the total page count
     */
    buildNextPageItem(pageIndex, pageCount) {
        const disabled = pageIndex + 1 > pageCount;
        const nextPage = pageIndex + 1 >= pageCount ? pageCount : pageIndex + 1;
        return this.buildPageItem(nextPage, disabled, false);
    }
    /**
     * Create's a page item
     *
     * @param disabled - if item is disabled
     * @param page - page number of the item
     * @param displayPage - if the item should display page number default to false
     * @param selected - if the item is the current page default to false
     */
    buildPageItem(page, disabled, selected) {
        return {
            disabled,
            selected,
            text: `${page ? page : ''}`,
            onClick: ($event) => {
                $event.preventDefault();
                if (!disabled && !selected) {
                    this.pageChange.next({ page });
                    if (this.scrollToTop) {
                        window.scrollTo(0, 0);
                    }
                }
            }
        };
    }
    /**
     * Checks if the number added by the user is bigger than the number of pages available
     *
     * @param keyPressedEvent - keyboard triggered event
     */
    validateAddedNumber(keyPressedEvent) {
        const inputNumber = parseInt(keyPressedEvent.target.value);
        if (inputNumber > keyPressedEvent.target.max) {
            keyPressedEvent.target.value = keyPressedEvent.target.max;
        }
    }
    /**
     * Changes the configuration page size
     *
     * @param pageSize - new page size
     */
    changePageSize(pageSize) {
        this.pageSizeChange.next({ pageSize });
        this.pageChange.next({ page: 1 });
    }
    /**
     * Changes the configuration pageIndex
     *
     * @param pageNumber - new page index
     */
    inputChangedPage(pageNumber) {
        if (pageNumber.length > 0 && parseInt(pageNumber) > 0) {
            this.pageChange.next({ page: parseInt(pageNumber) });
        }
    }
    /**
     * Checks if the input is empty on mouse out
     *
     * @param mouseOutEvent - mouse out triggered event
     */
    checkForEmptyInput(mouseOutEvent) {
        if (mouseOutEvent.target.value.length === 0 || mouseOutEvent.target.value <= 0) {
            mouseOutEvent.target.value = this.config.pageIndex;
        }
    }
}
PaginationV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationV2Component, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
PaginationV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: PaginationV2Component, selector: "bis-pagination-v2", inputs: { config: "config", scrollToTop: "scrollToTop", hidePagination: "hidePagination", pageLabel: "pageLabel", ofLabel: "ofLabel", itemsOfLabel: "itemsOfLabel", pageSizeEntries: "pageSizeEntries", showPaginationOptions: "showPaginationOptions" }, outputs: { pageChange: "pageChange", pageSizeChange: "pageSizeChange" }, host: { properties: { "class.bis-host-pagination": "this.hostName", "class.u-display-none": "this.hidePagination" } }, ngImport: i0, template: "<nav class=\"pagination-v2 u-justify-content-end u-display-none u-display-flex\" *ngIf=\"config && config.length > 0\">\n  <div class=\"u-display-flex u-align-items-center\" *ngIf=\"showPaginationOptions\">\n    <select class=\"form-addon__select u-margin-right-small input-number-border-radius page-size-width\" (change)=\"changePageSize($event.target.value)\">\n      <option *ngFor=\"let pageSize of pageSizeEntries\" [value]=\"pageSize\" [selected]=\"config.pageSize === pageSize\"> {{ pageSize }} </option>\n    </select>\n    <p class=\"text-light u-margin-bottom-none u-margin-right-large\">\n      {{ itemsOfLabel }} {{ config.length }}\n    </p>\n  </div>\n  <div class=\"u-margin-bottom-none text-light u-display-flex u-align-items-center u-justify-content-end\">\n    {{ pageLabel }}\n    <input\n      class=\"page-input-width u-margin-x-small u-text-center input-number-border-radius grow-0 page-input\"\n      bis-input\n      type=\"number\"\n      [value]=\"config.pageIndex\"\n      [max]=\"pageCount\"\n      (valueChange)=\"inputChangedPage($event.target.value)\"\n      (keyup)=\"validateAddedNumber($event)\"\n      (mouseout)=\"checkForEmptyInput($event)\"\n      (blur)=\"checkForEmptyInput($event)\"\n    >\n    {{ ofLabel }} {{ pageCount }}\n\n    <div class=\"u-margin-left-large\">\n      <a href=\"#\" class=\"pagination__item pagination__item--previous\" *ngIf=\"prevPageItem\" (click)=\"prevPageItem.onClick($event)\"></a>\n      <a href=\"#\" class=\"pagination__item pagination__item--next\" *ngIf=\"nextPageItem\" (click)=\"nextPageItem.onClick($event)\"></a>\n    </div>\n  </div>\n</nav>\n\n\n", styles: [":host{display:block}.page-input-width{min-width:50px;max-width:60px}.input-number-border-radius{border-radius:8px}.page-size-width{min-width:70px;max-width:95px}select{padding-right:2em}.grow-0{-ms-flex-positive:0;flex-grow:0}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.pagination__item:focus-visible{outline:none}.pagination__item:hover{color:#5ab1ac}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: InputDirective, selector: "input[bis-input]", inputs: ["type", "addon", "state"], outputs: ["valueChange"] }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationV2Component, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'bis-pagination-v2', template: "<nav class=\"pagination-v2 u-justify-content-end u-display-none u-display-flex\" *ngIf=\"config && config.length > 0\">\n  <div class=\"u-display-flex u-align-items-center\" *ngIf=\"showPaginationOptions\">\n    <select class=\"form-addon__select u-margin-right-small input-number-border-radius page-size-width\" (change)=\"changePageSize($event.target.value)\">\n      <option *ngFor=\"let pageSize of pageSizeEntries\" [value]=\"pageSize\" [selected]=\"config.pageSize === pageSize\"> {{ pageSize }} </option>\n    </select>\n    <p class=\"text-light u-margin-bottom-none u-margin-right-large\">\n      {{ itemsOfLabel }} {{ config.length }}\n    </p>\n  </div>\n  <div class=\"u-margin-bottom-none text-light u-display-flex u-align-items-center u-justify-content-end\">\n    {{ pageLabel }}\n    <input\n      class=\"page-input-width u-margin-x-small u-text-center input-number-border-radius grow-0 page-input\"\n      bis-input\n      type=\"number\"\n      [value]=\"config.pageIndex\"\n      [max]=\"pageCount\"\n      (valueChange)=\"inputChangedPage($event.target.value)\"\n      (keyup)=\"validateAddedNumber($event)\"\n      (mouseout)=\"checkForEmptyInput($event)\"\n      (blur)=\"checkForEmptyInput($event)\"\n    >\n    {{ ofLabel }} {{ pageCount }}\n\n    <div class=\"u-margin-left-large\">\n      <a href=\"#\" class=\"pagination__item pagination__item--previous\" *ngIf=\"prevPageItem\" (click)=\"prevPageItem.onClick($event)\"></a>\n      <a href=\"#\" class=\"pagination__item pagination__item--next\" *ngIf=\"nextPageItem\" (click)=\"nextPageItem.onClick($event)\"></a>\n    </div>\n  </div>\n</nav>\n\n\n", styles: [":host{display:block}.page-input-width{min-width:50px;max-width:60px}.input-number-border-radius{border-radius:8px}.page-size-width{min-width:70px;max-width:95px}select{padding-right:2em}.grow-0{-ms-flex-positive:0;flex-grow:0}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.pagination__item:focus-visible{outline:none}.pagination__item:hover{color:#5ab1ac}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { hostName: [{
                type: HostBinding,
                args: ['class.bis-host-pagination']
            }], config: [{
                type: Input
            }], scrollToTop: [{
                type: Input
            }], pageChange: [{
                type: Output
            }], pageSizeChange: [{
                type: Output
            }], hidePagination: [{
                type: HostBinding,
                args: ['class.u-display-none']
            }, {
                type: Input
            }], pageLabel: [{
                type: Input
            }], ofLabel: [{
                type: Input
            }], itemsOfLabel: [{
                type: Input
            }], pageSizeEntries: [{
                type: Input
            }], showPaginationOptions: [{
                type: Input
            }] } });

class PaginationV2Module {
    static forRoot() {
        return {
            ngModule: PaginationV2Module
        };
    }
}
PaginationV2Module.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationV2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PaginationV2Module.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: PaginationV2Module, declarations: [PaginationV2Component], imports: [CommonModule,
        FormModule], exports: [PaginationV2Component] });
PaginationV2Module.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationV2Module, imports: [CommonModule,
        FormModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: PaginationV2Module, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormModule
                    ],
                    declarations: [
                        PaginationV2Component
                    ],
                    exports: [
                        PaginationV2Component
                    ]
                }]
        }] });

class ScaleComponent {
    ngOnInit() {
        this.levels = this.buildScaleLevels();
    }
    ngOnChanges() {
        this.levels = this.buildScaleLevels();
    }
    buildScaleLevels() {
        let className = 'bis-scale-default-highlight';
        return this.scaleValues.map((scaleOption) => {
            const value = scaleOption.value;
            const isSelected = value === this.selected;
            if (isSelected) {
                className = `bis-scale-${value}`;
            }
            return {
                value: value,
                label: scaleOption.label,
                selected: isSelected,
                cssClass: className
            };
        });
    }
}
ScaleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScaleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScaleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ScaleComponent, selector: "bis-scale", inputs: { selected: "selected", scaleValues: "scaleValues" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"bis-scale-container\">\n  <div *ngFor=\"let level of levels; let i = index; let first = first; let last = last\" class=\"bis-scale\" [class.selected]=\"level?.selected === true\">\n    <div class=\"bis-scale-label-wrapper\">\n      <div class=\"bis-scale-label {{ level?.cssClass }}\" [class.first]=\"first === true\" [class.last]=\"last === true\">\n        <span [class.no-selection]=\"level?.selected !== true\">\n          {{ level?.label }}\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".bis-scale-container{display:table;width:100%;height:100%}.bis-scale{display:table-row;height:48px;text-align:right}.bis-scale-label-wrapper{display:table-cell;position:relative}.bis-scale-label{font-weight:700;display:table;float:right;height:100%;width:20px;border-bottom:2px solid white}.bis-scale-default-highlight{color:#d1d3d7;background-color:#d1d3d7}.no-selection{color:#d1d3d7}.bis-scale-label.first{border-radius:10px 10px 0 0}.bis-scale-label.last{border-bottom:none;border-radius:0 0 10px 10px}.bis-scale-label span{position:absolute;right:50px;margin-top:14px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScaleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-scale', encapsulation: ViewEncapsulation.None, template: "<div class=\"bis-scale-container\">\n  <div *ngFor=\"let level of levels; let i = index; let first = first; let last = last\" class=\"bis-scale\" [class.selected]=\"level?.selected === true\">\n    <div class=\"bis-scale-label-wrapper\">\n      <div class=\"bis-scale-label {{ level?.cssClass }}\" [class.first]=\"first === true\" [class.last]=\"last === true\">\n        <span [class.no-selection]=\"level?.selected !== true\">\n          {{ level?.label }}\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".bis-scale-container{display:table;width:100%;height:100%}.bis-scale{display:table-row;height:48px;text-align:right}.bis-scale-label-wrapper{display:table-cell;position:relative}.bis-scale-label{font-weight:700;display:table;float:right;height:100%;width:20px;border-bottom:2px solid white}.bis-scale-default-highlight{color:#d1d3d7;background-color:#d1d3d7}.no-selection{color:#d1d3d7}.bis-scale-label.first{border-radius:10px 10px 0 0}.bis-scale-label.last{border-bottom:none;border-radius:0 0 10px 10px}.bis-scale-label span{position:absolute;right:50px;margin-top:14px}\n"] }]
        }], propDecorators: { selected: [{
                type: Input
            }], scaleValues: [{
                type: Input
            }] } });

class ScaleModule {
}
ScaleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScaleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScaleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ScaleModule, declarations: [ScaleComponent], imports: [CommonModule], exports: [ScaleComponent] });
ScaleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScaleModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScaleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [ScaleComponent],
                    declarations: [ScaleComponent],
                    providers: [],
                }]
        }] });

class ScoreScaleComponent {
    constructor() {
        this.minScore = 0;
        this.maxScore = 0;
    }
    ngOnInit() {
        this.init();
    }
    ngOnChanges() {
        this.init();
    }
    init() {
        this.maxScore = 0;
        this.minScore = 0;
        this.hasScore = typeof this.score === 'number';
        this.sortScaleOptions();
        this.validate();
        if (this.scaleOptions) {
            this.scaleOptions.forEach((scaleOption) => {
                this.minScore = Math.min(this.minScore, scaleOption.lowerLimit);
                this.maxScore = Math.max(this.maxScore, scaleOption.upperLimit);
            });
        }
        this.levels = this.buildScaleLevels();
    }
    validate() {
        if (typeof this.score !== 'number' && this.score !== undefined && this.score !== null) {
            throw new Error(`The score passed '${this.score}' is not of the correct type! Type: ${typeof this.score}`);
        }
        if (!this.scaleOptions) {
            return;
        }
        const intersections = [];
        this.scaleOptions.forEach((scoreScaleOption, index) => this.scaleOptions
            .filter((comparedOption, comparedIndex) => index !== comparedIndex
            && (this.containsScore(scoreScaleOption.upperLimit, comparedOption) || this.containsScore(scoreScaleOption.lowerLimit, comparedOption)))
            .forEach((comparedOption) => intersections.push([scoreScaleOption, comparedOption])));
        if (intersections.length) {
            throw new Error(`The passed 'scaleOptions' are not valid! Please check 'upperLimit's and 'lowerLimit's are not intersecting! Intersections: ${JSON.stringify(intersections)}`);
        }
    }
    containsScore(score, scoreScaleOption) {
        return score >= scoreScaleOption.lowerLimit && score <= scoreScaleOption.upperLimit;
    }
    sortScaleOptions() {
        if (!this.scaleOptions) {
            return;
        }
        this.scaleOptions.sort((first, second) => second.upperLimit - first.upperLimit);
    }
    buildScaleLevels() {
        if (!this.maxScore) {
            return [];
        }
        let overriddenColor = '#d1d3d7';
        return this.scaleOptions.map((scaleOption) => {
            const lowerLimit = scaleOption.lowerLimit;
            const upperLimit = scaleOption.upperLimit;
            const color = scaleOption.color;
            const isSelected = this.hasScore && this.containsScore(this.score, scaleOption);
            if (isSelected) {
                overriddenColor = color;
                this.scoreColor = color;
            }
            let percentage = this.maxScore / 100 * (upperLimit - lowerLimit);
            if (lowerLimit !== this.minScore) {
                percentage++;
            }
            return {
                lowerLimit: lowerLimit,
                upperLimit: upperLimit,
                color: overriddenColor,
                label: scaleOption.label,
                percentage: percentage,
                selected: isSelected,
            };
        });
    }
}
ScoreScaleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScoreScaleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScoreScaleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ScoreScaleComponent, selector: "bis-score-scale", inputs: { score: "score", scaleOptions: "scaleOptions" }, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"scaleOptions\" class=\"u-height-100 u-width-100 u-display-flex u-position-relative\">\n  <div>\n    <div *ngFor=\"let level of levels; let first = first; let last = last;\" class=\"u-display-flex flex-column u-justify-content-between u-text-right no-selection\"\n      [style.height.%]=\"level?.percentage\">\n      <span [class.bis-score-scale--label]=\"!first\"> {{ level?.upperLimit }} </span>\n      <span *ngIf=\"last\"> {{ level?.lowerLimit }} </span>\n    </div>\n  </div>\n  <div class=\"u-display-flex u-flex-column u-align-items-center u-margin-x-default\">\n    <div *ngFor=\"let level of levels; let first = first; let last = last;\" class=\"u-display-flex flex-column bis-score-scale\" [class.first]=\"first\" [class.last]=\"last\"\n      [style.background-color]=\"level?.color\" [style.height.%]=\"level?.percentage\">\n      {{ level?.limit }}\n    </div>\n    <span *ngIf=\"hasScore\" class=\"score-indicator\" [class.score-min]=\"score === minScore\" [class.score-max]=\"score === maxScore\" [style.bottom.%]=\"score\"></span>\n    <span *ngIf=\"hasScore\" class=\"u-display-flex u-justify-content-center u-align-items-center score\" [class.score-min]=\"score === minScore\" [class.score-max]=\"score === maxScore\"\n      [style.bottom.%]=\"score\" [style.background-color]=\"scoreColor\">\n      {{ score }} </span>\n  </div>\n  <div>\n    <div *ngFor=\"let level of levels;\" class=\"u-display-flex flex-column u-justify-content-center\" [class.no-selection]=\"!level?.selected\"\n      [style.color]=\"level?.selected ? level?.color : ''\" [style.height.%]=\"level?.percentage\">\n      {{ level?.label }}\n    </div>\n  </div>\n</div>\n", styles: [".no-selection{color:#d1d3d7}.bis-score-scale{width:20px;border-bottom:2px solid white}.bis-score-scale--label{margin-top:-.75rem}.bis-score-scale.first{border-radius:10px 10px 0 0}.bis-score-scale.last{border-bottom:none;border-radius:0 0 10px 10px}.score{position:absolute;width:2.5rem;height:1.5rem;margin-left:-4.5rem;margin-bottom:-.75rem;border-radius:5px;box-shadow:0 0 5px gray;color:#fff;text-align:center}.score.score-min{margin-bottom:-6px}.score.score-max{margin-bottom:-18px}.score-indicator{position:absolute;background-color:#fff;border:5px solid white;border-radius:1rem;margin-bottom:-4px}.score-indicator.score-min{margin-bottom:0}.score-indicator.score-max{margin-bottom:-10px}.u-position-relative{position:relative!important}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScoreScaleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-score-scale', template: "<div *ngIf=\"scaleOptions\" class=\"u-height-100 u-width-100 u-display-flex u-position-relative\">\n  <div>\n    <div *ngFor=\"let level of levels; let first = first; let last = last;\" class=\"u-display-flex flex-column u-justify-content-between u-text-right no-selection\"\n      [style.height.%]=\"level?.percentage\">\n      <span [class.bis-score-scale--label]=\"!first\"> {{ level?.upperLimit }} </span>\n      <span *ngIf=\"last\"> {{ level?.lowerLimit }} </span>\n    </div>\n  </div>\n  <div class=\"u-display-flex u-flex-column u-align-items-center u-margin-x-default\">\n    <div *ngFor=\"let level of levels; let first = first; let last = last;\" class=\"u-display-flex flex-column bis-score-scale\" [class.first]=\"first\" [class.last]=\"last\"\n      [style.background-color]=\"level?.color\" [style.height.%]=\"level?.percentage\">\n      {{ level?.limit }}\n    </div>\n    <span *ngIf=\"hasScore\" class=\"score-indicator\" [class.score-min]=\"score === minScore\" [class.score-max]=\"score === maxScore\" [style.bottom.%]=\"score\"></span>\n    <span *ngIf=\"hasScore\" class=\"u-display-flex u-justify-content-center u-align-items-center score\" [class.score-min]=\"score === minScore\" [class.score-max]=\"score === maxScore\"\n      [style.bottom.%]=\"score\" [style.background-color]=\"scoreColor\">\n      {{ score }} </span>\n  </div>\n  <div>\n    <div *ngFor=\"let level of levels;\" class=\"u-display-flex flex-column u-justify-content-center\" [class.no-selection]=\"!level?.selected\"\n      [style.color]=\"level?.selected ? level?.color : ''\" [style.height.%]=\"level?.percentage\">\n      {{ level?.label }}\n    </div>\n  </div>\n</div>\n", styles: [".no-selection{color:#d1d3d7}.bis-score-scale{width:20px;border-bottom:2px solid white}.bis-score-scale--label{margin-top:-.75rem}.bis-score-scale.first{border-radius:10px 10px 0 0}.bis-score-scale.last{border-bottom:none;border-radius:0 0 10px 10px}.score{position:absolute;width:2.5rem;height:1.5rem;margin-left:-4.5rem;margin-bottom:-.75rem;border-radius:5px;box-shadow:0 0 5px gray;color:#fff;text-align:center}.score.score-min{margin-bottom:-6px}.score.score-max{margin-bottom:-18px}.score-indicator{position:absolute;background-color:#fff;border:5px solid white;border-radius:1rem;margin-bottom:-4px}.score-indicator.score-min{margin-bottom:0}.score-indicator.score-max{margin-bottom:-10px}.u-position-relative{position:relative!important}\n"] }]
        }], propDecorators: { score: [{
                type: Input
            }], scaleOptions: [{
                type: Input
            }] } });

class ScoreScaleModule {
}
ScoreScaleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScoreScaleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScoreScaleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ScoreScaleModule, declarations: [ScoreScaleComponent], imports: [CommonModule], exports: [ScoreScaleComponent] });
ScoreScaleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScoreScaleModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ScoreScaleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [ScoreScaleComponent],
                    declarations: [ScoreScaleComponent],
                    providers: [],
                }]
        }] });

class SectionComponent {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngOnInit() {
        this.addClasses();
    }
    /**
     * Method used to append classes on the element based on the input provided
     */
    addClasses() {
        this.renderer.addClass(this.el.nativeElement, 'section');
        if (this.spacing) {
            this.renderer.addClass(this.el.nativeElement, `section--${this.spacing}`);
        }
    }
}
SectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SectionComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: SectionComponent, selector: "bis-section", inputs: { spacing: "spacing" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-section',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { spacing: [{
                type: Input
            }] } });

class SectionModule {
}
SectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: SectionModule, declarations: [SectionComponent], exports: [SectionComponent] });
SectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SectionModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SectionModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [
                        SectionComponent
                    ],
                    declarations: [
                        SectionComponent
                    ]
                }]
        }] });

class ShowMoreComponent {
    constructor() {
        this.isExpanded = false;
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
    }
    getExpandedState() {
        return this.isExpanded ? ExpansionState.Expanded : ExpansionState.Collapsed;
    }
}
ShowMoreComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ShowMoreComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShowMoreComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: ShowMoreComponent, selector: "bis-show-more", ngImport: i0, template: "<article>\n  <section [@bodyExpansion]=\"getExpandedState()\">\n    <ng-content></ng-content>\n  </section>\n  <header (click)=\"toggle()\">\n    <button bis-btn btn-type=\"link\">\n      <div class=\"button__inner\">\n        <ng-content *ngIf=\"isExpanded\" select=\"[showLessLabel]\"></ng-content>\n        <ng-content *ngIf=\"!isExpanded\" select=\"[showMoreLabel]\"></ng-content>\n        <bis-icon\n          [@indicatorRotate]=\"getExpandedState()\"\n          icon=\"angle-down\"\n          element-type=\"btn\"\n          position=\"right\"\n        ></bis-icon>\n      </div>\n    </button>\n  </header>\n</article>\n", styles: ["header{cursor:pointer}.button__inner{display:-ms-flexbox;display:flex}bis-icon{margin-left:8px}section{overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ButtonDirective, selector: "button[bis-btn], a[bis-btn], input[bis-btn]", inputs: ["btn-type", "dropdown", "addon", "disabled"] }, { kind: "component", type: IconComponent, selector: "bis-icon", inputs: ["size", "icon", "element-type"] }], animations: [bodyExpansionAnimation, indicatorRotateAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ShowMoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-show-more', changeDetection: ChangeDetectionStrategy.OnPush, animations: [bodyExpansionAnimation, indicatorRotateAnimation], template: "<article>\n  <section [@bodyExpansion]=\"getExpandedState()\">\n    <ng-content></ng-content>\n  </section>\n  <header (click)=\"toggle()\">\n    <button bis-btn btn-type=\"link\">\n      <div class=\"button__inner\">\n        <ng-content *ngIf=\"isExpanded\" select=\"[showLessLabel]\"></ng-content>\n        <ng-content *ngIf=\"!isExpanded\" select=\"[showMoreLabel]\"></ng-content>\n        <bis-icon\n          [@indicatorRotate]=\"getExpandedState()\"\n          icon=\"angle-down\"\n          element-type=\"btn\"\n          position=\"right\"\n        ></bis-icon>\n      </div>\n    </button>\n  </header>\n</article>\n", styles: ["header{cursor:pointer}.button__inner{display:-ms-flexbox;display:flex}bis-icon{margin-left:8px}section{overflow:hidden}\n"] }]
        }] });

class ShowMoreModule {
}
ShowMoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ShowMoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ShowMoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: ShowMoreModule, declarations: [ShowMoreComponent], imports: [CommonModule, ButtonModule, IconFieldModule], exports: [ShowMoreComponent] });
ShowMoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ShowMoreModule, imports: [CommonModule, ButtonModule, IconFieldModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: ShowMoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ShowMoreComponent],
                    exports: [ShowMoreComponent],
                    imports: [CommonModule, ButtonModule, IconFieldModule],
                }]
        }] });

class BisShHeaderCell {
    constructor() {
        this.tCell = true;
        this.tCellHead = true;
        this.scope = 'row';
        this.textRight = true;
        this.textBold = false;
    }
}
BisShHeaderCell.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShHeaderCell, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BisShHeaderCell.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: BisShHeaderCell, selector: "[bisShHeaderCell]", inputs: { textRight: "textRight", textBold: "textBold" }, host: { properties: { "class.tcell": "this.tCell", "class.tcell--head": "this.tCellHead", "attr.scope": "this.scope", "class.u-text-right": "this.textRight", "class.font-weight-500": "this.textBold" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShHeaderCell, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bisShHeaderCell]'
                }]
        }], propDecorators: { tCell: [{
                type: HostBinding,
                args: ['class.tcell']
            }], tCellHead: [{
                type: HostBinding,
                args: ['class.tcell--head']
            }], scope: [{
                type: HostBinding,
                args: ['attr.scope']
            }], textRight: [{
                type: HostBinding,
                args: ['class.u-text-right']
            }, {
                type: Input
            }], textBold: [{
                type: HostBinding,
                args: ['class.font-weight-500']
            }, {
                type: Input
            }] } });
class BisShTableComponent {
    constructor() {
        this.tableContainer = true;
    }
}
BisShTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BisShTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: BisShTableComponent, selector: "bis-sh-table", host: { properties: { "class.table-container": "this.tableContainer" } }, ngImport: i0, template: `
    <table class="table table--sticky bis-sh-table">
      <thead class="thead">
        <ng-content select="bis-sh-header-row"></ng-content>
      </thead>
      <tbody class="tbody">
        <ng-content select="bis-sh-body-row"></ng-content>
      </tbody>
    </table>
  `, isInline: true, styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-sh-table', template: `
    <table class="table table--sticky bis-sh-table">
      <thead class="thead">
        <ng-content select="bis-sh-header-row"></ng-content>
      </thead>
      <tbody class="tbody">
        <ng-content select="bis-sh-body-row"></ng-content>
      </tbody>
    </table>
  `, styles: [":host{display:block}\n"] }]
        }], propDecorators: { tableContainer: [{
                type: HostBinding,
                args: ['class.table-container']
            }] } });
class BisShHeaderRowComponent {
    constructor() {
        this.display = 'table-row';
        this.tHeadRow = true;
    }
    set bisHeaderCells(bisHeaderCells) {
        // Triggers next change detect in cycle as this event happens on AfterContentInit lifecycle hook
        Promise.resolve().then(() => {
            this.setScopeOnChildren(bisHeaderCells, 'col');
        });
    }
    setScopeOnChildren(children, scope) {
        children.forEach((child, index) => {
            if (index === 0) {
                return child.scope = null;
            }
            child.scope = scope;
        });
    }
}
BisShHeaderRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShHeaderRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BisShHeaderRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: BisShHeaderRowComponent, selector: "bis-sh-header-row", host: { properties: { "style.display": "this.display", "class.thead__row": "this.tHeadRow" } }, queries: [{ propertyName: "bisHeaderCells", predicate: BisShHeaderCell }], ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShHeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-sh-header-row',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], propDecorators: { display: [{
                type: HostBinding,
                args: ['style.display']
            }], tHeadRow: [{
                type: HostBinding,
                args: ['class.thead__row']
            }], bisHeaderCells: [{
                type: ContentChildren,
                args: [BisShHeaderCell]
            }] } });
class BisShBodyRowComponent {
    constructor() {
        this.display = 'table-row';
        this.tBodyRow = true;
        this.textRight = true;
        this.textBold = false;
    }
}
BisShBodyRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShBodyRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BisShBodyRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: BisShBodyRowComponent, selector: "bis-sh-body-row", inputs: { textRight: "textRight", textBold: "textBold" }, host: { properties: { "style.display": "this.display", "class.tbody__row": "this.tBodyRow", "class.u-text-right": "this.textRight", "class.font-weight-500": "this.textBold" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShBodyRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-sh-body-row',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }], propDecorators: { display: [{
                type: HostBinding,
                args: ['style.display']
            }], tBodyRow: [{
                type: HostBinding,
                args: ['class.tbody__row']
            }], textRight: [{
                type: HostBinding,
                args: ['class.u-text-right']
            }, {
                type: Input
            }], textBold: [{
                type: HostBinding,
                args: ['class.font-weight-500']
            }, {
                type: Input
            }] } });
class BisShBodyCell {
    constructor() {
        this.tCell = true;
    }
}
BisShBodyCell.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShBodyCell, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BisShBodyCell.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: BisShBodyCell, selector: "[bisShBodyCell]", host: { properties: { "class.tcell": "this.tCell" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShBodyCell, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bisShBodyCell]'
                }]
        }], propDecorators: { tCell: [{
                type: HostBinding,
                args: ['class.tcell']
            }] } });

const exportsAndDeclarations = [
    BisShTableComponent,
    BisShHeaderRowComponent,
    BisShBodyRowComponent,
    BisShBodyCell,
    BisShHeaderCell,
];
class BisShTableModule {
}
BisShTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BisShTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: BisShTableModule, declarations: [BisShTableComponent,
        BisShHeaderRowComponent,
        BisShBodyRowComponent,
        BisShBodyCell,
        BisShHeaderCell], imports: [CommonModule], exports: [BisShTableComponent,
        BisShHeaderRowComponent,
        BisShBodyRowComponent,
        BisShBodyCell,
        BisShHeaderCell] });
BisShTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShTableModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: BisShTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [exportsAndDeclarations],
                    exports: [exportsAndDeclarations]
                }]
        }] });

var NavigationDirection;
(function (NavigationDirection) {
    NavigationDirection["Next"] = "next";
    NavigationDirection["Previous"] = "previous";
    NavigationDirection["Current"] = "current";
})(NavigationDirection || (NavigationDirection = {}));

class StepperService {
    constructor() {
        this._activeStepIndex = new BehaviorSubject(0);
        this.activeStepIndex$ = this._activeStepIndex.asObservable();
        this._steps = new BehaviorSubject([]);
        this.steps$ = this._steps.asObservable();
        this.labels = [];
        this.label$ = new BehaviorSubject([]);
    }
    get steps() {
        return this._steps.getValue();
    }
    setSteps(steps) {
        this._steps.next(steps);
    }
    setLabels(label, step) {
        this.steps$.pipe(filter(steps => !!(steps === null || steps === void 0 ? void 0 : steps.length)), take(1)).subscribe(steps => {
            this.labels[steps.indexOf(step)] = label;
            this.label$.next(this.labels);
        });
    }
    setActiveStepIndex(newStep) {
        const newStepIndex = newStep && this.steps ? this.steps.indexOf(newStep) : -1;
        const activeStep = this.steps[this._activeStepIndex.getValue()];
        const direction = this.getNavigationDirection(newStepIndex);
        let guard$ = of(true);
        if (direction === NavigationDirection.Next) {
            guard$ = activeStep.forwardNavigationGuard;
        }
        if (direction === NavigationDirection.Previous) {
            guard$ = activeStep.backwardNavigationGuard;
        }
        guard$.pipe(take(1)).subscribe((canNavigate) => {
            if (canNavigate) {
                this._activeStepIndex.next(newStepIndex);
            }
        });
    }
    next() {
        const currentActiveStepIndex = Math.min(this._activeStepIndex.getValue(), this.steps.length - 1);
        const activeStep = this.steps[currentActiveStepIndex];
        activeStep.forwardNavigationGuard
            .pipe(take(1))
            .subscribe((canNavigateForward) => {
            if (canNavigateForward) {
                const newActiveStepIndex = Math.min(this._activeStepIndex.getValue() + 1, this.steps.length - 1);
                this._activeStepIndex.next(newActiveStepIndex);
            }
        });
    }
    previous() {
        const currentActiveStepIndex = Math.max(this._activeStepIndex.getValue(), 0);
        const activeStep = this.steps[currentActiveStepIndex];
        activeStep.backwardNavigationGuard
            .pipe(take(1))
            .subscribe((canNavigateBackward) => {
            if (canNavigateBackward) {
                const newActiveStepIndex = Math.max(this._activeStepIndex.getValue() - 1, 0);
                this._activeStepIndex.next(newActiveStepIndex);
            }
        });
    }
    getNavigationDirection(newStepIndex) {
        const position = newStepIndex - this._activeStepIndex.getValue();
        if (position < 0) {
            return NavigationDirection.Previous;
        }
        else if (position > 0) {
            return NavigationDirection.Next;
        }
        return NavigationDirection.Current;
    }
}
StepperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StepperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperService, decorators: [{
            type: Injectable
        }] });

class StepperStepComponent {
    constructor(stepperService) {
        this.stepperService = stepperService;
        /** By default on desktop step content is attache to header. This option does not work on mobile breakpoint. */
        this.isAttachedToHeader = true;
        /** By default any step forward can be triggered but this can be used to prevent navigation */
        this.forwardNavigationGuard = of(true);
        /** By default any step backward can be triggered but this can be used to prevent navigation */
        this.backwardNavigationGuard = of(true);
    }
    /** By default a step number or icon will be shown with additional label if provided. */
    set label(val) {
        this.stepperService.setLabels(val, this);
    }
    select() {
        this.stepperService.setActiveStepIndex(this);
    }
}
StepperStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperStepComponent, deps: [{ token: StepperService }], target: i0.ɵɵFactoryTarget.Component });
StepperStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StepperStepComponent, selector: "bis-stepper-step", inputs: { label: "label", isDisabled: "isDisabled", isCompleted: "isCompleted", isAttachedToHeader: "isAttachedToHeader", forwardNavigationGuard: "forwardNavigationGuard", backwardNavigationGuard: "backwardNavigationGuard" }, viewQueries: [{ propertyName: "content", first: true, predicate: TemplateRef, descendants: true, static: true }], ngImport: i0, template: '<ng-template><ng-content></ng-content></ng-template>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperStepComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-stepper-step',
                    template: '<ng-template><ng-content></ng-content></ng-template>',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: StepperService }]; }, propDecorators: { label: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], isCompleted: [{
                type: Input
            }], isAttachedToHeader: [{
                type: Input
            }], forwardNavigationGuard: [{
                type: Input
            }], backwardNavigationGuard: [{
                type: Input
            }], content: [{
                type: ViewChild,
                args: [TemplateRef, { static: true }]
            }] } });

const horizontalStepTransition = trigger('horizontalStepTransition', [
    state(NavigationDirection.Previous, style({ transform: 'translate3d(-100%, 0, 0)', visibility: 'hidden' })),
    // Transition to `inherit`, rather than `visible`,
    // because visibility on a child element the one from the parent,
    // making this element focusable inside of a `hidden` element.
    state(NavigationDirection.Current, style({ transform: 'none', visibility: 'inherit' })),
    state(NavigationDirection.Next, style({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })),
    transition('* => *', animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
]);

class StepperContentComponent {
    constructor(stepperService) {
        this.stepperService = stepperService;
        this.steps$ = this.stepperService.steps$;
        this.activeStepIndex$ = this.stepperService.activeStepIndex$;
    }
    getAnimationDirection(index) {
        return this.stepperService.getNavigationDirection(index);
    }
}
StepperContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperContentComponent, deps: [{ token: StepperService }], target: i0.ɵɵFactoryTarget.Component });
StepperContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StepperContentComponent, selector: "bis-stepper-content", ngImport: i0, template: "<div\n  class=\"bis-stepper-content-container\"\n  *ngIf=\"{\n    steps: steps$ | async,\n    activeStepIndex: activeStepIndex$ | async\n  } as data\"\n>\n  <div\n    *ngFor=\"let step of data.steps; let i = index\"\n    [@horizontalStepTransition]=\"getAnimationDirection(i)\"\n    [class.u-stepper-step-hidden]=\"data.activeStepIndex !== i\"\n  >\n    <ng-container *ngTemplateOutlet=\"step.content\"></ng-container>\n  </div>\n</div>\n", styles: [".u-stepper-step-hidden{height:0;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], animations: [horizontalStepTransition], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-stepper-content', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [horizontalStepTransition], template: "<div\n  class=\"bis-stepper-content-container\"\n  *ngIf=\"{\n    steps: steps$ | async,\n    activeStepIndex: activeStepIndex$ | async\n  } as data\"\n>\n  <div\n    *ngFor=\"let step of data.steps; let i = index\"\n    [@horizontalStepTransition]=\"getAnimationDirection(i)\"\n    [class.u-stepper-step-hidden]=\"data.activeStepIndex !== i\"\n  >\n    <ng-container *ngTemplateOutlet=\"step.content\"></ng-container>\n  </div>\n</div>\n", styles: [".u-stepper-step-hidden{height:0;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: StepperService }]; } });

class StepperHeaderItemComponent {
    onClick() {
        if (this.isDisabled) {
            return;
        }
        return this.step.select();
    }
}
StepperHeaderItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperHeaderItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StepperHeaderItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StepperHeaderItemComponent, selector: "bis-stepper-header-item", inputs: { step: "step", label: "label", isActive: "isActive", isCompleted: "isCompleted", isDisabled: "isDisabled", stepNumber: "stepNumber" }, ngImport: i0, template: "<div\n  (click)=\"onClick()\"\n  class=\"bis-stepper-header-item\"\n  [class.bis-stepper-header-item--active]=\"isActive\"\n  [class.bis-stepper-header-item--completed]=\"isCompleted\"\n  [class.bis-stepper-header-item--disabled]=\"isDisabled\"\n>\n  <div class=\"bis-stepper-header-prefix\">\n    <span *ngIf=\"!isCompleted\">{{ stepNumber }}</span>\n    <i *ngIf=\"isCompleted\" class=\"icon icon--check\"></i>\n  </div>\n  <span class=\"bis-stepper-header-label\">{{ label }}</span>\n</div>\n", styles: [".bis-stepper-header-item{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.bis-stepper-header-prefix{height:2rem;width:2rem;min-width:2rem;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border-radius:50%;border:1px solid #e4e5ea;margin-right:.5rem;color:#000}.bis-stepper-header-prefix span{font-weight:500}.bis-stepper-header-label{font-size:.88875rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bis-stepper-header-item--active .bis-stepper-header-prefix{border-color:#d53867;color:#fff;background-color:#d53867}.bis-stepper-header-item--disabled .bis-stepper-header-prefix{border-color:#7c808c;color:#7c808c}.bis-stepper-header-item--disabled .bis-stepper-header-label{color:#7c808c}.bis-stepper-header-item--completed{cursor:pointer}.bis-stepper-header-item--completed .bis-stepper-header-prefix{border-color:#319e98;color:#319e98}.bis-stepper-header-item--completed .bis-stepper-header-label{color:#319e98}@media (max-width: 768px){.bis-stepper-header-label{text-align:center;width:76px}.bis-stepper-header-prefix{margin-right:0;margin-bottom:.5rem}.bis-stepper-header-item{-ms-flex-direction:column;flex-direction:column}}@media (max-width: 576px){.bis-stepper-header-label{width:54px}}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperHeaderItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-stepper-header-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  (click)=\"onClick()\"\n  class=\"bis-stepper-header-item\"\n  [class.bis-stepper-header-item--active]=\"isActive\"\n  [class.bis-stepper-header-item--completed]=\"isCompleted\"\n  [class.bis-stepper-header-item--disabled]=\"isDisabled\"\n>\n  <div class=\"bis-stepper-header-prefix\">\n    <span *ngIf=\"!isCompleted\">{{ stepNumber }}</span>\n    <i *ngIf=\"isCompleted\" class=\"icon icon--check\"></i>\n  </div>\n  <span class=\"bis-stepper-header-label\">{{ label }}</span>\n</div>\n", styles: [".bis-stepper-header-item{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.bis-stepper-header-prefix{height:2rem;width:2rem;min-width:2rem;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border-radius:50%;border:1px solid #e4e5ea;margin-right:.5rem;color:#000}.bis-stepper-header-prefix span{font-weight:500}.bis-stepper-header-label{font-size:.88875rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bis-stepper-header-item--active .bis-stepper-header-prefix{border-color:#d53867;color:#fff;background-color:#d53867}.bis-stepper-header-item--disabled .bis-stepper-header-prefix{border-color:#7c808c;color:#7c808c}.bis-stepper-header-item--disabled .bis-stepper-header-label{color:#7c808c}.bis-stepper-header-item--completed{cursor:pointer}.bis-stepper-header-item--completed .bis-stepper-header-prefix{border-color:#319e98;color:#319e98}.bis-stepper-header-item--completed .bis-stepper-header-label{color:#319e98}@media (max-width: 768px){.bis-stepper-header-label{text-align:center;width:76px}.bis-stepper-header-prefix{margin-right:0;margin-bottom:.5rem}.bis-stepper-header-item{-ms-flex-direction:column;flex-direction:column}}@media (max-width: 576px){.bis-stepper-header-label{width:54px}}\n"] }]
        }], propDecorators: { step: [{
                type: Input
            }], label: [{
                type: Input
            }], isActive: [{
                type: Input
            }], isCompleted: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], stepNumber: [{
                type: Input
            }] } });

class StepperHeaderComponent {
    constructor(stepperService) {
        this.stepperService = stepperService;
        this.isLinear = true;
        this.isDisabled = false;
        this.activeStepIndex$ = this.stepperService.activeStepIndex$;
        this.steps$ = this.stepperService.steps$;
        this.label$ = this.stepperService.label$;
    }
    isStepDisabled(activeStepIndex, step, index) {
        return !!(this.isDisabled ||
            step.isDisabled ||
            (this.isLinear && activeStepIndex < index));
    }
    isStepCompleted(activeStepIndex, step, index) {
        return !!(step.isCompleted ||
            (this.isLinear && activeStepIndex > index));
    }
    isHeaderAttached(steps, activeStepIndex) {
        var _a;
        if (!steps) {
            return true;
        }
        return !!((_a = steps[activeStepIndex]) === null || _a === void 0 ? void 0 : _a.isAttachedToHeader);
    }
}
StepperHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperHeaderComponent, deps: [{ token: StepperService }], target: i0.ɵɵFactoryTarget.Component });
StepperHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StepperHeaderComponent, selector: "bis-stepper-header", inputs: { isLinear: "isLinear", isDisabled: "isDisabled" }, ngImport: i0, template: "<ng-container\n  *ngIf=\"{\n    steps: steps$ | async,\n    activeStepIndex: activeStepIndex$ | async,\n    labels: label$ | async\n  } as data\"\n>\n  <div\n    class=\"bis-stepper-header-container u-padding-default u-shadow-resting\"\n    [class.bis-stepper-header-container-attached]=\"\n      isHeaderAttached(data.steps, data.activeStepIndex)\n    \"\n  >\n    <div\n      class=\"bis-stepper-header-list\"\n      *ngFor=\"let step of data.steps; let i = index; let last = last\"\n    >\n      <bis-stepper-header-item\n        [step]=\"step\"\n        [label]=\"data.labels[i]\"\n        [isActive]=\"data.activeStepIndex === i\"\n        [stepNumber]=\"i + 1\"\n        [isDisabled]=\"isStepDisabled(data.activeStepIndex, step, i)\"\n        [isCompleted]=\"isStepCompleted(data.activeStepIndex, step, i)\"\n      >\n      </bis-stepper-header-item>\n      <div *ngIf=\"!last\" class=\"bis-stepper-header-divider\"></div>\n    </div>\n  </div>\n</ng-container>\n", styles: [".bis-stepper-header-container{background-color:#fff;margin-bottom:1rem;border-radius:19px;display:-ms-flexbox;display:flex}.bis-stepper-header-list{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.bis-stepper-header-divider{width:48px;height:1px;background-color:#a5a8b2;margin:0 1rem}@media (min-width: 769px){.bis-stepper-header-container-attached{margin-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}}@media (max-width: 768px){.bis-stepper-header-list{-ms-flex-align:start;align-items:flex-start}.bis-stepper-header-divider{margin:12px 0 0}.bis-stepper-header-container{-ms-flex-pack:center;justify-content:center}}@media (max-width: 576px){.bis-stepper-header-divider{width:1.5rem}}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: StepperHeaderItemComponent, selector: "bis-stepper-header-item", inputs: ["step", "label", "isActive", "isCompleted", "isDisabled", "stepNumber"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-stepper-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container\n  *ngIf=\"{\n    steps: steps$ | async,\n    activeStepIndex: activeStepIndex$ | async,\n    labels: label$ | async\n  } as data\"\n>\n  <div\n    class=\"bis-stepper-header-container u-padding-default u-shadow-resting\"\n    [class.bis-stepper-header-container-attached]=\"\n      isHeaderAttached(data.steps, data.activeStepIndex)\n    \"\n  >\n    <div\n      class=\"bis-stepper-header-list\"\n      *ngFor=\"let step of data.steps; let i = index; let last = last\"\n    >\n      <bis-stepper-header-item\n        [step]=\"step\"\n        [label]=\"data.labels[i]\"\n        [isActive]=\"data.activeStepIndex === i\"\n        [stepNumber]=\"i + 1\"\n        [isDisabled]=\"isStepDisabled(data.activeStepIndex, step, i)\"\n        [isCompleted]=\"isStepCompleted(data.activeStepIndex, step, i)\"\n      >\n      </bis-stepper-header-item>\n      <div *ngIf=\"!last\" class=\"bis-stepper-header-divider\"></div>\n    </div>\n  </div>\n</ng-container>\n", styles: [".bis-stepper-header-container{background-color:#fff;margin-bottom:1rem;border-radius:19px;display:-ms-flexbox;display:flex}.bis-stepper-header-list{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.bis-stepper-header-divider{width:48px;height:1px;background-color:#a5a8b2;margin:0 1rem}@media (min-width: 769px){.bis-stepper-header-container-attached{margin-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0}}@media (max-width: 768px){.bis-stepper-header-list{-ms-flex-align:start;align-items:flex-start}.bis-stepper-header-divider{margin:12px 0 0}.bis-stepper-header-container{-ms-flex-pack:center;justify-content:center}}@media (max-width: 576px){.bis-stepper-header-divider{width:1.5rem}}\n"] }]
        }], ctorParameters: function () { return [{ type: StepperService }]; }, propDecorators: { isLinear: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }] } });

class StepperComponent {
    constructor(stepperService, changeDetectorRef) {
        this.stepperService = stepperService;
        this.changeDetectorRef = changeDetectorRef;
        /** isLinear = true means that user cannot navigate forward using header and needs to complete steps one by one. */
        this._isLinear = true;
        /** When isDisabled is set to true then stepper header cannot be used for navigation. */
        this._isDisabled = false;
    }
    get isLinear() {
        return this._isLinear;
    }
    set isLinear(value) {
        this._isLinear = value;
        this.changeDetectorRef.detectChanges();
    }
    get isDisabled() {
        return this._isDisabled;
    }
    set isDisabled(value) {
        this._isDisabled = value;
        this.changeDetectorRef.detectChanges();
    }
    ngAfterViewInit() {
        this.stepperService.setSteps(this.steps.toArray());
        this.changeDetectorRef.detectChanges();
    }
    next() {
        this.stepperService.next();
    }
    previous() {
        this.stepperService.previous();
    }
}
StepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperComponent, deps: [{ token: StepperService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
StepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StepperComponent, selector: "bis-stepper", inputs: { isLinear: "isLinear", isDisabled: "isDisabled" }, providers: [StepperService], queries: [{ propertyName: "steps", predicate: StepperStepComponent }], ngImport: i0, template: "<bis-stepper-header [isLinear]=\"isLinear\" [isDisabled]=\"isDisabled\"></bis-stepper-header>\n<bis-stepper-content></bis-stepper-content>\n", dependencies: [{ kind: "component", type: StepperContentComponent, selector: "bis-stepper-content" }, { kind: "component", type: StepperHeaderComponent, selector: "bis-stepper-header", inputs: ["isLinear", "isDisabled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-stepper', changeDetection: ChangeDetectionStrategy.OnPush, providers: [StepperService], template: "<bis-stepper-header [isLinear]=\"isLinear\" [isDisabled]=\"isDisabled\"></bis-stepper-header>\n<bis-stepper-content></bis-stepper-content>\n" }]
        }], ctorParameters: function () { return [{ type: StepperService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { steps: [{
                type: ContentChildren,
                args: [StepperStepComponent]
            }], isLinear: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }] } });

class StepperNextDirective {
    constructor(stepperService) {
        this.stepperService = stepperService;
    }
    onClick() {
        this.stepperService.next();
    }
}
StepperNextDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperNextDirective, deps: [{ token: StepperService }], target: i0.ɵɵFactoryTarget.Directive });
StepperNextDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: StepperNextDirective, selector: "button[bisStepperNext]", host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperNextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[bisStepperNext]',
                }]
        }], ctorParameters: function () { return [{ type: StepperService }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class StepperPreviousDirective {
    constructor(stepperService) {
        this.stepperService = stepperService;
    }
    onClick() {
        this.stepperService.previous();
    }
}
StepperPreviousDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperPreviousDirective, deps: [{ token: StepperService }], target: i0.ɵɵFactoryTarget.Directive });
StepperPreviousDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: StepperPreviousDirective, selector: "button[bisStepperPrevious]", host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperPreviousDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[bisStepperPrevious]',
                }]
        }], ctorParameters: function () { return [{ type: StepperService }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class StepperModule {
}
StepperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StepperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: StepperModule, declarations: [StepperComponent,
        StepperStepComponent,
        StepperNextDirective,
        StepperPreviousDirective,
        StepperHeaderItemComponent,
        StepperContentComponent,
        StepperHeaderComponent], imports: [CommonModule], exports: [StepperComponent,
        StepperStepComponent,
        StepperNextDirective,
        StepperPreviousDirective] });
StepperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StepperModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [
                        StepperComponent,
                        StepperStepComponent,
                        StepperNextDirective,
                        StepperPreviousDirective,
                    ],
                    declarations: [
                        StepperComponent,
                        StepperStepComponent,
                        StepperNextDirective,
                        StepperPreviousDirective,
                        StepperHeaderItemComponent,
                        StepperContentComponent,
                        StepperHeaderComponent,
                    ],
                }]
        }] });

class TabTitleComponent {
    constructor() {
        this.active = false;
        this.disable = false;
        this.tabClick = new EventEmitter();
        this.tabindex = -1;
    }
    setActive($event) {
        $event.preventDefault();
        if (!this.disable) {
            this.tabClick.emit();
        }
    }
}
TabTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabTitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TabTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabTitleComponent, selector: "bis-tab-title", inputs: { class: "class" }, outputs: { tabClick: "tabClick" }, viewQueries: [{ propertyName: "li", first: true, predicate: ["li"], descendants: true }], ngImport: i0, template: `
    <li #li class="tab {{class ? class : ''}}"
        [class.tab--active]="active && !disable"
        [class.tab--disabled]="disable"
        (click)="setActive($event)"
        [tabindex]="tabindex">
        <a class="tab__link" [attr.disabled]="disable" tabindex="-1">
          <ng-content></ng-content>
        </a>
    </li>
  `, isInline: true, styles: [".tab__link{cursor:pointer}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-tab-title', template: `
    <li #li class="tab {{class ? class : ''}}"
        [class.tab--active]="active && !disable"
        [class.tab--disabled]="disable"
        (click)="setActive($event)"
        [tabindex]="tabindex">
        <a class="tab__link" [attr.disabled]="disable" tabindex="-1">
          <ng-content></ng-content>
        </a>
    </li>
  `, preserveWhitespaces: false, styles: [".tab__link{cursor:pointer}\n"] }]
        }], propDecorators: { class: [{
                type: Input
            }], li: [{
                type: ViewChild,
                args: ['li', { static: false }]
            }], tabClick: [{
                type: Output
            }] } });
class TabContentComponent {
    constructor(element) {
        this.element = element;
    }
}
TabContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabContentComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
TabContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabContentComponent, selector: "bis-tab-content", ngImport: i0, template: `
    <ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-tab-content',
                    template: `
    <ng-content></ng-content>`
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });
class TabComponent {
    constructor() {
        this._active = false;
        this._disable = false;
        this.click = new EventEmitter();
    }
    get tabindex() {
        return this._tabindex;
    }
    set tabindex(value) {
        if (!value && value !== 0) {
            this.setTabTitleIndex(-1);
            return;
        }
        this._tabindex = value;
        this.setTabTitleIndex(value);
    }
    get active() {
        return this._active;
    }
    set active(value) {
        this._active = value;
        if (!this._active) {
            this.setTabTitleIndex(-1);
        }
    }
    get disable() {
        return this._disable;
    }
    set disable(value) {
        this._disable = value;
        if (this._disable) {
            this.setTabTitleIndex(-1);
        }
    }
    ngAfterContentInit() {
        this.setTabTitleIndex(this.tabindex);
    }
    ngOnChanges() {
        if (this.tabTitle) {
            this.tabTitle.active = this.active;
            this.tabTitle.disable = this.disable;
        }
    }
    setTabTitleIndex(value) {
        if (this.tabTitle) {
            this.tabTitle.tabindex = value;
        }
    }
}
TabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabComponent, selector: "bis-tab", inputs: { tabindex: "tabindex", active: "active", disable: "disable" }, outputs: { click: "click" }, queries: [{ propertyName: "tabTitle", first: true, predicate: TabTitleComponent, descendants: true, static: true }, { propertyName: "tabContent", first: true, predicate: TabContentComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <ng-content></ng-content>`, isInline: true, styles: [":host{display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end}.nav-tabs--justify>:host{-ms-flex:1;flex:1}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-tab', template: `
    <ng-content></ng-content>`, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: [":host{display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end}.nav-tabs--justify>:host{-ms-flex:1;flex:1}\n"] }]
        }], propDecorators: { click: [{
                type: Output
            }], tabTitle: [{
                type: ContentChild,
                args: [TabTitleComponent, { static: true }]
            }], tabContent: [{
                type: ContentChild,
                args: [TabContentComponent, { static: false }]
            }], tabindex: [{
                type: Input
            }], active: [{
                type: Input
            }], disable: [{
                type: Input
            }] } });
class TabsComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.expanded = true;
        this.classes = {};
        this.tabClickSubscriptions = [];
    }
    ngOnInit() {
        this.setClasses(this.direction);
    }
    ngOnChanges() {
        this.setClasses(this.direction);
    }
    ngAfterViewInit() {
        this.render();
    }
    render() {
        this.tabs.forEach((tab, index) => {
            this.tabClickSubscriptions[index] = tab.tabTitle.tabClick.subscribe(this.onTabClick.bind(this, index));
            this.renderer.appendChild(this.list.nativeElement, tab.tabTitle.li.nativeElement);
            if (tab.active && !tab.disable) {
                this.setContent(tab.tabContent);
            }
        });
    }
    reRender() {
        this.list.nativeElement.innerHTML = '';
        if (this.tabClickSubscriptions && this.tabClickSubscriptions.length) {
            this.tabClickSubscriptions.forEach(subscription => subscription.unsubscribe());
        }
        this.render();
    }
    onTabClick(id, $event) {
        this.tabs.forEach((tabComponentRef) => {
            tabComponentRef.tabTitle.active = false;
            tabComponentRef.active = false;
        });
        const tab = this.tabs.toArray()[id];
        tab.tabTitle.active = true;
        tab.active = true;
        tab.click.emit(tab.active);
        this.setContent(tab.tabContent);
    }
    setContent(tabContent) {
        if (tabContent) {
            if (this.externalContent) {
                this.clearContentAndAppendChild(this.externalContent.element.nativeElement, tabContent);
            }
            else {
                this.clearContentAndAppendChild(this.content.nativeElement, tabContent);
            }
        }
    }
    clearContentAndAppendChild(element, tabContent) {
        element.textContent = '';
        this.renderer.appendChild(element, tabContent.element.nativeElement);
    }
    setClasses(direction) {
        this.classes = {};
        this.classes['tabs'] = true;
        this.classes[`tabs--${direction}`] = true;
    }
    ngOnDestroy() {
        if (this.tabClickSubscriptions && this.tabClickSubscriptions.length) {
            this.tabClickSubscriptions.forEach(subscription => subscription.unsubscribe());
        }
    }
}
TabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
TabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabsComponent, selector: "bis-tabs", inputs: { direction: "direction", externalContent: "externalContent", expanded: "expanded" }, queries: [{ propertyName: "tabs", predicate: TabComponent }], viewQueries: [{ propertyName: "list", first: true, predicate: ["list"], descendants: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div [ngClass]="{ 'row u-padding-left-small': !expanded }">
      <div [ngClass]="{ 'card u-border-radius-bottom-none u-margin-bottom-none': !expanded }">
        <ul #list [ngClass]="classes"></ul>
      </div>
    </div>
    <div #content></div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-tabs',
                    template: `
    <div [ngClass]="{ 'row u-padding-left-small': !expanded }">
      <div [ngClass]="{ 'card u-border-radius-bottom-none u-margin-bottom-none': !expanded }">
        <ul #list [ngClass]="classes"></ul>
      </div>
    </div>
    <div #content></div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { direction: [{
                type: Input
            }], externalContent: [{
                type: Input
            }], expanded: [{
                type: Input
            }], list: [{
                type: ViewChild,
                args: ['list', { static: false }]
            }], content: [{
                type: ViewChild,
                args: ['content', { static: false }]
            }], tabs: [{
                type: ContentChildren,
                args: [TabComponent]
            }] } });

class TabsModule {
    static forRoot() {
        return {
            ngModule: TabsModule,
            providers: []
        };
    }
}
TabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: TabsModule, declarations: [TabsComponent,
        TabComponent,
        TabTitleComponent,
        TabContentComponent], imports: [CommonModule], exports: [TabsComponent,
        TabComponent,
        TabTitleComponent,
        TabContentComponent] });
TabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        TabsComponent,
                        TabComponent,
                        TabTitleComponent,
                        TabContentComponent,
                    ],
                    providers: [],
                    exports: [
                        TabsComponent,
                        TabComponent,
                        TabTitleComponent,
                        TabContentComponent,
                    ]
                }]
        }] });

class TabLinkV2Directive {
    constructor() {
        this.tabLinkClass = true;
        this.tabindex = -1;
        this.pointerClass = true;
    }
}
TabLinkV2Directive.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabLinkV2Directive, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TabLinkV2Directive.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: TabLinkV2Directive, selector: "[bis-tab-link-v2]", inputs: { pointerClass: "pointerClass" }, host: { properties: { "class.tab__link": "this.tabLinkClass", "attr.tabindex": "this.tabindex", "class.u-cursor-pointer": "this.pointerClass" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabLinkV2Directive, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bis-tab-link-v2]'
                }]
        }], propDecorators: { tabLinkClass: [{
                type: HostBinding,
                args: ['class.tab__link']
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], pointerClass: [{
                type: HostBinding,
                args: ['class.u-cursor-pointer']
            }, {
                type: Input
            }] } });
class TabHeaderV2Component {
    constructor() {
        this.tabClass = true;
        this.tabHeaderClass = true;
    }
}
TabHeaderV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabHeaderV2Component, deps: [], target: i0.ɵɵFactoryTarget.Component });
TabHeaderV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabHeaderV2Component, selector: "bis-tab-header-v2", host: { properties: { "class.tab": "this.tabClass", "class.tab--header": "this.tabHeaderClass" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{display:list-item}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabHeaderV2Component, decorators: [{
            type: Component,
            args: [{ selector: 'bis-tab-header-v2', template: `
    <ng-content></ng-content>
  `, styles: [":host{display:list-item}\n"] }]
        }], propDecorators: { tabClass: [{
                type: HostBinding,
                args: ['class.tab']
            }], tabHeaderClass: [{
                type: HostBinding,
                args: ['class.tab--header']
            }] } });
class TabContentV2Directive {
    constructor(template) {
        this.template = template;
    }
}
TabContentV2Directive.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabContentV2Directive, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
TabContentV2Directive.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: TabContentV2Directive, selector: "[bis-tab-content-v2]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabContentV2Directive, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bis-tab-content-v2]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class TabV2Component {
    constructor() {
        this._disabled = false;
        this._active = false;
        this.tabClick = new EventEmitter();
        this.internalActivation = new EventEmitter();
        this.role = 'listitem';
        this.tabindex = -1;
        this.tabClass = true;
    }
    set active(active) {
        if (active) {
            this.internalActivation.emit();
        }
        this._active = active;
    }
    get active() {
        return this._active;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        const disabled = value ? true : null;
        this._disabled = disabled;
        if (disabled) {
            this.tabindex = -1;
        }
    }
    get isTabActive() {
        return this.active && !this.disabled;
    }
    setActive(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.disabled) {
            this.tabClick.emit({ name });
        }
    }
    setInternalActive(active) {
        this._active = active;
    }
}
TabV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabV2Component, deps: [], target: i0.ɵɵFactoryTarget.Component });
TabV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabV2Component, selector: "bis-tab-v2", inputs: { active: "active", name: "name", tabindex: "tabindex", disabled: "disabled" }, outputs: { tabClick: "tabClick", internalActivation: "internalActivation" }, host: { listeners: { "keydown.space": "setActive($event)", "click": "setActive($event)" }, properties: { "attr.role": "this.role", "attr.tabindex": "this.tabindex", "class.tab": "this.tabClass", "class.tab--disabled": "this.disabled", "class.tab--active": "this.isTabActive" } }, queries: [{ propertyName: "tabContent", first: true, predicate: TabContentV2Directive, descendants: true }], ngImport: i0, template: `
    <ng-content select="[bis-tab-link-v2]"></ng-content>
  `, isInline: true, styles: [":host{display:list-item}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabV2Component, decorators: [{
            type: Component,
            args: [{ selector: 'bis-tab-v2', template: `
    <ng-content select="[bis-tab-link-v2]"></ng-content>
  `, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: [":host{display:list-item}\n"] }]
        }], propDecorators: { tabContent: [{
                type: ContentChild,
                args: [TabContentV2Directive]
            }], active: [{
                type: Input
            }], name: [{
                type: Input
            }], tabClick: [{
                type: Output
            }], internalActivation: [{
                type: Output
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], tabindex: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.tabindex']
            }], tabClass: [{
                type: HostBinding,
                args: ['class.tab']
            }], disabled: [{
                type: HostBinding,
                args: ['class.tab--disabled']
            }, {
                type: Input
            }], isTabActive: [{
                type: HostBinding,
                args: ['class.tab--active']
            }], setActive: [{
                type: HostListener,
                args: ['keydown.space', ['$event']]
            }, {
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class TabsContentDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
TabsContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsContentDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
TabsContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: TabsContentDirective, selector: "[tabsContent]", exportAs: ["tabsContent"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tabsContent]',
                    exportAs: 'tabsContent'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });
class TabsV2Component {
    constructor(dif) {
        this.dif = dif;
        this.role = 'list';
        this.tabsClass = true;
        this.direction = 'justify';
        this.tabChange = new EventEmitter();
        this.classes = {};
        this.unsubscribe$ = new Subject();
        this.differ = this.dif.find([]).create();
    }
    set tabs(value) {
        this._tabs = value;
        const changes = this.differ.diff(value);
        if (changes) {
            this.render();
        }
    }
    get tabs() {
        return this._tabs;
    }
    get shouldSetVerticalTabs() {
        return this.direction === 'vertical';
    }
    get shouldSetJustifyTabs() {
        return this.direction === 'justify';
    }
    ngAfterViewInit() {
        this.render();
    }
    render() {
        this.unsubscribe$.next(undefined);
        this.tabs.forEach((tab, index) => {
            tab.tabClick
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(this.onTabClick.bind(this, index));
            tab.internalActivation
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(() => this.onInternalTabActivate(index));
            if (tab.active && !tab.disabled) {
                this.setContent(tab.tabContent);
            }
        });
    }
    onTabClick(index, { name }) {
        const tab = this.getSelectedTab(index);
        const tabAlreadyActive = tab.active;
        if (tabAlreadyActive) {
            return;
        }
        this.handleTabActivation(tab);
        this.tabChange.next({ index, name });
    }
    onInternalTabActivate(index) {
        const tab = this.getSelectedTab(index);
        this.handleTabActivation(tab);
    }
    handleTabActivation(activeTab) {
        this.tabs.forEach((tabComponentRef) => {
            tabComponentRef.setInternalActive(false);
        });
        activeTab.setInternalActive(true);
        this.setContent(activeTab.tabContent);
    }
    getSelectedTab(index) {
        return this.tabs.toArray()[index];
    }
    setContent(tabContent) {
        const canRenderContent = tabContent && this.tabsContent && this.tabsContent.viewContainerRef;
        if (canRenderContent) {
            setTimeout(() => {
                this.tabsContent.viewContainerRef.clear();
                this.tabsContent.viewContainerRef.createEmbeddedView(tabContent.template);
            }, 0);
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next(undefined);
        this.unsubscribe$.complete();
    }
}
TabsV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsV2Component, deps: [{ token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Component });
TabsV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TabsV2Component, selector: "bis-tabs-v2", inputs: { direction: "direction", tabsContent: "tabsContent" }, outputs: { tabChange: "tabChange" }, host: { properties: { "attr.role": "this.role", "class.tabs": "this.tabsClass", "class.tabs--vertical": "this.shouldSetVerticalTabs", "class.tabs--justify": "this.shouldSetJustifyTabs" } }, queries: [{ propertyName: "tabs", predicate: TabV2Component, descendants: true }], ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsV2Component, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-tabs-v2',
                    template: `
    <ng-content></ng-content>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], ctorParameters: function () { return [{ type: i0.IterableDiffers }]; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], tabsClass: [{
                type: HostBinding,
                args: ['class.tabs']
            }], tabs: [{
                type: ContentChildren,
                args: [TabV2Component, { descendants: true }]
            }], direction: [{
                type: Input
            }], tabsContent: [{
                type: Input
            }], shouldSetVerticalTabs: [{
                type: HostBinding,
                args: [`class.tabs--vertical`]
            }], shouldSetJustifyTabs: [{
                type: HostBinding,
                args: [`class.tabs--justify`]
            }], tabChange: [{
                type: Output
            }] } });
class SubTabsV2Component {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.role = 'list';
        this.tabs = true;
        this.tabsVertical = true;
        this.tabsSub = true;
    }
}
SubTabsV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SubTabsV2Component, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SubTabsV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: SubTabsV2Component, selector: "bis-sub-tabs-v2", host: { properties: { "attr.role": "this.role", "class.tabs": "this.tabs", "class.tabs--vertical": "this.tabsVertical", "class.tabs--sub": "this.tabsSub" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: SubTabsV2Component, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-sub-tabs-v2',
                    template: `
    <ng-content></ng-content>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], tabs: [{
                type: HostBinding,
                args: ['class.tabs']
            }], tabsVertical: [{
                type: HostBinding,
                args: ['class.tabs--vertical']
            }], tabsSub: [{
                type: HostBinding,
                args: ['class.tabs--sub']
            }] } });

const declarationsExports = [
    TabsV2Component,
    TabV2Component,
    TabLinkV2Directive,
    TabContentV2Directive,
    SubTabsV2Component,
    TabHeaderV2Component,
    TabsContentDirective
];
class TabsV2Module {
}
TabsV2Module.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsV2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TabsV2Module.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: TabsV2Module, declarations: [TabsV2Component,
        TabV2Component,
        TabLinkV2Directive,
        TabContentV2Directive,
        SubTabsV2Component,
        TabHeaderV2Component,
        TabsContentDirective], imports: [CommonModule], exports: [TabsV2Component,
        TabV2Component,
        TabLinkV2Directive,
        TabContentV2Directive,
        SubTabsV2Component,
        TabHeaderV2Component,
        TabsContentDirective] });
TabsV2Module.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsV2Module, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TabsV2Module, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        declarationsExports
                    ],
                    providers: [],
                    exports: [
                        declarationsExports
                    ]
                }]
        }] });

class TagComponent {
    constructor() {
        this.tag = true;
        this.disabled = false;
    }
}
TagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TagComponent, selector: "bis-tag", inputs: { disabled: "disabled" }, host: { properties: { "class.tag": "this.tag", "class.tag--disabled": "this.disabled" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TagComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-tag',
                    template: `
    <ng-content></ng-content>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                }]
        }], propDecorators: { tag: [{
                type: HostBinding,
                args: ['class.tag']
            }], disabled: [{
                type: HostBinding,
                args: ['class.tag--disabled']
            }, {
                type: Input
            }] } });

class TagModule {
}
TagModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TagModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: TagModule, declarations: [TagComponent], exports: [TagComponent] });
TagModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TagModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TagModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [TagComponent],
                    declarations: [TagComponent],
                    providers: [],
                }]
        }] });

class TooltipTextComponent {
}
TooltipTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipTextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TooltipTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TooltipTextComponent, selector: "bis-tooltip-text", ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-tooltip-text',
                    template: `
    <ng-content></ng-content>
  `,
                }]
        }] });
class TooltipComponent {
    constructor() {
        this.classes = {};
        this.tabindex = -1;
    }
    ngOnInit() {
        this.setClasses(this.type, this.direction);
    }
    /**
     * Method used to set classes on the span element depending on the tooltip type provided
     * @param type tooltip type provided through attribute binding on the selector
     */
    setClasses(type, direction) {
        let className;
        // tooltip class should be present on all types of tooltip
        this.classes['tooltip'] = true;
        if (type !== 'line-break') {
            className = 'tooltip--' + direction;
            this.classes[className] = true;
        }
        else {
            className = 'tooltip--' + direction;
            this.classes['tooltip--line-break'] = true;
            this.classes[className] = true;
        }
    }
}
TooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TooltipComponent, selector: "bis-tooltip", inputs: { type: "type", direction: "direction", tooltipData: ["tooltip-data", "tooltipData"], tabindex: "tabindex" }, ngImport: i0, template: `
    <span [ngClass]="classes" [attr.data-tooltip]="tooltipData" [tabindex]="tabindex">
      <ng-content></ng-content>
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-tooltip',
                    template: `
    <span [ngClass]="classes" [attr.data-tooltip]="tooltipData" [tabindex]="tabindex">
      <ng-content></ng-content>
    </span>
  `
                }]
        }], propDecorators: { type: [{
                type: Input
            }], direction: [{
                type: Input
            }], tooltipData: [{
                type: Input,
                args: ['tooltip-data']
            }], tabindex: [{
                type: Input
            }] } });

class TooltipModule {
}
TooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: TooltipModule, declarations: [TooltipComponent,
        TooltipTextComponent], imports: [CommonModule], exports: [TooltipComponent,
        TooltipTextComponent] });
TooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TooltipComponent,
                        TooltipTextComponent
                    ],
                    declarations: [
                        TooltipComponent,
                        TooltipTextComponent
                    ],
                    providers: [],
                }]
        }] });

class TypeaheadComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.debounce = 300; // ms
        this.minLength = 2; // min text length
        this.valueChange = new EventEmitter();
        this.keyup$ = new Subject();
    }
    ngOnInit() {
        // assign host class names to inner input and remove the classes from host
        this.input.nativeElement.className = this.elementRef.nativeElement.className;
        this.elementRef.nativeElement.className = '';
        this.keyup$
            .pipe(map((e) => {
            return e.target.value; // Project the text from the input
        }), filter((text) => {
            return (text !== undefined) && (text.length > this.minLength); // Only if the text is longer than 2 characters
        }), filter((text) => {
            return (this.minLength < 0) ? true : !!text.trim(); // if minlength -1 allow empty text
        }), debounceTime(this.debounce), /* Pause for 300ms */ distinctUntilChanged()) // Only if the value has changed)
            .subscribe((next) => this.valueChange.emit(next));
    }
    onKeyPress($event) {
        this.keyup$.next($event);
    }
}
TypeaheadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
TypeaheadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: TypeaheadComponent, selector: "bis-typeahead", inputs: { placeholder: "placeholder", debounce: "debounce", minLength: "minLength" }, outputs: { valueChange: "valueChange" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0, template: "<input #input (keyup)=\"onKeyPress($event)\" type=\"text\" [placeholder]=\"placeholder || ''\" class=\"form-control\">\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bis-typeahead', template: "<input #input (keyup)=\"onKeyPress($event)\" type=\"text\" [placeholder]=\"placeholder || ''\" class=\"form-control\">\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { placeholder: [{
                type: Input
            }], debounce: [{
                type: Input
            }], minLength: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }] } });
class TypeaheadDirective {
    constructor(elementRef, render) {
        this.elementRef = elementRef;
        this.render = render;
        this.debounce = 300; // ms
        this.minLength = 2; // min text length
        this.valueChange = new EventEmitter();
        this.keyup$ = new Subject();
    }
    ngOnInit() {
        this.keyup$
            .pipe(map((e) => {
            return e.target.value; // Project the text from the input
        }), filter((text) => {
            return (text !== undefined) && (text.length > this.minLength); // Only if the text is longer than 2 characters
        }), filter((text) => {
            return (this.minLength < 0) ? true : !!text.trim(); // if minlength -1 allow empty text
        }), debounceTime(this.debounce), /* Pause for 300ms */ distinctUntilChanged() // Only if the value has changed
        )
            .subscribe((next) => this.valueChange.emit(next));
        this.render.listen(this.elementRef.nativeElement, 'keyup', this.onKeyPress.bind(this));
    }
    onKeyPress($event) {
        this.keyup$.next($event);
    }
}
TypeaheadDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
TypeaheadDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.3", type: TypeaheadDirective, selector: "input[bis-typeahead]", inputs: { debounce: "debounce", minLength: "minLength" }, outputs: { valueChange: "valueChange" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[bis-typeahead]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { debounce: [{
                type: Input,
                args: ['debounce']
            }], minLength: [{
                type: Input,
                args: ['minLength']
            }], valueChange: [{
                type: Output,
                args: ['valueChange']
            }] } });

class TypeaheadModule {
}
TypeaheadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TypeaheadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadModule, declarations: [TypeaheadComponent, TypeaheadDirective], imports: [CommonModule], exports: [TypeaheadComponent, TypeaheadDirective] });
TypeaheadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypeaheadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [TypeaheadComponent, TypeaheadDirective],
                    exports: [TypeaheadComponent, TypeaheadDirective]
                }]
        }] });

class StatisticsComponent {
    constructor() {
        this.stats = 'stats';
    }
}
StatisticsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StatisticsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StatisticsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StatisticsComponent, selector: "bis-statistics", host: { properties: { "class": "this.stats" } }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StatisticsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-statistics',
                    template: `
    <ng-content></ng-content>
  `,
                    preserveWhitespaces: false,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], propDecorators: { stats: [{
                type: HostBinding,
                args: ['class']
            }] } });
class StatisticsContentComponent {
    constructor() {
        this.contentType = null;
        this.class = '';
    }
    ngOnChanges() {
        this.setClasses();
    }
    /**
     * Method that sets the classes on the host element.
     */
    setClasses() {
        this.classesString = '';
        switch (this.contentType) {
            case ContentType.TREND_UP:
                this.classesString = `stats__trend-up${this.class}`;
                break;
            case ContentType.TREN_DDOWN:
                this.classesString = `stats__trend-down${this.class}`;
                break;
            case ContentType.DATA:
                this.classesString = `stats__data${this.class}`;
                break;
            case ContentType.UNIT:
                this.classesString = `stats__unit${this.class}`;
                break;
            default:
                throw new Error('The contentType provided is not valid!');
        }
    }
}
StatisticsContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StatisticsContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StatisticsContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.3", type: StatisticsContentComponent, selector: "bis-statistics-content", inputs: { contentType: "contentType", class: "class" }, host: { properties: { "class": "this.classesString" } }, usesOnChanges: true, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: StatisticsContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bis-statistics-content',
                    template: `
    <ng-content></ng-content>
  `,
                    preserveWhitespaces: false,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], propDecorators: { classesString: [{
                type: HostBinding,
                args: ['class']
            }], contentType: [{
                type: Input
            }], class: [{
                type: Input
            }] } });
var ContentType;
(function (ContentType) {
    ContentType["TREND_UP"] = "trendUp";
    ContentType["TREN_DDOWN"] = "trendDown";
    ContentType["DATA"] = "data";
    ContentType["UNIT"] = "unit";
})(ContentType || (ContentType = {}));

class TypographyModule {
}
TypographyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypographyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TypographyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.3", ngImport: i0, type: TypographyModule, declarations: [StatisticsComponent,
        StatisticsContentComponent], exports: [StatisticsComponent,
        StatisticsContentComponent] });
TypographyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypographyModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.3", ngImport: i0, type: TypographyModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [
                        StatisticsComponent,
                        StatisticsContentComponent
                    ],
                    declarations: [
                        StatisticsComponent,
                        StatisticsContentComponent
                    ],
                    providers: [],
                }]
        }] });

/**
 * @module
 * @description
 * Entry point for all public APIs of Bisnode Angular Components library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ALERT_DATA, AlertComponent, AlertInjector, AlertModule, AlertPlaceholder, AlertRef, AlertService, AlertTextDirective, AlertTitleDirective, Backdrop, BackdropConfig, BackdropContainer, BackdropRef, BaseRowDef, BisShBodyCell, BisShBodyRowComponent, BisShHeaderCell, BisShHeaderRowComponent, BisShTableComponent, BisShTableModule, BisTableDataSource, BorderedCheckboxComponent, BreadcrumbNavigationComponent, BreadcrumbNavigationModule, BreadcrumbNavigationService, ButtonDirective, ButtonModule, CardButtonsContainerComponent, CardComponent, CardComponentBase, CardDirective, CardExpandableContentDirective, CardFooterComponent, CardGroupComponent, CardGroupWrapperComponent, CardHeaderComponent, CardLinkDirective, CardModule, CardSectionComponent, CarouselCloseDirective, CarouselComponent, CarouselConfig, CarouselDotComponent, CarouselDotPlaceholderComponent, CarouselJumpToDirective, CarouselModule, CarouselPlaceholderService, CarouselRef, CarouselService, CellBase, CellComponent, CellDefDirective, CellOutletDirective, CheckboxComponent, CollapsableComponent, ColumnComponent, ColumnDefDirective, ContainerComponent, ContentBelowBreakpointComponent, ContentType, DIALOG_DATA, DataHistoryCollection, DataSource, DataTableComponent, DataTableModule, DatePickerComponent, DatePickerModule, DescriptiveItemComponent, DialogButtonContainerComponent, DialogConfig, DialogContainerComponent, DialogFooterComponent, DialogHeaderComponent, DialogInjector, DialogModule, DialogRef, DialogSectionComponent, DialogService, DropContainerComponent, DropdownBodyComponent, DropdownComponent, DropdownLabelComponent, DropdownModule, DropdownSelectComponent, ExpandableButtonComponent, ExpandablePlaceholderDirective, ExpansionPanelCollapsedSuffixDirective, ExpansionPanelComponent, ExpansionPanelExpandedSuffixDirective, ExpansionPanelModule, ExpansionPanelPrefixDirective, ExpansionPanelTitleComponent, FileListComponent, FileUploadComponent, FileUploadFooterComponent, FileUploadModule, FileUploadOverlayComponent, FilterComponent, FilterModule, FilterWithCloseComponent, FormAddonComponent, FormBase, FormGroupComponent, FormModule, GridModule, HeaderCellComponent, HeaderCellDefDirective, HeaderRowComponent, HeaderRowDefDirective, HeaderRowPlaceholderDirective, IconComponent, IconFieldComponent, IconFieldModule, InfoBarDirective, InlineAlertComponent, InputDirective, LevelComponent, LevelGroupComponent, LevelItemComponent, LevelModule, ListComponent, ListItemComponent, ListItemKeyComponent, ListItemValueComponent, ListModule, MediaObjectComponent, MediaObjectImageComponent, MediaObjectModule, MediaObjectTitleComponent, MediaObjectToolbarComponent, ModalComponent, ModalModule, NavigationItemComponent, NavigationModule, NavigationService, NavigationbarContainerComponent, NavigationbarContentComponent, NoteComponent, NoteContentComponent, NoteListComponent, NoteListItemComponent, NoteModule, NoteTitleComponent, OptionDropdownSelectComponent, OverlayErrorComponent, OverlaySuccessComponent, OverlayUploadingComponent, PaginationComponent, PaginationModule, PaginationPlaceholderDirective, PaginationV2Component, PaginationV2Module, RadioComponent, RadioGroupDirective, RowComponent, RowDefDirective, RowPlaceholderDirective, ScaleComponent, ScaleModule, ScoreScaleComponent, ScoreScaleModule, SectionComponent, SectionModule, SetDisplayBlock, ShowMoreComponent, ShowMoreModule, SortDirective, SortHeaderComponent, SpinnerComponent, SpinnerModule, StatisticsComponent, StatisticsContentComponent, StepperComponent, StepperHeaderItemComponent, StepperModule, StepperNextDirective, StepperPreviousDirective, StepperStepComponent, SubTabsV2Component, SwitcherComponent, TabComponent, TabContentComponent, TabContentV2Directive, TabHeaderV2Component, TabLinkV2Directive, TabTitleComponent, TabV2Component, TableFooterComponent, TableRowComponent, TabsComponent, TabsContentDirective, TabsModule, TabsV2Component, TabsV2Module, TagComponent, TagModule, TooltipComponent, TooltipModule, TooltipTextComponent, TypeaheadComponent, TypeaheadDirective, TypeaheadModule, TypographyModule, getSortDuplicateSortableIdError, getSortHeaderMissingIdError, getSortHeaderNotContainedWithinSortError, getSortInvalidDirectionError, getTableDuplicateColumnNameError, getTableMissingMatchingRowDefError, getTableMissingRowDefsError, getTableMultipleDefaultRowDefsError, getTableUnknownColumnError, getTableUnknownDataSourceError, publicComponents, publicDirectives };
